import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID7hggqo3abtya as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  lazy2hsh8ze7j6ikd as lazy,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  indexOff2hgzjbxdcp4 as indexOf,
  KtList3hktaavzmj137 as KtList,
  roundToInt1ue8x8yshtznx as roundToInt,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  first28gmhyvs4kf06 as first,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  listOf1jh22dvmctj1r as listOf,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString14fd7g605f91p as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  until1jbpn0z3f8lbg as until,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  first58ocm7j58k3q as first_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  toIntArray27j90pvfixv10 as toIntArray,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  toLongw1zpgk99d84b as toLong,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  toIntArray2d4xwvtjb01mq as toIntArray_0,
  abs1kdzbjes1idip as abs,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instanceeeaudfwfrq87 as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3 as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89 as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance2kfoysd3on6as as Companion_getInstance_0,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_1,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default4sjbw0e0mkug as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  Winding_EVEN_ODD_getInstancemyc10vdu2m52 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_1,
  LineScaleMode_NORMAL_getInstance1wxue9rdh6hry as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  moveTo1v59p8psmu2yv as moveTo,
  lineTo35eirmrqxz1l0 as lineTo,
  line3u2mk0n2uhnlh as line,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3d17rumlj92i7 as Companion_getInstance_2,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_1,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_5,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_6,
  Companion_getInstance2yu48324co92b as Companion_getInstance_7,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_8,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd19ndx9mxcgcss as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423 as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstance26n3n49ggvwm4 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2mn8x7j48jyfs as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_9,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instancelqpzd9anuk16 as Companion_instance_2,
  Companion_instance3ldriv9x4zcjm as Companion_instance_3,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt2kqnbzr6sil9y as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t21dxxdiycat5m as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01c9hqlgdxaps5 as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_10,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu as UByteArrayInt__getOrElse_impl_f0pf72,
  _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance6aal8l6ipt6u as Companion_getInstance_11,
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  Companion_getInstance345a0ojzj45ct as Companion_getInstance_12,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf1rn8v9q6wbx2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1b2jkpzd6lmvg as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgreuo7vfsc7aqn as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s3bs6vkriyagvh as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhmx5zxcvkgp62x as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance3mocpl8hga9iq as Companion_getInstance_13,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  sliceHere162e6oimkowhf as sliceHere,
  readString3h14fm47a2tde as readString,
  readU162q6ft3yjssyvs as readU16,
  readS325wl7ebgpu38s as readS32,
  readBytesExact305h8zdeltghk as readBytesExact,
  sliceStart186j1d4dpd1wx as sliceStart,
  readStringzzxx8hll1ncys as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_0,
  readBytes3l26albs0coyl as readBytes,
  readAll1pkrq4jwoqns4 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream,
  readU82o15i0epsnmc5 as readU8,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_14,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance3mhfp4g0i6mgz as Companion_instance_4,
  decodeBytes3q5q9i2zh0cy6 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.p3x_1 = slice;
    this.q3x_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.p3x_1.toString() + ', data=' + toString(this.q3x_1) + ')';
  }
  hashCode() {
    var result = this.p3x_1.hashCode();
    result = imul(result, 31) + (this.q3x_1 == null ? 0 : hashCode(this.q3x_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.p3x_1.equals(tmp0_other_with_cast.p3x_1))
      return false;
    if (!equals(this.q3x_1, tmp0_other_with_cast.q3x_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static u3y(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.r3x_1 = binPacker;
    $this.s3x_1 = border;
    $this.t3x_1 = premultiplied;
    $this.u3x_1 = allowToGrow;
    $this.v3x_1 = growMethod;
    $this.w3x_1 = MarginInt.i2d($this.s3x_1);
    $this.x3x_1 = Bitmap32.s3y($this.d2m(), $this.e2m(), VOID, $this.t3x_1);
    $this.y3x_1 = arrayListOf([$this.x3x_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.z3x_1 = ArrayList.j1();
    $this.a3y_1 = LinkedHashMap.oc();
    $this.b3y_1 = null;
    return $this;
  }
  static v3y(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.u3y(Companion_instance_0.l3i(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  d2m() {
    return numberToInt(this.r3x_1.d2m());
  }
  e2m() {
    return numberToInt(this.r3x_1.e2m());
  }
  f1() {
    return this.z3x_1.f1();
  }
  w3y(bmp, data, name) {
    return this.t3y(slice(bmp, VOID, name), data, name);
  }
  x3y(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.f1() : name;
    return $super === VOID ? this.w3y(bmp, data, name) : $super.w3y.call(this, bmp, data, name);
  }
  t3y(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.w3y(extract_0(bmp).l3z(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.f1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.b3y_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.b3y_1).p3x_1;
        if (bigEmptySlice.a3k_1 >= bmp.a3k_1 && bigEmptySlice.b3k_1 >= bmp.b3k_1) {
          entry = new Entry(bigEmptySlice.k3l(RectangleInt.x2i(0, 0, bmp.a3k_1, bmp.b3k_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.r3x_1.v2v(bmp.a3k_1 + imul(this.s3x_1, 2), bmp.b3k_1 + imul(this.s3x_1, 2));
        var slice = sliceWithSize(this.x3x_1, numberToInt(rect.r2a() + this.s3x_1), numberToInt(rect.t2a() + this.s3x_1), bmp.a3k_1, bmp.b3k_1, rname);
        var dstX = slice.r2a();
        var dstY = slice.t2a();
        var boundsWithBorder = get_bounds_0(slice).y2i(this.w3x_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.x3x_1;
        if (true) {
          this_0.m3z();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.x3x_1.n3z(bmp, dstX, dstY);
          expandBorder(this.x3x_1, slice.s3j_1, this.s3x_1);
        }finally {
          result = true ? this_0.o3z(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.b3y_1 == null || bmp.l2j() > ensureNotNull(this.b3y_1).p3x_1.l2j()) {
          this.b3y_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.z3x_1;
      var element = entry;
      this_1.h(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.a3y_1;
      var value = entry;
      this_2.h3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.u3x_1)
          throw e;
        growAtlas(this, bmp);
        return this.t3y(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  p3z(bmp, data, name, $super) {
    name = name === VOID ? bmp.v3j_1 : name;
    return $super === VOID ? this.t3y(bmp, data, name) : $super.t3y.call(this, bmp, data, name);
  }
}
class Bitmap {
  static q3z(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.y3y_1 = new Mixin();
    $this.z3y_1 = width;
    $this.a3z_1 = height;
    $this.b3z_1 = bpp;
    $this.c3z_1 = backingArray;
    $this.d3z_1 = RectangleInt.x2i(0, 0, $this.z3y_1, $this.a3z_1);
    $this.e3z_1 = null;
    $this.f3z_1 = premultiplied;
    $this.g3z_1 = false;
    var tmp = $this;
    tmp.h3z_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.i3z_1 = 0;
    $this.j3z_1 = null;
    $this.k3z_1 = false;
    return $this;
  }
  yz(_set____db54di) {
    this.y3y_1.yz(_set____db54di);
  }
  zz() {
    return this.y3y_1.zz();
  }
  f1() {
    return SizeInt.n2k(this.z3y_1, this.a3z_1);
  }
  r3z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h3z_1;
    tempInts$factory();
    return this_0.s1();
  }
  s3z() {
    return _RgbaArray___init__impl__oib4y4(this.r3z());
  }
  t3z() {
    return imul(this.z3y_1, this.b3z_1) / 8 | 0;
  }
  l2j() {
    return imul(this.z3y_1, this.a3z_1);
  }
  u3z(x, y) {
    return imul(y, this.z3y_1) + x | 0;
  }
  v3z() {
    if (!(this.j3z_1 == null)) {
      this.j3z_1 = null;
    }
  }
  m3z() {
    return Unit_instance;
  }
  o3z(rect) {
    if (this.j3z_1 == null)
      this.j3z_1 = rect;
    else
      this.j3z_1 = Companion_instance_1.e2j(ensureNotNull(this.j3z_1), rect);
    this.i3z_1 = this.i3z_1 + 1 | 0;
    return this.i3z_1;
  }
  w3z(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.x3z(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  y3z(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.z3z(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  a40(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.y3z(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.y3z.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  b40(x, y, v) {
    if (this.f3z_1) {
      this.z3z(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.z3z(x, y, v);
    }
  }
  c40(x, y) {
    var tmp;
    if (this.f3z_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.x3z(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.x3z(x, y);
    }
    return tmp;
  }
  d40(x, y, color) {
    this.z3z(x, y, _RGBA___init__impl__lqpay5(color));
  }
  e40(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.x3z(x, y));
  }
  f40(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.z3y_1 || y0 >= this.a3z_1)
      return Colors_getInstance().l40_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.z3y_1 - 1 | 0);
    var y1Inside = y1 < (this.a3z_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.x3z(x0, y0);
    var c10 = x1Inside ? this.x3z(x1, y0) : c00;
    var c01 = y1Inside ? this.x3z(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.x3z(x1, y1) : c01;
    return Companion_getInstance_22().d46(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  e46(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.f46(srcX);
    var srcX1 = src.f46(srcX + width | 0);
    var srcY0 = src.g46(srcY);
    var srcY1 = src.g46(srcY + height | 0);
    var dstX0 = dst.f46(dstX);
    var dstX1 = dst.f46(dstX + width | 0);
    var dstY0 = dst.g46(dstY);
    var dstY1 = dst.g46(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.h46(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  h46(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w3z(srcX, srcY + y | 0, width, 1, this.r3z(), 0);
        dst.y3z(dstX, dstY + y | 0, width, 1, this.r3z(), 0);
      }
       while (inductionVariable < height);
  }
  i46(x) {
    return x >= 0 && x < this.z3y_1;
  }
  j46(y) {
    return y >= 0 && y < this.a3z_1;
  }
  k46(x, y) {
    return this.i46(x) && this.j46(y);
  }
  l46(x) {
    return clamp(x, 0, this.z3y_1 - 1 | 0);
  }
  m46(y) {
    return clamp(y, 0, this.a3z_1 - 1 | 0);
  }
  f46(x) {
    return clamp(x, 0, this.z3y_1);
  }
  g46(y) {
    return clamp(y, 0, this.a3z_1);
  }
  n46() {
    var inductionVariable = 0;
    var last = this.a3z_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o46(y, (this.a3z_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  p46() {
    var inductionVariable = 0;
    var last = this.z3y_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.q46(x, (this.z3y_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  r46(rotation) {
    var tmp;
    switch (rotation.r3_1) {
      case 0:
        tmp = this.uz();
        break;
      case 1:
        tmp = this.s46().p46();
        break;
      case 2:
        tmp = this.s46().p46().s46().p46();
        break;
      case 3:
        tmp = this.s46().n46();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  t46(orientation) {
    var out = this.uz();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.p46();
    }
    return out.r46(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  s46() {
    var temp = new IntArray2(this.z3y_1, this.a3z_1, readPixelsUnsafe(this, 0, 0, this.z3y_1, this.a3z_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.a3z_1;
    var height = this.z3y_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.a3z_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.z3y_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.j2m(y, x, temp.m2c(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.u46(this.a3z_1, this.z3y_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.a40(0, 0, this.a3z_1, this.z3y_1, out.c2m_1);
    return this_0;
  }
  o46(y0, y1) {
    var inductionVariable = 0;
    var last = this.z3y_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.e40(x, y0);
        var c1 = this.e40(x, y1);
        this.d40(x, y0, c1);
        this.d40(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  q46(x0, x1) {
    var inductionVariable = 0;
    var last = this.a3z_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.e40(x0, y);
        var c1 = this.e40(x1, y);
        this.d40(x0, y, c1);
        this.d40(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  v46(antialiasing) {
    throw UnsupportedOperationException.la('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  u46(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  l3z() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.s3y(this.z3y_1, this.a3z_1, VOID, this.f3z_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.w3z(0, 0, this.z3y_1, this.a3z_1, this_0.p3y_1, 0);
    return this_0;
  }
  w46() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.l3z();
    }
    return tmp;
  }
  uz() {
    var out = this.u46(this.z3y_1, this.a3z_1);
    this.h46(0, 0, out, 0, 0, this.z3y_1, this.a3z_1);
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_5 = this;
    this.g47_1 = Bitmap32.s3y(0, 0, VOID, true);
  }
  h47(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.s3y(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.p3y_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  i47(width, height, premultiplied) {
    return Bitmap32.s3y(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  j47(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.n47_1;
    var dstShift = dstChannel.n47_1;
    var dstClear = dstChannel.p47_1;
    var dstData = dst.p3y_1;
    var srcData = src.p3y_1;
    var inductionVariable = 0;
    var last = dst.l2j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  q47(src, dst, dstChannel) {
    var destShift = imul(dstChannel.m47_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.l2j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.l48()[n] & 255;
        dst.p3y_1[n] = dst.p3y_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  m48(src, srcChannel, dst) {
    var shift = srcChannel.n47_1;
    var inductionVariable = 0;
    var last = src.l2j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.l48()[n] = toByte((src.p3y_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.e47_1 = this$0;
  }
  n48($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
  }
  de(p1, $completion) {
    return this.n48(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static s3y(width, height, ints, premultiplied) {
    Companion_getInstance_15();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.q3z(width, height, 32, premultiplied, ints);
    $this.p3y_1 = ints;
    if ($this.p3y_1.length < imul(width, height))
      throw RuntimeException.wa('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.p3y_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.q3y_1 = new Int32Array(tmp$ret$0);
    $this.r3y_1 = RectangleInt.x2i(0, 0, width, height);
    return $this;
  }
  u46(width, height) {
    return Bitmap32.s3y(width, height, VOID, this.f3z_1);
  }
  h46(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.h46(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.p3y_1;
    var dstArray = dst.p3y_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.u3z(srcX, srcY + y | 0), dstArray, dst.u3z(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  o48(x, y, color) {
    this.b40(x, y, color);
  }
  p48(x, y) {
    return this.c40(x, y);
  }
  d40(x, y, color) {
    this.p3y_1[this.u3z(x, y)] = color;
  }
  e40(x, y) {
    return this.p3y_1[this.u3z(x, y)];
  }
  x3z(x, y) {
    return _RGBA___init__impl__lqpay5(this.e40(x, y));
  }
  z3z(x, y, v) {
    return this.d40(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  q48(n, color) {
    this.p3y_1[n] = this.f3z_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  r48(n, color) {
    var tmp;
    if (this.f3z_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.p3y_1[n] = tmp;
  }
  f47(n) {
    var tmp;
    if (this.f3z_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.p3y_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.p3y_1[n]);
    }
    return tmp;
  }
  s48(n) {
    return this.f3z_1 ? _RGBAPremultiplied___init__impl__uos02x(this.p3y_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.p3y_1[n]));
  }
  t48(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.u3z(dx, dy + y | 0);
        var srcOffset = src.u3z(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.r48(dstOffset + x | 0, mix(dst.s48(dstOffset + x | 0), src.s48(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.f3z_1 === src.f3z_1) {
            arraycopy(src.p3y_1, srcOffset, dst.p3y_1, dstOffset, width);
          } else if (!dst.f3z_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.q48(dstOffset + x_0 | 0, src.f47(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.r48(dstOffset + x_1 | 0, src.s48(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  u48(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.z3y_1 - dx_0 | 0;
    var availableHeight = this.a3z_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.t48(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  v48(mix, other, _dx, _dy) {
    this.u48(other, _dx, _dy, 0, 0, other.z3y_1, other.a3z_1, mix);
  }
  w48(color, x, y, width, height) {
    var x1 = this.l46(x);
    var x2 = this.l46((x + width | 0) - 1 | 0);
    var y1 = this.m46(y);
    var y2 = this.m46((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.f3z_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.p3y_1, colorInt, this.u3z(x1, cy), this.u3z(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  x48(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.z3y_1 - x | 0 : width;
    height = height === VOID ? this.a3z_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.w48(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.w48.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  y48(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.u48(get_bmp(src), dx, dy, b.r2a(), b.t2a(), b.s2a(), b.u2a(), mix);
  }
  z48(src, dx, dy) {
    return this.v48(false, src, dx, dy);
  }
  a49(src, dx, dy) {
    return this.v48(true, src, dx, dy);
  }
  n3z(src, dx, dy) {
    return this.y48(src, dx, dy, true);
  }
  b49(destination, input, source) {
    return Companion_getInstance_15().j47(input, source, this, destination);
  }
  c49(destination, input) {
    return Companion_getInstance_15().q47(input, this, destination);
  }
  d49(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_15().m48(this, channel, out);
    return out;
  }
  e49(channel, out, $super) {
    out = out === VOID ? Bitmap8.z49(this.z3y_1, this.a3z_1) : out;
    return $super === VOID ? this.d49(channel, out) : $super.d49.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.bc('Bitmap32(');
    this_0.ah(this.z3y_1);
    this_0.bc(', ');
    this_0.ah(this.a3z_1);
    if (!(this.e3z_1 == null)) {
      this_0.bc(', name=');
      this_0.bc(this.e3z_1);
    }
    this_0.bc(')');
    return this_0.toString();
  }
  o46(y0, y1) {
    var s0 = this.u3z(0, y0);
    var s1 = this.u3z(0, y1);
    arraycopy(this.p3y_1, s0, this.q3y_1, 0, this.z3y_1);
    arraycopy(this.p3y_1, s1, this.p3y_1, s0, this.z3y_1);
    arraycopy(this.q3y_1, 0, this.p3y_1, s1, this.z3y_1);
  }
  uz() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.p3y_1.slice();
    return Bitmap32.s3y(this.z3y_1, this.a3z_1, tmp$ret$1, this.f3z_1);
  }
  v46(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  a4a() {
    return this.f3z_1 ? this : this.copyPremultiplied();
  }
  b4a() {
    return !this.f3z_1 ? this : this.c4a();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.uz();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.d4a();
    return this_0;
  }
  c4a() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.uz();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.e4a();
    return this_0;
  }
  d4a() {
    if (this.f3z_1)
      return Unit_instance;
    this.f3z_1 = true;
    var inductionVariable = 0;
    var last = this.l2j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.p3y_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.p3y_1[n])));
      }
       while (inductionVariable < last);
  }
  e4a() {
    if (!this.f3z_1)
      return Unit_instance;
    this.f3z_1 = false;
    var inductionVariable = 0;
    var last = this.l2j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.p3y_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.p3y_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  b1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  f4a(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.p3y_1, this.u3z(x, y), width);
    } else {
      var m = this.u3z(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.p3y_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  l3z() {
    return this;
  }
}
class Companion_0 {
  g4a(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.e46(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static i4a(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_11.h4a(1 << bpp) : palette;
    var $this = this.q3z(width, height, bpp, false, bytes);
    $this.e48_1 = bytes;
    $this.f48_1 = palette;
    if ($this.e48_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.wa('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.l48().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.g48_1 = new Int8Array(tmp$ret$0);
    $this.h48_1 = _UByteArrayInt___init__impl__xif7bu($this.l48());
    $this.i48_1 = 8 / bpp | 0;
    $this.j48_1 = ilog2($this.i48_1);
    $this.k48_1 = $this.i48_1 - 1 | 0;
    return $this;
  }
  l48() {
    return this.e48_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.b3z_1 + ', width=' + this.z3y_1 + ', height=' + this.a3z_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.f48_1) + ')';
  }
  e40(x, y) {
    return this.k4a(this.u3z(x, y));
  }
  d40(x, y, color) {
    return this.j4a(this.u3z(x, y), color);
  }
  k4a(n) {
    var iD = this.m4a(n);
    var iM = this.n4a(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.h48_1, iD), imul(this.b3z_1, iM), this.b3z_1);
  }
  j4a(n, color) {
    var iD = this.m4a(n);
    var iM = this.n4a(n);
    UByteArrayInt__set_impl_gn4532(this.h48_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.h48_1, iD), color, imul(this.b3z_1, iM), this.b3z_1));
  }
  x3z(x, y) {
    var tmp = this.f48_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.e40(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  z3z(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  l4a(x, y) {
    return this.m4a(this.u3z(x, y));
  }
  m4a(n) {
    return n >>> this.j48_1 | 0;
  }
  n4a(n) {
    return n & this.k48_1;
  }
  o46(y0, y1) {
    var s0 = this.l4a(0, y0);
    var s1 = this.l4a(0, y1);
    arraycopy_0(this.l48(), s0, this.g48_1, 0, this.t3z());
    arraycopy_0(this.l48(), s1, this.l48(), s0, this.t3z());
    arraycopy_0(this.g48_1, 0, this.l48(), s1, this.t3z());
  }
  o4a(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.l48(), this.u3z(x, y), width / this.i48_1 | 0);
    } else {
      var m = this.u3z(x, y);
      var inductionVariable = 0;
      var last = width / this.i48_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.l48()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  l3z() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.s3y(this.z3y_1, this.a3z_1, VOID, this.f3z_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.p3y_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.f48_1);
    var inductionVariable = 0;
    var last = this.l2j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.k4a(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static z49(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_11.h4a(256) : palette;
    return this.i4a(8, width, height, data, palette);
  }
  u46(width, height) {
    return Bitmap8.z49(width, height, VOID, this.f48_1);
  }
  d40(x, y, color) {
    return this.j4a(this.u3z(x, y), color);
  }
  e40(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.h48_1, this.u3z(x, y));
  }
  x3z(x, y) {
    var tmp = this.f48_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.e40(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  k4a(n) {
    return UByteArrayInt__get_impl_px6q8a(this.h48_1, n);
  }
  j4a(n, color) {
    UByteArrayInt__set_impl_gn4532(this.h48_1, n, color);
  }
  h46(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.h46(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.l48();
        var tmp_0 = this.u3z(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).l48(), dst.u3z(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  uz() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.l48().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.f48_1).slice();
    return Bitmap8.z49(this.z3y_1, this.a3z_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.z3y_1 + ', ' + this.a3z_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.f48_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_7 = this;
    this.p4a_1 = values();
  }
  e1(index) {
    return this.p4a_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.m47_1 = index;
    this.n47_1 = imul(this.m47_1, 8);
    this.o47_1 = 255 << this.n47_1;
    this.p47_1 = ~this.o47_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.q4a_1 = 1.0;
    this.r4a_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.s4a_1 = width;
    this.t4a_1 = height;
    this.u4a_1 = d;
    this.v4a_1 = px;
    this.w4a_1 = py;
    this.x4a_1 = imul(this.s4a_1, this.t4a_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.u4a_1.length >= this.x4a_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.v4a_1.length >= this.x4a_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.w4a_1.length >= this.x4a_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message_1));
    }
  }
  i46(x) {
    return x >= 0 && x < this.s4a_1;
  }
  j46(y) {
    return y >= 0 && y < this.t4a_1;
  }
  k46(x, y) {
    return this.i46(x) && this.j46(y);
  }
  u3z(x, y) {
    return imul(y, this.s4a_1) + x | 0;
  }
  c4b(x, y) {
    return this.k46(x, y) ? this.u4a_1[this.u3z(x, y)] : Infinity;
  }
  z4a(x, y) {
    return this.k46(x, y) ? this.v4a_1[this.u3z(x, y)] : -1;
  }
  a4b(x, y) {
    return this.k46(x, y) ? this.w4a_1[this.u3z(x, y)] : -1;
  }
  b4b(x, y, d) {
    if (!this.k46(x, y))
      return Unit_instance;
    this.u4a_1[this.u3z(x, y)] = d;
  }
  d4b(x, y, px, py) {
    if (!this.k46(x, y))
      return Unit_instance;
    var index = this.u3z(x, y);
    this.v4a_1[index] = px;
    this.w4a_1[index] = py;
  }
  y4a(x, y, px, py) {
    return this.d4b(x, y, this.z4a(px, py), this.a4b(px, py));
  }
  e4b(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.s4a_1 === bmp.z3y_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.t4a_1 === bmp.a3z_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.t4a_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.s4a_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.b4b(x, y, Infinity);
            this.d4b(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.t4a_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.s4a_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.b4b(x_0, y_0, 0.0);
              this.d4b(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.t4a_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.s4a_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.t4a_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.s4a_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.t4a_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.s4a_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.b4b(x_3, y_3, -this.c4b(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static t4b(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.q3z(width, height, 32, premultiplied, data);
    $this.s4b_1 = data;
    return $this;
  }
  z3z(x, y, v) {
    var rindex = index4(this, x, y);
    this.s4b_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.s4b_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.s4b_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.s4b_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  x3z(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_22().u4b(this.s4b_1[rindex + 0 | 0], this.s4b_1[rindex + 1 | 0], this.s4b_1[rindex + 2 | 0], this.s4b_1[rindex + 3 | 0]);
  }
  v4b(x, y) {
    return this.s4b_1[index4(this, x, y) + 0 | 0];
  }
  w4b(x, y) {
    return this.s4b_1[index4(this, x, y) + 1 | 0];
  }
  x4b(x, y) {
    return this.s4b_1[index4(this, x, y) + 2 | 0];
  }
  y4b(x, y) {
    return this.s4b_1[index4(this, x, y) + 3 | 0];
  }
  z4b(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.s4b_1[rindex + 0 | 0] = r;
    this.s4b_1[rindex + 1 | 0] = g;
    this.s4b_1[rindex + 2 | 0] = b;
    this.s4b_1[rindex + 3 | 0] = a;
  }
  a4c(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.s4b_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.s4b_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.s4b_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.s4b_1[rindex + 3 | 0]);
    return out;
  }
  b4c(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.z3y_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.a3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.u3z(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.a4c(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  c4c(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.b4c(out) : $super.b4c.call(this, out);
  }
  d4c(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.z3y_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.a3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.u3z(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.a4c(x, y, out);
            this.z4b(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  e4c(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.d4c(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.d4c.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  f4c() {
    var _destruct__k2r9zo = this.c4c();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.e4c(-range, +range);
  }
  g4c(scale) {
    return this.h4c(scale, scale, scale, scale);
  }
  h4c(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.z3y_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.a3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.u3z(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.z4b(x, y, this.v4b(x, y) * scaleRed, this.w4b(x, y) * scaleGreen, this.x4b(x, y) * scaleBlue, this.y4b(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  i4c(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.z3y_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.a3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.u3z(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.v4b(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.w4b(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.x4b(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.y4b(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.z4b(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static x4c(width, height, data, premultiplied) {
    var $this = this.q3z(width, height, 32, premultiplied, null);
    $this.w4c_1 = data;
    return $this;
  }
  l3z() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_15().i47(this.z3y_1, this.a3z_1, this.f3z_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.w3z(0, 0, this.z3y_1, this.a3z_1, this_0.p3y_1, 0);
    return this_0;
  }
  z3z(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.s3z(), 0, v);
    this.y3z(x, y, 1, 1, this.r3z(), 0);
  }
  x3z(x, y) {
    this.w3z(x, y, 1, 1, this.r3z(), 0);
    return RgbaArray__get_impl_nzyo1o(this.s3z(), 0);
  }
  d40(x, y, color) {
    return this.z3z(x, y, _RGBA___init__impl__lqpay5(color));
  }
  e40(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.x3z(x, y));
  }
  n46() {
    var tmp = this.l3z().n46();
    this.a40(0, 0, this.z3y_1, this.a3z_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).p3y_1);
    return this;
  }
  p46() {
    var tmp = this.l3z().p46();
    this.a40(0, 0, this.z3y_1, this.a3z_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).p3y_1);
    return this;
  }
  o46(y0, y1) {
    this.w3z(0, y0, this.z3y_1, 1, this.r3z(), 0);
    this.w3z(0, y1, this.z3y_1, 1, this.r3z(), this.z3y_1);
    this.y3z(0, y1, this.z3y_1, 1, this.r3z(), 0);
    this.y3z(0, y0, this.z3y_1, 1, this.r3z(), this.z3y_1);
  }
  q46(x0, x1) {
    this.w3z(x0, 0, 1, this.a3z_1, this.r3z(), 0);
    this.w3z(x1, 0, 1, this.a3z_1, this.r3z(), this.z3y_1);
    this.y3z(x1, 0, 1, this.a3z_1, this.r3z(), 0);
    this.y3z(x0, 0, 1, this.a3z_1, this.r3z(), this.z3y_1);
  }
  u46(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.s3() + '(' + this.z3y_1 + ', ' + this.a3z_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  static c4e(width, height, premultiplied) {
    Companion_getInstance_19();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.q3z(width, height, 32, premultiplied, null);
  }
  z3z(x, y, v) {
    return Unit_instance;
  }
  x3z(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_3 extends NullBitmap {
  static o4d() {
    Companion_instance_9 = null;
    var $this = this.c4e(1, 1);
    Companion_instance_9 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.d4e_1 = colors;
    this.e4e_1 = names;
    this.f4e_1 = changeStart;
    this.g4e_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.bc('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.d4e_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.d4e_1, n);
        var tmp22_safe_receiver = this.e4e_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.bc(', ');
        }
        if (!(name == null)) {
          this_0.bc(name);
          this_0.bc(': ');
        }
        this_0.bc(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.bc(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.r4e_1 = bmp;
    this.s4e_1 = buffer;
    this.t4e_1 = radius;
    this.u4e_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.r4e_1.toString() + ', buffer=' + this.s4e_1 + ', radius=' + this.t4e_1 + ', cutoff=' + this.u4e_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.r4e_1);
    result = imul(result, 31) + this.s4e_1 | 0;
    result = imul(result, 31) + this.t4e_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.u4e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.r4e_1, tmp0_other_with_cast.r4e_1))
      return false;
    if (!(this.s4e_1 === tmp0_other_with_cast.s4e_1))
      return false;
    if (!(this.t4e_1 === tmp0_other_with_cast.t4e_1))
      return false;
    if (!equals(this.u4e_1, tmp0_other_with_cast.u4e_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.v4e_1 = 1.0E10;
  }
  w4e(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.s3y(bmp.z3y_1 + imul(buffer, 2) | 0, bmp.a3z_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.z3y_1;
    var height = out.a3z_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.z3y_1;
    var height_0 = out.a3z_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.a3z_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.z3y_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.p48(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.q2m(x0, y0, 1.0E10);
                gridInner.q2m(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.q2m(x0, y0, 0.0);
                gridInner.q2m(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.q2m(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.q2m(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.x4e(gridOuter.o2m_1, 0, 0, out.z3y_1, out.a3z_1, gridOuter.d2m(), f, v, z);
    this.x4e(gridInner.o2m_1, buffer, buffer, bmp.z3y_1, bmp.a3z_1, gridInner.d2m(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.a3z_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.z3y_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.m2c(x_0, y_0);
            var gin = gridInner.m2c(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.o48(x_0, y_0, Companion_getInstance_22().q4e(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  y4e(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.z3y_1;
      var b = bmp.a3z_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.w4e(bmp, maxSide, buffer, radius, cutoff) : $super.w4e.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  x4e(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.z4e(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.z4e(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  z4e(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.f4f_1 = 32;
  }
  a4f() {
    return this.f4f_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.g4f_1 = 24;
  }
  a4f() {
    return this.g4f_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.h4f_1 = _r;
    this.i4f_1 = _g;
    this.j4f_1 = _b;
    this.k4f_1 = _a;
    this.l4f_1 = true;
    this.m4f_1 = Colors_getInstance().g40_1;
  }
  n4f() {
    return this.h4f_1;
  }
  o4f() {
    return this.i4f_1;
  }
  p4f() {
    return this.j4f_1;
  }
  q4f(value) {
    this.k4f_1 = value;
    this.l4f_1 = true;
  }
  r4f() {
    return this.k4f_1;
  }
  s4f(v) {
    this.t4f(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.m4f_1 = v;
    this.l4f_1 = false;
  }
  u4f() {
    if (this.l4f_1) {
      this.l4f_1 = false;
      this.m4f_1 = Companion_getInstance_22().u4b(this.h4f_1, this.i4f_1, this.j4f_1, this.k4f_1);
    }
    return this.m4f_1;
  }
  t4f(r, g, b, a) {
    this.h4f_1 = r;
    this.i4f_1 = g;
    this.j4f_1 = b;
    this.k4f_1 = a;
    this.l4f_1 = true;
  }
  v4f(other) {
    return this.t4f(other.h4f_1, other.i4f_1, other.j4f_1, other.k4f_1);
  }
  w4f(a, b) {
    return this.t4f(a.n4f() * b.n4f(), a.o4f() * b.o4f(), a.p4f() * b.p4f(), a.r4f() * b.r4f());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.h4f_1 + ', _g=' + this.i4f_1 + ', _b=' + this.j4f_1 + ', _a=' + this.k4f_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h4f_1);
    result = imul(result, 31) + getNumberHashCode(this.i4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k4f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.h4f_1, tmp0_other_with_cast.h4f_1))
      return false;
    if (!equals(this.i4f_1, tmp0_other_with_cast.i4f_1))
      return false;
    if (!equals(this.j4f_1, tmp0_other_with_cast.j4f_1))
      return false;
    if (!equals(this.k4f_1, tmp0_other_with_cast.k4f_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.g40_1 = Companion_getInstance_22().q4e(255, 255, 255, 255);
    this.h40_1 = Companion_getInstance_22().q4e(0, 0, 0, 255);
    this.i40_1 = Companion_getInstance_22().q4e(255, 0, 0, 255);
    this.j40_1 = Companion_getInstance_22().q4e(0, 255, 0, 255);
    this.k40_1 = Companion_getInstance_22().q4e(0, 0, 255, 255);
    this.l40_1 = Companion_getInstance_22().q4e(0, 0, 0, 0);
    this.m40_1 = Companion_getInstance_22().q4e(255, 255, 255, 0);
    this.n40_1 = Companion_getInstance_22().x4f(240, 248, 255);
    this.o40_1 = Companion_getInstance_22().x4f(250, 235, 215);
    this.p40_1 = Companion_getInstance_22().x4f(0, 255, 255);
    this.q40_1 = Companion_getInstance_22().x4f(127, 255, 212);
    this.r40_1 = Companion_getInstance_22().x4f(240, 255, 255);
    this.s40_1 = Companion_getInstance_22().x4f(245, 245, 220);
    this.t40_1 = Companion_getInstance_22().x4f(255, 228, 196);
    this.u40_1 = Companion_getInstance_22().x4f(255, 235, 205);
    this.v40_1 = Companion_getInstance_22().x4f(138, 43, 226);
    this.w40_1 = Companion_getInstance_22().x4f(165, 42, 42);
    this.x40_1 = Companion_getInstance_22().x4f(222, 184, 135);
    this.y40_1 = Companion_getInstance_22().x4f(95, 158, 160);
    this.z40_1 = Companion_getInstance_22().x4f(127, 255, 0);
    this.a41_1 = Companion_getInstance_22().x4f(210, 105, 30);
    this.b41_1 = Companion_getInstance_22().x4f(255, 127, 80);
    this.c41_1 = Companion_getInstance_22().x4f(100, 149, 237);
    this.d41_1 = Companion_getInstance_22().x4f(255, 248, 220);
    this.e41_1 = Companion_getInstance_22().x4f(220, 20, 60);
    this.f41_1 = Companion_getInstance_22().x4f(0, 0, 139);
    this.g41_1 = Companion_getInstance_22().x4f(0, 255, 255);
    this.h41_1 = Companion_getInstance_22().x4f(0, 139, 139);
    this.i41_1 = Companion_getInstance_22().x4f(184, 134, 11);
    this.j41_1 = Companion_getInstance_22().x4f(169, 169, 169);
    this.k41_1 = Companion_getInstance_22().x4f(0, 100, 0);
    this.l41_1 = Companion_getInstance_22().x4f(169, 169, 169);
    this.m41_1 = Companion_getInstance_22().x4f(189, 183, 107);
    this.n41_1 = Companion_getInstance_22().x4f(255, 0, 255);
    this.o41_1 = Companion_getInstance_22().x4f(139, 0, 139);
    this.p41_1 = Companion_getInstance_22().x4f(85, 107, 47);
    this.q41_1 = Companion_getInstance_22().x4f(255, 140, 0);
    this.r41_1 = Companion_getInstance_22().x4f(153, 50, 204);
    this.s41_1 = Companion_getInstance_22().x4f(139, 0, 0);
    this.t41_1 = Companion_getInstance_22().x4f(233, 150, 122);
    this.u41_1 = Companion_getInstance_22().x4f(143, 188, 143);
    this.v41_1 = Companion_getInstance_22().x4f(72, 61, 139);
    this.w41_1 = Companion_getInstance_22().x4f(47, 79, 79);
    this.x41_1 = Companion_getInstance_22().x4f(47, 79, 79);
    this.y41_1 = Companion_getInstance_22().x4f(0, 206, 209);
    this.z41_1 = Companion_getInstance_22().x4f(148, 0, 211);
    this.a42_1 = Companion_getInstance_22().x4f(255, 20, 147);
    this.b42_1 = Companion_getInstance_22().x4f(0, 191, 255);
    this.c42_1 = Companion_getInstance_22().x4f(105, 105, 105);
    this.d42_1 = Companion_getInstance_22().x4f(105, 105, 105);
    this.e42_1 = Companion_getInstance_22().x4f(30, 144, 255);
    this.f42_1 = Companion_getInstance_22().x4f(178, 34, 34);
    this.g42_1 = Companion_getInstance_22().x4f(255, 250, 240);
    this.h42_1 = Companion_getInstance_22().x4f(34, 139, 34);
    this.i42_1 = Companion_getInstance_22().x4f(255, 0, 255);
    this.j42_1 = Companion_getInstance_22().x4f(220, 220, 220);
    this.k42_1 = Companion_getInstance_22().x4f(248, 248, 255);
    this.l42_1 = Companion_getInstance_22().x4f(255, 215, 0);
    this.m42_1 = Companion_getInstance_22().x4f(218, 165, 32);
    this.n42_1 = Companion_getInstance_22().x4f(173, 255, 47);
    this.o42_1 = Companion_getInstance_22().x4f(240, 255, 240);
    this.p42_1 = Companion_getInstance_22().x4f(255, 105, 180);
    this.q42_1 = Companion_getInstance_22().x4f(205, 92, 92);
    this.r42_1 = Companion_getInstance_22().x4f(75, 0, 130);
    this.s42_1 = Companion_getInstance_22().x4f(255, 255, 240);
    this.t42_1 = Companion_getInstance_22().x4f(240, 230, 140);
    this.u42_1 = Companion_getInstance_22().x4f(230, 230, 250);
    this.v42_1 = Companion_getInstance_22().x4f(255, 240, 245);
    this.w42_1 = Companion_getInstance_22().x4f(124, 252, 0);
    this.x42_1 = Companion_getInstance_22().x4f(255, 250, 205);
    this.y42_1 = Companion_getInstance_22().x4f(173, 216, 230);
    this.z42_1 = Companion_getInstance_22().x4f(240, 128, 128);
    this.a43_1 = Companion_getInstance_22().x4f(224, 255, 255);
    this.b43_1 = Companion_getInstance_22().x4f(250, 250, 210);
    this.c43_1 = Companion_getInstance_22().x4f(211, 211, 211);
    this.d43_1 = Companion_getInstance_22().x4f(144, 238, 144);
    this.e43_1 = Companion_getInstance_22().x4f(211, 211, 211);
    this.f43_1 = Companion_getInstance_22().x4f(255, 182, 193);
    this.g43_1 = Companion_getInstance_22().x4f(255, 160, 122);
    this.h43_1 = Companion_getInstance_22().x4f(32, 178, 170);
    this.i43_1 = Companion_getInstance_22().x4f(135, 206, 250);
    this.j43_1 = Companion_getInstance_22().x4f(119, 136, 153);
    this.k43_1 = Companion_getInstance_22().x4f(119, 136, 153);
    this.l43_1 = Companion_getInstance_22().x4f(176, 196, 222);
    this.m43_1 = Companion_getInstance_22().x4f(255, 255, 224);
    this.n43_1 = Companion_getInstance_22().x4f(0, 255, 0);
    this.o43_1 = Companion_getInstance_22().x4f(50, 205, 50);
    this.p43_1 = Companion_getInstance_22().x4f(250, 240, 230);
    this.q43_1 = Companion_getInstance_22().x4f(128, 0, 0);
    this.r43_1 = Companion_getInstance_22().x4f(102, 205, 170);
    this.s43_1 = Companion_getInstance_22().x4f(0, 0, 205);
    this.t43_1 = Companion_getInstance_22().x4f(186, 85, 211);
    this.u43_1 = Companion_getInstance_22().x4f(147, 112, 219);
    this.v43_1 = Companion_getInstance_22().x4f(60, 179, 113);
    this.w43_1 = Companion_getInstance_22().x4f(123, 104, 238);
    this.x43_1 = Companion_getInstance_22().x4f(0, 250, 154);
    this.y43_1 = Companion_getInstance_22().x4f(72, 209, 204);
    this.z43_1 = Companion_getInstance_22().x4f(199, 21, 133);
    this.a44_1 = Companion_getInstance_22().x4f(25, 25, 112);
    this.b44_1 = Companion_getInstance_22().x4f(245, 255, 250);
    this.c44_1 = Companion_getInstance_22().x4f(255, 228, 225);
    this.d44_1 = Companion_getInstance_22().x4f(255, 228, 181);
    this.e44_1 = Companion_getInstance_22().x4f(255, 222, 173);
    this.f44_1 = Companion_getInstance_22().x4f(0, 0, 128);
    this.g44_1 = Companion_getInstance_22().x4f(253, 245, 230);
    this.h44_1 = Companion_getInstance_22().x4f(128, 128, 0);
    this.i44_1 = Companion_getInstance_22().x4f(107, 142, 35);
    this.j44_1 = Companion_getInstance_22().x4f(255, 165, 0);
    this.k44_1 = Companion_getInstance_22().x4f(255, 69, 0);
    this.l44_1 = Companion_getInstance_22().x4f(218, 112, 214);
    this.m44_1 = Companion_getInstance_22().x4f(238, 232, 170);
    this.n44_1 = Companion_getInstance_22().x4f(152, 251, 152);
    this.o44_1 = Companion_getInstance_22().x4f(175, 238, 238);
    this.p44_1 = Companion_getInstance_22().x4f(219, 112, 147);
    this.q44_1 = Companion_getInstance_22().x4f(255, 239, 213);
    this.r44_1 = Companion_getInstance_22().x4f(255, 218, 185);
    this.s44_1 = Companion_getInstance_22().x4f(205, 133, 63);
    this.t44_1 = Companion_getInstance_22().x4f(255, 192, 203);
    this.u44_1 = Companion_getInstance_22().x4f(221, 160, 221);
    this.v44_1 = Companion_getInstance_22().x4f(176, 224, 230);
    this.w44_1 = Companion_getInstance_22().x4f(128, 0, 128);
    this.x44_1 = Companion_getInstance_22().x4f(188, 143, 143);
    this.y44_1 = Companion_getInstance_22().x4f(65, 105, 225);
    this.z44_1 = Companion_getInstance_22().x4f(139, 69, 19);
    this.a45_1 = Companion_getInstance_22().x4f(250, 128, 114);
    this.b45_1 = Companion_getInstance_22().x4f(244, 164, 96);
    this.c45_1 = Companion_getInstance_22().x4f(46, 139, 87);
    this.d45_1 = Companion_getInstance_22().x4f(255, 245, 238);
    this.e45_1 = Companion_getInstance_22().x4f(160, 82, 45);
    this.f45_1 = Companion_getInstance_22().x4f(192, 192, 192);
    this.g45_1 = Companion_getInstance_22().x4f(135, 206, 235);
    this.h45_1 = Companion_getInstance_22().x4f(106, 90, 205);
    this.i45_1 = Companion_getInstance_22().x4f(112, 128, 144);
    this.j45_1 = Companion_getInstance_22().x4f(112, 128, 144);
    this.k45_1 = Companion_getInstance_22().x4f(255, 250, 250);
    this.l45_1 = Companion_getInstance_22().x4f(0, 255, 127);
    this.m45_1 = Companion_getInstance_22().x4f(70, 130, 180);
    this.n45_1 = Companion_getInstance_22().x4f(210, 180, 140);
    this.o45_1 = Companion_getInstance_22().x4f(0, 128, 128);
    this.p45_1 = Companion_getInstance_22().x4f(216, 191, 216);
    this.q45_1 = Companion_getInstance_22().x4f(255, 99, 71);
    this.r45_1 = Companion_getInstance_22().x4f(64, 224, 208);
    this.s45_1 = Companion_getInstance_22().x4f(238, 130, 238);
    this.t45_1 = Companion_getInstance_22().x4f(245, 222, 179);
    this.u45_1 = Companion_getInstance_22().x4f(245, 245, 245);
    this.v45_1 = Companion_getInstance_22().x4f(154, 205, 50);
    this.w45_1 = Companion_getInstance_22().x4f(255, 255, 0);
    this.x45_1 = mapOf([to('black', new RGBA(this.h40_1)), to('white', new RGBA(this.g40_1)), to('red', new RGBA(this.i40_1)), to('green', new RGBA(this.j40_1)), to('blue', new RGBA(this.k40_1)), to('aliceblue', new RGBA(this.n40_1)), to('antiquewhite', new RGBA(this.o40_1)), to('aqua', new RGBA(this.p40_1)), to('aquamarine', new RGBA(this.q40_1)), to('azure', new RGBA(this.r40_1)), to('beige', new RGBA(this.s40_1)), to('bisque', new RGBA(this.t40_1)), to('blanchedalmond', new RGBA(this.u40_1)), to('blueviolet', new RGBA(this.v40_1)), to('brown', new RGBA(this.w40_1)), to('burlywood', new RGBA(this.x40_1)), to('cadetblue', new RGBA(this.y40_1)), to('chartreuse', new RGBA(this.z40_1)), to('chocolate', new RGBA(this.a41_1)), to('coral', new RGBA(this.b41_1)), to('cornflowerblue', new RGBA(this.c41_1)), to('cornsilk', new RGBA(this.d41_1)), to('crimson', new RGBA(this.e41_1)), to('cyan', new RGBA(this.g41_1)), to('darkblue', new RGBA(this.f41_1)), to('darkcyan', new RGBA(this.h41_1)), to('darkgoldenrod', new RGBA(this.i41_1)), to('darkgray', new RGBA(this.j41_1)), to('darkgreen', new RGBA(this.k41_1)), to('darkgrey', new RGBA(this.l41_1)), to('darkkhaki', new RGBA(this.m41_1)), to('darkmagenta', new RGBA(this.o41_1)), to('darkolivegreen', new RGBA(this.p41_1)), to('darkorange', new RGBA(this.q41_1)), to('darkorchid', new RGBA(this.r41_1)), to('darkred', new RGBA(this.s41_1)), to('darksalmon', new RGBA(this.t41_1)), to('darkseagreen', new RGBA(this.u41_1)), to('darkslateblue', new RGBA(this.v41_1)), to('darkslategray', new RGBA(this.w41_1)), to('darkslategrey', new RGBA(this.x41_1)), to('darkturquoise', new RGBA(this.y41_1)), to('darkviolet', new RGBA(this.z41_1)), to('deeppink', new RGBA(this.a42_1)), to('deepskyblue', new RGBA(this.b42_1)), to('dimgray', new RGBA(this.c42_1)), to('dimgrey', new RGBA(this.d42_1)), to('dodgerblue', new RGBA(this.e42_1)), to('firebrick', new RGBA(this.f42_1)), to('floralwhite', new RGBA(this.g42_1)), to('forestgreen', new RGBA(this.h42_1)), to('fuchsia', new RGBA(this.i42_1)), to('gainsboro', new RGBA(this.j42_1)), to('ghostwhite', new RGBA(this.k42_1)), to('gold', new RGBA(this.l42_1)), to('goldenrod', new RGBA(this.m42_1)), to('greenyellow', new RGBA(this.n42_1)), to('honeydew', new RGBA(this.o42_1)), to('hotpink', new RGBA(this.p42_1)), to('indianred', new RGBA(this.q42_1)), to('indigo', new RGBA(this.r42_1)), to('ivory', new RGBA(this.s42_1)), to('khaki', new RGBA(this.t42_1)), to('lavender', new RGBA(this.u42_1)), to('lavenderblush', new RGBA(this.v42_1)), to('lawngreen', new RGBA(this.w42_1)), to('lemonchiffon', new RGBA(this.x42_1)), to('lightblue', new RGBA(this.y42_1)), to('lightcoral', new RGBA(this.z42_1)), to('lightcyan', new RGBA(this.a43_1)), to('lightgoldenrodyellow', new RGBA(this.b43_1)), to('lightgray', new RGBA(this.c43_1)), to('lightgreen', new RGBA(this.d43_1)), to('lightgrey', new RGBA(this.e43_1)), to('lightpink', new RGBA(this.f43_1)), to('lightsalmon', new RGBA(this.g43_1)), to('lightseagreen', new RGBA(this.h43_1)), to('lightskyblue', new RGBA(this.i43_1)), to('lightslategray', new RGBA(this.j43_1)), to('lightslategrey', new RGBA(this.k43_1)), to('lightsteelblue', new RGBA(this.l43_1)), to('lightyellow', new RGBA(this.m43_1)), to('lime', new RGBA(this.n43_1)), to('limegreen', new RGBA(this.o43_1)), to('linen', new RGBA(this.p43_1)), to('magenta', new RGBA(this.n41_1)), to('maroon', new RGBA(this.q43_1)), to('mediumaquamarine', new RGBA(this.r43_1)), to('mediumblue', new RGBA(this.s43_1)), to('mediumorchid', new RGBA(this.t43_1)), to('mediumpurple', new RGBA(this.u43_1)), to('mediumseagreen', new RGBA(this.v43_1)), to('mediumslateblue', new RGBA(this.w43_1)), to('mediumspringgreen', new RGBA(this.x43_1)), to('mediumturquoise', new RGBA(this.y43_1)), to('mediumvioletred', new RGBA(this.z43_1)), to('midnightblue', new RGBA(this.a44_1)), to('mintcream', new RGBA(this.b44_1)), to('mistyrose', new RGBA(this.c44_1)), to('moccasin', new RGBA(this.d44_1)), to('navajowhite', new RGBA(this.e44_1)), to('navy', new RGBA(this.f44_1)), to('oldlace', new RGBA(this.g44_1)), to('olive', new RGBA(this.h44_1)), to('olivedrab', new RGBA(this.i44_1)), to('orange', new RGBA(this.j44_1)), to('orangered', new RGBA(this.k44_1)), to('orchid', new RGBA(this.l44_1)), to('palegoldenrod', new RGBA(this.m44_1)), to('palegreen', new RGBA(this.n44_1)), to('paleturquoise', new RGBA(this.o44_1)), to('palevioletred', new RGBA(this.p44_1)), to('papayawhip', new RGBA(this.q44_1)), to('peachpuff', new RGBA(this.r44_1)), to('peru', new RGBA(this.s44_1)), to('pink', new RGBA(this.t44_1)), to('plum', new RGBA(this.u44_1)), to('powderblue', new RGBA(this.v44_1)), to('purple', new RGBA(this.w44_1)), to('rosybrown', new RGBA(this.x44_1)), to('royalblue', new RGBA(this.y44_1)), to('saddlebrown', new RGBA(this.z44_1)), to('salmon', new RGBA(this.a45_1)), to('sandybrown', new RGBA(this.b45_1)), to('seagreen', new RGBA(this.c45_1)), to('seashell', new RGBA(this.d45_1)), to('sienna', new RGBA(this.e45_1)), to('silver', new RGBA(this.f45_1)), to('skyblue', new RGBA(this.g45_1)), to('slateblue', new RGBA(this.h45_1)), to('slategray', new RGBA(this.i45_1)), to('slategrey', new RGBA(this.j45_1)), to('snow', new RGBA(this.k45_1)), to('springgreen', new RGBA(this.l45_1)), to('steelblue', new RGBA(this.m45_1)), to('tan', new RGBA(this.n45_1)), to('teal', new RGBA(this.o45_1)), to('thistle', new RGBA(this.p45_1)), to('tomato', new RGBA(this.q45_1)), to('turquoise', new RGBA(this.r45_1)), to('violet', new RGBA(this.s45_1)), to('wheat', new RGBA(this.t45_1)), to('whitesmoke', new RGBA(this.u45_1)), to('yellowgreen', new RGBA(this.v45_1)), to('yellow', new RGBA(this.w45_1))]);
  }
  y4f(str) {
    return this.z4f(str, this.l40_1, true);
  }
  z4f(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).x2(hex.length))
          return this.h40_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_22().q4e(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.f1() : false) {
          tmp = parts.e1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.f1() : false) {
          tmp_0 = parts.e1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.f1() : false) {
          tmp_1 = parts.e1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.f1() : false) {
          tmp_2 = parts.e1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_22().q4e(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.x45_1.f3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.a4g_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.b4g('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().i40_1;
      } else {
        throw $p;
      }
    }
  }
  b4g(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.z4f(str, default_0, errorOnDefault) : $super.z4f.call(this, str, new RGBA(default_0), errorOnDefault).a4g_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_20();
    super();
    this.d4g_1 = rOffset;
    this.e4g_1 = gOffset;
    this.f4g_1 = bOffset;
  }
  b4f(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.d4g_1 | 0) & 255;
  }
  c4f(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.e4g_1 | 0) & 255;
  }
  d4f(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.f4g_1 | 0) & 255;
  }
  e4f(v) {
    return 255;
  }
}
class Companion_4 extends RGB {
  constructor() {
    Companion_instance_10 = null;
    super(0, 8, 16);
    Companion_instance_10 = this;
  }
}
class Companion_5 {
  h4a(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.g4g_1 = ints;
  }
  c3(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.g4g_1, fromIndex, toIndex);
  }
  h4g(element) {
    return RgbaArray__contains_impl_ofn00n(this.g4g_1, element);
  }
  x2(element) {
    return RgbaArray__contains_impl_ofn00n_0(this, element);
  }
  i4g(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.g4g_1, elements);
  }
  y2(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  j4g(element) {
    return RgbaArray__indexOf_impl_d6b5pl(this.g4g_1, element);
  }
  z2(element) {
    return RgbaArray__indexOf_impl_d6b5pl_0(this, element);
  }
  h1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.g4g_1);
  }
  b1() {
    return RgbaArray__iterator_impl_5wfwsm(this.g4g_1);
  }
  a3() {
    return RgbaArray__listIterator_impl_m4kjt0(this.g4g_1);
  }
  b3(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.g4g_1, index);
  }
  f1() {
    return _RgbaArray___get_size__impl__imxef8(this.g4g_1);
  }
  k4g(index) {
    return RgbaArray__get_impl_nzyo1o(this.g4g_1, index);
  }
  e1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.g4g_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.g4g_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.g4g_1, other);
  }
}
class Companion_6 extends ColorFormat32 {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
    this.z45_1 = 0;
    this.a46_1 = 8;
    this.b46_1 = 16;
    this.c46_1 = 24;
  }
  u4b(r, g, b, a) {
    return this.l4g(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  l4g(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  q4e(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  x4f(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  m4g(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  b4f(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  c4f(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  d4f(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  e4f(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  n4g(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.o4g(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  o4g(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  p4g(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.n4g(c1, c2, tmp$ret$0);
  }
  q4g(c1, c2, factor) {
    return Companion_getInstance_22().m4g(_RGBA___get_rgb__impl__tijaqt(this.p4g(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  d46(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.q4g(c00, c10, factorX);
    var c2 = this.q4g(c01, c11, factorX);
    return this.q4g(c1, c2, factorY);
  }
  p4e(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_22().m4g(_RGBA___get_rgb__impl__tijaqt(this.n4g(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  r4g(src, dst, ratio) {
    return Companion_getInstance_22().q4e(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_22();
    this.a4g_1 = value;
  }
  uz() {
    return RGBA__clone_impl_w007z0(this.a4g_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.a4g_1);
  }
  s4g(other) {
    return RGBA__compareTo_impl_lrfjc1(this.a4g_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.a4g_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.a4g_1, other);
  }
}
class Companion_7 {
  constructor() {
    this.t4g_1 = 16711935;
    this.u4g_1 = -16711936;
  }
  v4g(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_8 {
  w4g(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.x4g_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.x4g_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.x4g_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.x4g_1, other);
  }
}
class Companion_9 {
  y4g(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_10 {}
class Kerning {
  constructor(first, second, amount) {
    this.h4h_1 = first;
    this.i4h_1 = second;
    this.j4h_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.z4g_1 = fontSize;
    this.a4h_1 = id;
    this.b4h_1 = texture;
    this.c4h_1 = xoffset;
    this.d4h_1 = yoffset;
    this.e4h_1 = xadvance;
    var tmp = this;
    tmp.f4h_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.g4h_1 = new GlyphMetrics(this.z4g_1, true, -1, Companion_getInstance_4().z2h(this.c4h_1, this.d4h_1, this.b4h_1.a3k_1, this.b4h_1.b3k_1), this.e4h_1);
  }
  k4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4h_1;
    bmp$factory();
    return this_0.s1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.z4g_1 + ', id=' + this.a4h_1 + ', texture=' + this.b4h_1.toString() + ', xoffset=' + this.c4h_1 + ', yoffset=' + this.d4h_1 + ', xadvance=' + this.e4h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.z4g_1);
    result = imul(result, 31) + this.a4h_1 | 0;
    result = imul(result, 31) + this.b4h_1.hashCode() | 0;
    result = imul(result, 31) + this.c4h_1 | 0;
    result = imul(result, 31) + this.d4h_1 | 0;
    result = imul(result, 31) + this.e4h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.z4g_1, tmp0_other_with_cast.z4g_1))
      return false;
    if (!(this.a4h_1 === tmp0_other_with_cast.a4h_1))
      return false;
    if (!this.b4h_1.equals(tmp0_other_with_cast.b4h_1))
      return false;
    if (!(this.c4h_1 === tmp0_other_with_cast.c4h_1))
      return false;
    if (!(this.d4h_1 === tmp0_other_with_cast.d4h_1))
      return false;
    if (!(this.e4h_1 === tmp0_other_with_cast.e4h_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.u4h(size, metrics) : $super.u4h.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.g4i(size, codePoint, metrics, reader) : $super.g4i.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.r4i(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.r4i.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.r4h().b4h_1);
}
function getFontMetrics(size, metrics) {
  return metrics.e4i(this.s4h(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.h4i(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.g4h_1;
  return metrics.n4i(tmp0_elvis_lhs == null ? this.t4h() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.l4h();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.h4i(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.h4i(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.r4h() : tmp1_elvis_lhs;
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.q4i(size);
  var tmp0_elvis_lhs = this.o4h().e1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.g4i(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.j4i_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.d2m() === 0.0 && metrics.e2m() === 0.0)
    return false;
  var texX = pos.a2a_1 + metrics.r2a();
  var texY = pos.b2a_1 + metrics.t2a();
  var swidth = metrics.d2m();
  var sheight = metrics.e2m();
  var tmp_1;
  if (equals(ctx.o4j(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.k4h();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.s3y(g.k4h().z3y_1, g.k4h().a3z_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.d3z_1;
    if (true) {
      this_1.m3z();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.v46(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.a47_1.s4i_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.n4j(1.0 / scale);
          ctx_0.p4j(ctx.o4j());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.d2m() * scale;
          var height = ctx_0.e2m() * scale;
          ctx_0.q4j(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.a47_1.s4i_1 = t;
        }
      }finally {
        ctx_0.m1a();
      }
    }finally {
      result = true ? this_1.o3z(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.b49(BitmapChannel_ALPHA_getInstance(), g.k4h(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.r4j(bmp, Vector2D.k2c(texX, texY - metrics.u2a()), Size2D.f2i(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.q4i(size);
  var tmp40_safe_receiver = this.p4i(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.j4h_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.u4j_1 = new Mixin();
    this.v4j_1 = fontSize;
    this.w4j_1 = lineHeight;
    this.x4j_1 = base;
    this.y4j_1 = glyphs;
    this.z4j_1 = kernings;
    this.a4k_1 = name;
    this.b4k_1 = distanceField;
    this.c4k_1 = this.w4j_1 - this.x4j_1;
    var tmp = this;
    tmp.d4k_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.e4k_1 = new GlyphMetrics(this.v4j_1, false, 0, Companion_getInstance_4().p2d(), 0.0);
    var tmp_0 = this;
    tmp_0.f4k_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.g4k_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  yz(_set____db54di) {
    this.u4j_1.yz(_set____db54di);
  }
  zz() {
    return this.u4j_1.zz();
  }
  l4h() {
    return this.v4j_1;
  }
  m4h() {
    return this.w4j_1;
  }
  a3l() {
    return this.x4j_1;
  }
  o4h() {
    return this.y4j_1;
  }
  p4h() {
    return this.z4j_1;
  }
  s3() {
    return this.a4k_1;
  }
  n4h() {
    return this.b4k_1;
  }
  b11() {
    return this;
  }
  s4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d4k_1;
    naturalFontMetrics$factory();
    return this_0.s1();
  }
  t4h() {
    return this.e4k_1;
  }
  p4i(first, second) {
    return this.z4j_1.e1(Companion_instance_15.y4g(first, second));
  }
  h4i(codePoint) {
    return this.y4j_1.e1(codePoint);
  }
  r4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4k_1;
    anyGlyph$factory();
    return this_0.s1();
  }
  h4k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g4k_1;
    invalidGlyph$factory();
    return this_0.s1();
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.x4m_1 = bmp;
    this.y4m_1 = fmetrics;
    this.z4m_1 = metrics;
    this.a4n_1 = glyphs;
    this.b4n_1 = glyphsPerLine;
    this.c4n_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.x4m_1) + ', fmetrics=' + this.y4m_1.toString() + ', metrics=' + this.z4m_1.toString() + ', glyphs=' + toString_0(this.a4n_1) + ', glyphsPerLine=' + toString_0(this.b4n_1) + ', shape=' + toString(this.c4n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.x4m_1);
    result = imul(result, 31) + this.y4m_1.hashCode() | 0;
    result = imul(result, 31) + this.z4m_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a4n_1) | 0;
    result = imul(result, 31) + hashCode(this.b4n_1) | 0;
    result = imul(result, 31) + (this.c4n_1 == null ? 0 : hashCode(this.c4n_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.x4m_1, tmp0_other_with_cast.x4m_1))
      return false;
    if (!this.y4m_1.equals(tmp0_other_with_cast.y4m_1))
      return false;
    if (!this.z4m_1.equals(tmp0_other_with_cast.z4m_1))
      return false;
    if (!equals(this.a4n_1, tmp0_other_with_cast.a4n_1))
      return false;
    if (!equals(this.b4n_1, tmp0_other_with_cast.b4n_1))
      return false;
    if (!equals(this.c4n_1, tmp0_other_with_cast.c4n_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.o4n_1 = codePoint;
    this.p4n_1 = pos;
    this.q4n_1 = metrics;
    this.r4n_1 = fontMetrics;
    this.s4n_1 = transform;
    this.t4n_1 = index;
    this.u4n_1 = nline;
    var tmp = this;
    tmp.v4n_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.w4n_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.x4n_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.y4n_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  z4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v4n_1;
    boundsPath$factory();
    return this_0.s1();
  }
  a4o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w4n_1;
    boundsPathCurves$factory();
    return this_0.s1();
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.o4n_1 + ', pos=' + this.p4n_1.toString() + ', metrics=' + this.q4n_1.toString() + ', fontMetrics=' + this.r4n_1.toString() + ', transform=' + this.s4n_1.toString() + ', index=' + this.t4n_1 + ', nline=' + this.u4n_1 + ')';
  }
  hashCode() {
    var result = this.o4n_1;
    result = imul(result, 31) + this.p4n_1.hashCode() | 0;
    result = imul(result, 31) + this.q4n_1.hashCode() | 0;
    result = imul(result, 31) + this.r4n_1.hashCode() | 0;
    result = imul(result, 31) + this.s4n_1.hashCode() | 0;
    result = imul(result, 31) + this.t4n_1 | 0;
    result = imul(result, 31) + this.u4n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.o4n_1 === tmp0_other_with_cast.o4n_1))
      return false;
    if (!this.p4n_1.equals(tmp0_other_with_cast.p4n_1))
      return false;
    if (!this.q4n_1.equals(tmp0_other_with_cast.q4n_1))
      return false;
    if (!this.r4n_1.equals(tmp0_other_with_cast.r4n_1))
      return false;
    if (!this.s4n_1.equals(tmp0_other_with_cast.s4n_1))
      return false;
    if (!(this.t4n_1 === tmp0_other_with_cast.t4n_1))
      return false;
    if (!(this.u4n_1 === tmp0_other_with_cast.u4n_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.b4o_1 = fmetrics;
    this.c4o_1 = metrics;
    this.d4o_1 = glyphs;
    this.e4o_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.b4o_1.toString() + ', metrics=' + this.c4o_1.toString() + ', glyphs=' + toString_0(this.d4o_1) + ', glyphsPerLine=' + toString_0(this.e4o_1) + ')';
  }
  hashCode() {
    var result = this.b4o_1.hashCode();
    result = imul(result, 31) + this.c4o_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d4o_1) | 0;
    result = imul(result, 31) + hashCode(this.e4o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.b4o_1.equals(tmp0_other_with_cast.b4o_1))
      return false;
    if (!this.c4o_1.equals(tmp0_other_with_cast.c4o_1))
      return false;
    if (!equals(this.d4o_1, tmp0_other_with_cast.d4o_1))
      return false;
    if (!equals(this.e4o_1, tmp0_other_with_cast.e4o_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.g4p_1 = FastArrayList.q10();
    this.h4p_1 = FastArrayList.q10();
  }
  f1() {
    return this.g4p_1.f1();
  }
  m4q(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.g4p_1.h(glyph);
    while (this.h4p_1.f1() <= glyph.u4n_1) {
      this.h4p_1.h(FastArrayList.q10());
    }
    this.h4p_1.e1(glyph.u4n_1).h(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.w4s(Companion_getInstance_6().c2a_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.vy();
  var that = Vector2D.k2c(x, 0.0);
  var tmp$ret$0 = Vector2D.k2c(this_0.a2a_1 + that.a2a_1, this_0.b2a_1 + that.b2a_1);
  this.w4s(tmp$ret$0);
}
function newLine(y, end) {
  this.w4s(Vector2D.k2c(0.0, this.vy().b2a_1 + y));
  var _unary__edvuaz = this.o4s();
  this.u4s(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.e4s_1 = new GlyphPath();
    this.f4s_1 = new GlyphMetrics();
    this.g4s_1 = new FontMetrics();
    this.h4s_1 = 0;
    this.j4s_1 = 0.0;
    this.k4s_1 = Companion_getInstance_6().c2a_1;
    this.l4s_1 = Companion_getInstance_5().m2d_1;
    this.m4s_1 = null;
    this.n4s_1 = Colors_getInstance().g40_1;
  }
  m4h() {
    return this.g4s_1.m4h();
  }
  u4s(_set____db54di) {
    this.h4s_1 = _set____db54di;
  }
  o4s() {
    return this.h4s_1;
  }
  t4s() {
    var tmp = this.i4s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  v4s(font, size) {
    this.i4s_1 = font;
    this.j4s_1 = size;
    font.u4h(size, this.g4s_1);
  }
  w4s(_set____db54di) {
    this.k4s_1 = _set____db54di;
  }
  vy() {
    return this.k4s_1;
  }
  x4s(reader, codePoint) {
    return this.t4s().g4i(this.j4s_1, codePoint, this.f4s_1, reader);
  }
  y4s(_set____db54di) {
    this.l4s_1 = _set____db54di;
  }
  r4s() {
    return this.l4s_1;
  }
  p4i(leftCodePoint, rightCodePoint) {
    return this.t4s().t4j(this.j4s_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.t4r_1 = $size;
    $box.u4r_1 = $align;
    $box.v4r_1 = $pos;
    $box.w4r_1 = $ctx;
    $box.x4r_1 = $paint;
    $box.y4r_1 = $textRangeStart;
    $box.z4r_1 = $textRangeEnd;
    $box.a4s_1 = $doRender;
    $box.b4s_1 = $glyphs;
    $box.c4s_1 = $placed;
    super($box);
    this.r4r_1 = measure($renderer, $text, $size, $fnt);
    this.s4r_1 = 0;
  }
  d4s(reader, codePoint) {
    var nline = this.o4s();
    var dx = this.r4r_1.p4s(this.u4r_1.d4q_1, nline);
    var dy = this.r4r_1.g4q(this.u4r_1.e4q_1, this.g4s_1);
    var px = this.vy().a2a_1 + this.v4r_1.a2a_1 - dx;
    var py = this.vy().b2a_1 + this.v4r_1.b2a_1 + dy;
    var tmp71_safe_receiver = this.w4r_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.a47_1.s4i_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.w4r_1.q4s(px, py);
        this.w4r_1.s4s(get_immutable(this.r4s()));
        var tmp0_elvis_lhs = this.m4s_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.x4r_1 : tmp0_elvis_lhs;
        this.w4r_1.p4j(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.y4r_1;
        var containsUpper = this.z4r_1;
        var containsArg = this.s4r_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.t4s().r4i(this.w4r_1, this.t4r_1, codePoint, Companion_getInstance_6().c2a_1, null, this.f4s_1, reader, this.a4s_1);
        }
        this.s4r_1 = this.s4r_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.a47_1.s4i_1 = t;
      }
    }
    if (!(this.b4s_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.k2c(px, py), this.f4s_1.uz(), this.g4s_1.uz(), this.r4s(), this.b4s_1.f1(), nline);
      this.b4s_1.m4q(glyph);
    }
    var tmp72_safe_receiver = this.c4s_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.k2c(px, py), this.t4r_1, this.f4s_1, this.g4s_1, this.r4s());
    return this.f4s_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.x2c(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.t2j(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_5().p2d() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.b4t_1 = path;
    this.c4t_1 = colorShape;
    this.d4t_1 = bitmap;
    this.e4t_1 = bitmapOffset;
    this.f4t_1 = bitmapScale;
    this.g4t_1 = transform;
    this.h4t_1 = scale;
  }
  i4t() {
    return this.d4t_1 == null && this.c4t_1 == null;
  }
  j4t(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.a47_1.s4i_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.s4s(this.g4t_1);
      if (!(this.d4t_1 == null)) {
        c.r4j(ensureNotNull(this.d4t_1), this.e4t_1, toFloat(ensureNotNull(this.d4t_1).f1()).h2k(this.f4t_1));
      } else if (!(this.c4t_1 == null)) {
        c.k4t(ensureNotNull(this.c4t_1));
        c.f4p();
      } else {
        draw_1(c, this.b4t_1);
      }
    }finally {
      c.a47_1.s4i_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.b4t_1.toString() + ', colorShape=' + toString(this.c4t_1) + ', bitmap=' + toString(this.d4t_1) + ', bitmapOffset=' + this.e4t_1.toString() + ', bitmapScale=' + this.f4t_1.toString() + ', transform=' + this.g4t_1.toString() + ', scale=' + this.h4t_1 + ')';
  }
  hashCode() {
    var result = this.b4t_1.hashCode();
    result = imul(result, 31) + (this.c4t_1 == null ? 0 : hashCode(this.c4t_1)) | 0;
    result = imul(result, 31) + (this.d4t_1 == null ? 0 : hashCode(this.d4t_1)) | 0;
    result = imul(result, 31) + this.e4t_1.hashCode() | 0;
    result = imul(result, 31) + this.f4t_1.hashCode() | 0;
    result = imul(result, 31) + this.g4t_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.h4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.b4t_1.equals(tmp0_other_with_cast.b4t_1))
      return false;
    if (!equals(this.c4t_1, tmp0_other_with_cast.c4t_1))
      return false;
    if (!equals(this.d4t_1, tmp0_other_with_cast.d4t_1))
      return false;
    if (!this.e4t_1.equals(tmp0_other_with_cast.e4t_1))
      return false;
    if (!this.f4t_1.equals(tmp0_other_with_cast.f4t_1))
      return false;
    if (!this.g4t_1.equals(tmp0_other_with_cast.g4t_1))
      return false;
    if (!equals(this.h4t_1, tmp0_other_with_cast.h4t_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.l4t_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_27();
    distanceField = distanceField === VOID ? null : distanceField;
    this.m4t_1 = new Mixin();
    this.n4t_1 = font;
    this.o4t_1 = fontSize;
    this.p4t_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.v3y(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.p4t_1 == null))
      this_0.x3x_1;
    else
      mipmaps(this_0.x3x_1);
    tmp.q4t_1 = this_0;
    this.r4t_1 = this.n4t_1.f4i(this.o4t_1);
    this.s4t_1 = this.r4t_1.m4h();
    this.t4t_1 = this.r4t_1.y4h_1;
    this.u4t_1 = IntMap.v2s();
    this.v4t_1 = IntMap.v2s();
    var tmp_0 = this;
    tmp_0.w4t_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.x4t_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.y4t_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.z4t_1 = new GlyphMetrics(this.o4t_1, false, 0, Companion_getInstance_4().p2d(), 0.0);
  }
  yz(_set____db54di) {
    this.m4t_1.yz(_set____db54di);
  }
  zz() {
    return this.m4t_1.zz();
  }
  l4h() {
    return this.o4t_1;
  }
  n4h() {
    return this.p4t_1;
  }
  m4h() {
    return this.s4t_1;
  }
  a3l() {
    return this.t4t_1;
  }
  o4h() {
    return this.u4t_1;
  }
  p4h() {
    return this.v4t_1;
  }
  r4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w4t_1;
    anyGlyph$factory_0();
    return this_0.s1();
  }
  h4k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x4t_1;
    invalidGlyph$factory_0();
    return this_0.s1();
  }
  s3() {
    return this.n4t_1.s3();
  }
  s4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y4t_1;
    naturalFontMetrics$factory_0();
    return this_0.s1();
  }
  t4h() {
    return this.z4t_1;
  }
  p4i(first, second) {
    var kerning = this.n4t_1.t4j(this.o4t_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.v4t_1;
      var key = Companion_instance_15.y4g(first, second);
      var res = this_0.e1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.p2s(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.e1(key));
    }
    return tmp;
  }
  h4i(codePoint) {
    if (this.u4t_1.e1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.a4u(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.a4u(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.a4u(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.b4u(tmp$ret$6);
    }
    return this.u4t_1.e1(codePoint);
  }
  a4u(codePoint, range) {
    var containsLower = range.b2_1;
    if (codePoint <= range.c2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.m2o(coerceAtLeast(range.f2() - range.g2() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.g2();
      var last = range.f2();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.s2o(v);
        }
         while (!(v === last));
      this.b4u(this_0.d2p());
    }
  }
  b4u(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.q4t_1.x3x_1;
    var rect = this_0.d3z_1;
    if (true) {
      this_0.m3z();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.u4t_1;
        var res = this_1.e1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.p4t_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.o4t_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.n4t_1;
          var tmp84_size = this.o4t_1;
          var tmp85_paint = Colors_getInstance().g40_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.x4m_1.l3z();
          var rbmp;
          switch (this.p4t_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.c4n_1).c4u(), bmp.z3y_1, bmp.a3z_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.c4n_1).c4u(), bmp.z3y_1, bmp.a3z_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.q4t_1.x3y(rbmp, Unit_instance);
          var slice = entry.p3x_1.g3l(border, border, entry.p3x_1.a3k_1 - border | 0, entry.p3x_1.b3k_1 - border | 0);
          var g = first_0(result_0.a4n_1);
          var m = g.q4n_1;
          var xadvance = m.m4i_1;
          var tmp$ret$1 = new Glyph(this.o4t_1, codePoint, slice, -toIntRound(g.p4n_1.a2a_1) | 0, -toIntRound(g.p4n_1.b2a_1) | 0, toIntRound(xadvance));
          this_1.p2s(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.e1(codePoint));
      }
    }finally {
      result = true ? this_0.o3z(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.v4h_1 = size;
    this.w4h_1 = top;
    this.x4h_1 = ascent;
    this.y4h_1 = baseline;
    this.z4h_1 = descent;
    this.a4i_1 = bottom;
    this.b4i_1 = lineGap;
    this.c4i_1 = maxWidth;
    this.d4i_1 = unitsPerEm;
  }
  d4u() {
    // Inline function 'kotlin.math.max' call
    var a = this.x4h_1;
    var b = this.w4h_1;
    return Math.max(a, b);
  }
  e4u() {
    // Inline function 'kotlin.math.min' call
    var a = this.z4h_1;
    var b = this.a4i_1;
    return Math.min(a, b);
  }
  f4u() {
    return this.d4u() - this.e4u();
  }
  m4h() {
    return this.f4u() + this.b4i_1;
  }
  m4p(other) {
    return this.g4u(other, 1.0);
  }
  e4i(other, size) {
    return this.g4u(other, size / other.v4h_1);
  }
  g4u(other, scale) {
    this.v4h_1 = other.v4h_1 * scale;
    this.w4h_1 = other.w4h_1 * scale;
    this.x4h_1 = other.x4h_1 * scale;
    this.y4h_1 = other.y4h_1 * scale;
    this.z4h_1 = other.z4h_1 * scale;
    this.a4i_1 = other.a4i_1 * scale;
    this.b4i_1 = other.b4i_1 * scale;
    this.d4i_1 = other.d4i_1 * scale;
    this.c4i_1 = other.c4i_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.bc('FontMetrics(');
    this_0.bc('size=' + niceStr(this.v4h_1, 1) + ', ');
    this_0.bc('top=' + niceStr(this.w4h_1, 1) + ', ');
    this_0.bc('ascent=' + niceStr(this.x4h_1, 1) + ', ');
    this_0.bc('baseline=' + niceStr(this.y4h_1, 1) + ', ');
    this_0.bc('descent=' + niceStr(this.z4h_1, 1) + ', ');
    this_0.bc('bottom=' + niceStr(this.a4i_1, 1) + ', ');
    this_0.bc('lineGap=' + niceStr(this.b4i_1, 1) + ', ');
    this_0.bc('unitsPerEm=' + niceStr(this.d4i_1, 1) + ', ');
    this_0.bc('maxWidth=' + niceStr(this.c4i_1, 1) + ', ');
    this_0.bc('lineHeight=' + niceStr(this.m4h(), 1));
    this_0.bc(')');
    return this_0.toString();
  }
  uz() {
    return this.h4u();
  }
  i4u(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  h4u(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.v4h_1 : size;
    top = top === VOID ? this.w4h_1 : top;
    ascent = ascent === VOID ? this.x4h_1 : ascent;
    baseline = baseline === VOID ? this.y4h_1 : baseline;
    descent = descent === VOID ? this.z4h_1 : descent;
    bottom = bottom === VOID ? this.a4i_1 : bottom;
    lineGap = lineGap === VOID ? this.b4i_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.c4i_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.d4i_1 : unitsPerEm;
    return $super === VOID ? this.i4u(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.i4u.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.v4h_1);
    result = imul(result, 31) + getNumberHashCode(this.w4h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x4h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y4h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z4h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a4i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b4i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c4i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.v4h_1, tmp0_other_with_cast.v4h_1))
      return false;
    if (!equals(this.w4h_1, tmp0_other_with_cast.w4h_1))
      return false;
    if (!equals(this.x4h_1, tmp0_other_with_cast.x4h_1))
      return false;
    if (!equals(this.y4h_1, tmp0_other_with_cast.y4h_1))
      return false;
    if (!equals(this.z4h_1, tmp0_other_with_cast.z4h_1))
      return false;
    if (!equals(this.a4i_1, tmp0_other_with_cast.a4i_1))
      return false;
    if (!equals(this.b4i_1, tmp0_other_with_cast.b4i_1))
      return false;
    if (!equals(this.c4i_1, tmp0_other_with_cast.c4i_1))
      return false;
    if (!equals(this.d4i_1, tmp0_other_with_cast.d4i_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_4().p2d() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.i4i_1 = size;
    this.j4i_1 = existing;
    this.k4i_1 = codePoint;
    this.l4i_1 = bounds;
    this.m4i_1 = xadvance;
  }
  u2a() {
    return this.l4i_1.u2a();
  }
  r2a() {
    return this.l4i_1.r2a();
  }
  t2a() {
    return this.l4i_1.t2a();
  }
  d2m() {
    return this.l4i_1.m2a_1;
  }
  e2m() {
    return this.l4i_1.n2a_1;
  }
  uz() {
    return this.j4u(VOID, VOID, VOID, this.l4i_1.uz());
  }
  n4i(other, size, codePoint) {
    return this.k4u(other, size / other.i4i_1, codePoint);
  }
  k4u(other, scale, codePoint) {
    this.i4i_1 = other.i4i_1;
    this.j4i_1 = other.j4i_1;
    this.k4i_1 = codePoint;
    this.l4i_1 = other.l4i_1.i2i(scale);
    this.m4i_1 = other.m4i_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.bc('GlyphMetrics(');
    this_0.bc('codePoint=' + this.k4i_1 + " ('" + toString_1(numberToChar(this.k4i_1)) + "'), ");
    this_0.bc('existing=' + this.j4i_1 + ', ');
    this_0.bc('xadvance=' + roundToInt(this.m4i_1) + ', ');
    this_0.bc('bounds=' + this.l4i_1.j2().toString());
    this_0.bc(')');
    return this_0.toString();
  }
  l4u(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  j4u(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.i4i_1 : size;
    existing = existing === VOID ? this.j4i_1 : existing;
    codePoint = codePoint === VOID ? this.k4i_1 : codePoint;
    bounds = bounds === VOID ? this.l4i_1 : bounds;
    xadvance = xadvance === VOID ? this.m4i_1 : xadvance;
    return $super === VOID ? this.l4u(size, existing, codePoint, bounds, xadvance) : $super.l4u.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.i4i_1);
    result = imul(result, 31) + getBooleanHashCode(this.j4i_1) | 0;
    result = imul(result, 31) + this.k4i_1 | 0;
    result = imul(result, 31) + this.l4i_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.m4i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.i4i_1, tmp0_other_with_cast.i4i_1))
      return false;
    if (!(this.j4i_1 === tmp0_other_with_cast.j4i_1))
      return false;
    if (!(this.k4i_1 === tmp0_other_with_cast.k4i_1))
      return false;
    if (!this.l4i_1.equals(tmp0_other_with_cast.l4i_1))
      return false;
    if (!equals(this.m4i_1, tmp0_other_with_cast.m4i_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_4().p2d() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.i4p_1 = bounds;
    this.j4p_1 = lineBounds;
    this.k4p_1 = fontMetrics;
    this.l4p_1 = nlines;
  }
  m4u() {
    var tmp0_elvis_lhs = firstOrNull_0(this.j4p_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().w2a_1 : tmp0_elvis_lhs;
  }
  r2a() {
    return this.i4p_1.r2a();
  }
  t2a() {
    return this.i4p_1.t2a();
  }
  d2m() {
    return this.i4p_1.m2a_1;
  }
  e2m() {
    return this.i4p_1.n2a_1;
  }
  n4u() {
    return -this.r2a();
  }
  o4u() {
    return this.m4u().n2a_1 + this.m4u().t2a();
  }
  l4q() {
    return this.k4p_1.x4h_1;
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.r2a()) + ', ' + get_niceStr_0(this.t2a()) + ', ' + get_niceStr_0(this.d2m()) + ', ' + get_niceStr_0(this.e2m()) + '][' + get_niceStr_0(this.n4u()) + ', ' + get_niceStr_0(this.o4u()) + ']';
  }
  hashCode() {
    var result = this.i4p_1.hashCode();
    result = imul(result, 31) + hashCode(this.j4p_1) | 0;
    result = imul(result, 31) + this.k4p_1.hashCode() | 0;
    result = imul(result, 31) + this.l4p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.i4p_1.equals(tmp0_other_with_cast.i4p_1))
      return false;
    if (!equals(this.j4p_1, tmp0_other_with_cast.j4p_1))
      return false;
    if (!this.k4p_1.equals(tmp0_other_with_cast.k4p_1))
      return false;
    if (!(this.l4p_1 === tmp0_other_with_cast.l4p_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.r4u_1;
      destination.h3(tmp$ret$0, element);
    }
    tmp.s4u_1 = toIntMap(destination);
  }
  e1(id) {
    return this.s4u_1.e1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.t4u_1 = path;
    this.u4u_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.t4u_1.toString() + ', advanceWidth=' + this.u4u_1 + ')';
  }
  hashCode() {
    var result = this.t4u_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.u4u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.t4u_1.equals(tmp0_other_with_cast.t4u_1))
      return false;
    if (!equals(this.u4u_1, tmp0_other_with_cast.u4u_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.v4u_1 = charstringsIndex;
    this.w4u_1 = globalSubrIndex;
    this.x4u_1 = localSubrsIndex;
    this.y4u_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.y4u_1.f3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.z4u_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.y4u_1.f3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.a4v_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  b4v(index, flipY) {
    var evalCtx = new EvalContext(this.w4u_1, this.x4u_1, this.z4u_1, this.a4v_1, index);
    var vp = new VectorPath();
    var bytes = this.v4u_1.e1(index);
    CharStringType2_instance.e4v(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.n3r(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.o4v_1);
  }
  q4v(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.b4v(index, flipY) : $super.b4v.call(this, index, flipY);
  }
}
class DataIndex {
  static r4v(offsets, bytes) {
    var $this = createThis(this);
    $this.c4v_1 = offsets;
    $this.d4v_1 = bytes;
    return $this;
  }
  static s4v() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.r4v(tmp, tmp$ret$1);
  }
  f1() {
    return this.c4v_1.length - 1 | 0;
  }
  t4v(index) {
    return this.c4v_1[index + 1 | 0] - this.c4v_1[index] | 0;
  }
  e1(index) {
    return copyOfRange(this.d4v_1, this.c4v_1[index], this.c4v_1[index + 1 | 0]);
  }
  u4v() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.f1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.e1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return destination;
  }
  b1() {
    return this.u4v().b1();
  }
  toString() {
    var tmp = this.f1();
    var tmp_0 = toString_0(toList_0(this.c4v_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.f1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.t4v(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.r4u_1 = id;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.x4v_1;
      destination.h3(tmp$ret$0, element);
    }
    tmp.y4v_1 = toIntMap(destination);
  }
  e1(id) {
    var tmp0_elvis_lhs = this.y4v_1.e1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.h5(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.s4v() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.s4v() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.f4v_1 = globalSubrIndex;
    this.g4v_1 = localSubrsIndex;
    this.h4v_1 = defaultWidthX;
    this.i4v_1 = nominalWidthX;
    this.j4v_1 = index;
    this.k4v_1 = heap;
    this.l4v_1 = computeSubrBias(CharStringType2_instance, this.f4v_1.f1());
    this.m4v_1 = computeSubrBias(CharStringType2_instance, this.g4v_1.f1());
    this.n4v_1 = 0;
    this.o4v_1 = this.h4v_1;
    this.p4v_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.x4v_1 = id;
  }
}
class CFF {
  z4v(_this__u8e3s4) {
    this.a4w(_this__u8e3s4);
    var nameIndex = this.b4w(_this__u8e3s4);
    var topDictIndex = this.b4w(_this__u8e3s4);
    var topDictByte = topDictIndex.e1(0)[1];
    var topDict = this.c4w(openFastStream(topDictIndex.e1(0)));
    var stringIndex = this.b4w(_this__u8e3s4);
    var globalSubrIndex = this.b4w(_this__u8e3s4);
    var privateSizeOffset = topDict.f3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.s4v();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.h(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.e1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.e1(1);
      privateDict = this.c4w(_this__u8e3s4.k1s(privateOffset, privateSize));
      var localSubrs = privateDict.f3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.b4w(_this__u8e3s4.l1s(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.f3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.b4w(_this__u8e3s4.l1s(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  a4w(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.q1s();
    var versionMinor = _this__u8e3s4.q1s();
    var headerSize = _this__u8e3s4.q1s();
    var offsetSize = _this__u8e3s4.q1s();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().d4w_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  e4w(_this__u8e3s4) {
    return _this__u8e3s4.q1s();
  }
  f4w(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.e4w(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.q1s();
        break;
      case 2:
        tmp = _this__u8e3s4.s1s();
        break;
      case 3:
        tmp = _this__u8e3s4.t1s();
        break;
      case 4:
        tmp = _this__u8e3s4.u1s();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  b4w(_this__u8e3s4) {
    var count = _this__u8e3s4.s1s();
    if (count === 0)
      return DataIndex.s4v();
    var offSize = this.e4w(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.m2o((coerceAtLeast(this_0.f2() - this_0.g2() | 0, 0) / this_0.d2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.g2();
    var nestedLast = this_0.f2();
    var stepArg = this_0.d2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.f4w(_this__u8e3s4, offSize) - 1 | 0;
        this_1.s2o(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.o1s(offsets.z2o());
    return DataIndex.r4v(offsets.d2p(), bytes);
  }
  c4w(_this__u8e3s4) {
    var map = LinkedHashMap.oc();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.j1();
    while (_this__u8e3s4.ux()) {
      var item = this.g4w(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.h3(item, value);
        values.k3();
      } else {
        if (isNumber(item)) {
          values.h(item);
        }
      }
    }
    return map;
  }
  g4w(_this__u8e3s4) {
    var b0 = _this__u8e3s4.q1s();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_28();
      tmp = tmp_0.e1(b0 === 12 ? b0 << 8 | _this__u8e3s4.q1s() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.q1s() << 8 | _this__u8e3s4.q1s());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.q1s() << 24 | _this__u8e3s4.q1s() << 16 | _this__u8e3s4.q1s() << 8 | _this__u8e3s4.q1s();
    } else if (b0 === 30) {
      tmp = this.h4w(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.q1s() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.q1s() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  i4w(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.q1s() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.h5(toString_0(message));
      }
    }
    var str = StringBuilder.f();
    end: while (true) {
      var byte = _this__u8e3s4.q1s();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.bc('E-');
              break;
            default:
              str.cc((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  h4w(_this__u8e3s4, readHeader) {
    return toDouble(this.i4w(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  j4w(_this__u8e3s4, value) {
    _this__u8e3s4.s2p(_this__u8e3s4.f1() - 1 | 0, value);
  }
  k4w(_this__u8e3s4) {
    return _this__u8e3s4.e1(_this__u8e3s4.f1() - 1 | 0);
  }
  l4w(_this__u8e3s4) {
    return _this__u8e3s4.p3(_this__u8e3s4.f1() - 1 | 0);
  }
  m4w(_this__u8e3s4, value) {
    _this__u8e3s4.t11(value);
  }
  n4w(_this__u8e3s4, value) {
    _this__u8e3s4.t11(value);
  }
  o4w(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.v3q();
    _this__u8e3s4.n6();
    _this__u8e3s4.t3h(lastPoint);
  }
  p4w(_this__u8e3s4, x, y) {
    _this__u8e3s4.d3r(Vector2D.k2c(x, y));
  }
  q4w(_this__u8e3s4, x, y) {
    _this__u8e3s4.e3r(Vector2D.k2c(x, y));
  }
  r4w(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.u3h(Vector2D.k2c(fcx1, fcy1), Vector2D.k2c(fcx2, fcy2), Vector2D.k2c(fax, fay));
  }
  s4w(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.v3q().a2a_1 + cx1;
    var fcy1 = _this__u8e3s4.v3q().b2a_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.r4w(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  t4w(_this__u8e3s4, v, horizontal) {
    return this.p4w(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  u4w(_this__u8e3s4, v, horizontal) {
    return this.q4w(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  v4w(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.q1s();
  }
  w4w(ctx, s, evalCtx, stack, stackLevel) {
    while (s.ux()) {
      var v0 = this.v4w(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_29();
        var op = tmp.e1(v0 === 12 ? v0 << 8 | this.v4w(s) : v0);
        switch (op.r3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.h1()) {
              tmp_0 = !evalCtx.p4v_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.o4v_1 = stack.e1(0) + evalCtx.i4v_1;
              evalCtx.p4v_1 = true;
            }

            if (!(ctx.u3q() === 0)) {
              this.o4w(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.l4w(stack));
            var bytes = global ? evalCtx.f4v_1.e1(evalCtx.l4v_1 + funcOffset | 0) : evalCtx.g4v_1.e1(evalCtx.m4v_1 + funcOffset | 0);
            this.w4w(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.l4w(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.l4w(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.l2p(this_0, this_0);
            break;
          case 39:
            stack.b2p(stack.f1() - 2 | 0, stack.f1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.be();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.be();
          case 25:
            var index = this.l4w(stack);
            var value = this.l4w(stack);
            evalCtx.k4v_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.k4w(stack);
            var tmp$ret$3 = evalCtx.k4v_1[numberToInt(it)];
            this.j4w(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.l4w(stack);
            var l = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.m4w(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.l4w(stack);
            var l_0 = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.m4w(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.k4w(stack) === 0.0 ? 1 : 0;
            this.j4w(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.l4w(stack);
            var l_1 = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.m4w(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.l4w(stack);
            var v1 = this.l4w(stack);
            var s2 = this.l4w(stack);
            var s1 = this.l4w(stack);
            this.m4w(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.t11(Default_getInstance().wo());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.k4w(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.j4w(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.k4w(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.j4w(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.k4w(stack);
            this.j4w(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.l4w(stack);
            var l_2 = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.m4w(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.l4w(stack);
            var l_3 = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.m4w(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.l4w(stack);
            var l_4 = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.m4w(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.l4w(stack);
            var l_5 = this.l4w(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.m4w(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.f1() > 2) {
              evalCtx.o4v_1 = stack.e1(0) + evalCtx.i4v_1;
              evalCtx.p4v_1 = true;
            }

            if (!(ctx.u3q() === 0)) {
              this.o4w(ctx);
            }

            this.p4w(ctx, stack.e1(stack.f1() - 2 | 0), stack.e1(stack.f1() - 1 | 0));
            stack.k3();
            break;
          case 3:
          case 28:
            if (stack.f1() > 1) {
              evalCtx.o4v_1 = stack.e1(0) + evalCtx.i4v_1;
              evalCtx.p4v_1 = true;
            }

            this.t4w(ctx, this.l4w(stack), op.equals(Op_hmoveto_getInstance()));
            stack.k3();
            break;
          case 5:
            var progression = step(until(0, stack.f1()), 2);
            var inductionVariable = progression.b2_1;
            var last = progression.c2_1;
            var step_0 = progression.d2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.q4w(ctx, stack.e1(n), stack.e1(n + 1 | 0));
              }
               while (!(n === last));
            stack.k3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.f1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.u4w(ctx, stack.e1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.k3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.f1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.e1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.q4w(ctx, tmp_1, stack.e1(_unary__edvuaz_0));
              }
            }

            while ((stack.f1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.e1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.e1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.e1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.e1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.e1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.s4w(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.e1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.f1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.e1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.q4w(ctx, tmp_7, stack.e1(_unary__edvuaz_8));
              }
            }

            stack.k3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.f1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.e1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.f1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.h5(toString_0(message));
            }

            while (n_2 < stack.f1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.e1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.e1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.e1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.e1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.s4w(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.k3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.h1()) {
                break $l$loop;
              }
              var vv_0 = this.l4w(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.l4w(stack);
              var y2_0 = this.l4w(stack);
              var v1_1 = this.l4w(stack);
              var v2_0 = stack.f1() === 1 ? this.l4w(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.s4w(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.k3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.be();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.f1() % 2 | 0) === 0) && !evalCtx.p4v_1) {
              var value_0 = stack.e1(0);
              evalCtx.o4v_1 = value_0 + evalCtx.i4v_1;
            }

            evalCtx.n4v_1 = evalCtx.n4v_1 + (stack.f1() >>> 1 | 0) | 0;
            evalCtx.p4v_1 = true;
            stack.k3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.n4v_1 + 7 | 0) >>> 3 | 0;
              s.zx(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.be();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.be();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.v4w(s) << 8 | this.v4w(s);
        var fractionPart = this.v4w(s) << 8 | this.v4w(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.m4w(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.v4w(s) << 8 | this.v4w(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.v4w(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.v4w(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.n4w(stack, value_2);
      }
    }
  }
  e4v(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.g2p(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.w4w(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.w4w.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.d4w_1 = Companion_getInstance_14().ey('TtfCIDFont');
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_20 = this;
    this.x4w_1 = Companion_getInstance_14().ey('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.n4z(size, codePoint, path, reader) : $super.n4z.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.nx_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.g4i(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.nx_1 = old;
      }
    }
  }
  var g = this.o4z(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.f4p();
    }
    if (!g.i4t()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.a47_1.s4i_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.q4s(pos.a2a_1, pos.b2a_1);
      g.j4t(ctx);
    }finally {
      ctx.a47_1.s4i_1 = t;
    }
    switch (fill) {
      case true:
        ctx.o4q();
        break;
      case false:
        ctx.n4q();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.i4t();
  }
  return false;
}
class BaseTtfFont {
  static j59(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.y4w_1 = new Mixin();
    $this.z4w_1 = s;
    $this.a4x_1 = extName;
    $this.b4x_1 = onlyReadMetadata;
    $this.c4x_1 = enableLigatures;
    $this.d4x_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e4x_1 = tmp_1;
    $this.f4x_1 = 0;
    $this.g4x_1 = 0;
    $this.h4x_1 = 0;
    $this.i4x_1 = 0;
    $this.j4x_1 = 0;
    $this.k4x_1 = 0;
    $this.l4x_1 = 0;
    $this.m4x_1 = 0;
    $this.n4x_1 = 0;
    $this.o4x_1 = 0;
    $this.p4x_1 = 0;
    $this.q4x_1 = 0;
    $this.r4x_1 = 0;
    $this.s4x_1 = 0;
    $this.t4x_1 = Companion_instance_24.k59(0, 0);
    $this.u4x_1 = 0;
    $this.v4x_1 = 0;
    $this.w4x_1 = 0;
    $this.x4x_1 = 0;
    $this.y4x_1 = 0;
    $this.z4x_1 = 0;
    $this.a4y_1 = 0;
    $this.b4y_1 = 0;
    $this.c4y_1 = 0;
    $this.d4y_1 = 0;
    $this.e4y_1 = 0;
    $this.f4y_1 = 0;
    $this.g4y_1 = new Int32Array(0);
    $this.h4y_1 = Companion_instance_24.k59(0, 0);
    $this.i4y_1 = 128;
    $this.j4y_1 = 0;
    $this.k4y_1 = 0;
    $this.l4y_1 = 0;
    $this.m4y_1 = 0;
    $this.n4y_1 = 0;
    $this.o4y_1 = 0;
    $this.p4y_1 = 0;
    $this.q4y_1 = 0;
    $this.r4y_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.s4y_1 = emptyList();
    $this.t4y_1 = LinkedHashMap.oc();
    $this.u4y_1 = LinkedHashMap.oc();
    $this.v4y_1 = IntMap.v2s(512);
    $this.w4y_1 = LinkedHashMap.oc();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.x4y_1 = [];
    $this.y4y_1 = IntMap.v2s();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.z4y_1 = emptyList();
    $this.a4z_1 = new COLRv1();
    $this.b4z_1 = false;
    $this.c4z_1 = IntIntMap.n2t();
    $this.d4z_1 = IntMap.v2s();
    $this.f4z_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_4().p2d(), 0.0);
    $this.g4z_1 = false;
    $this.h4z_1 = null;
    return $this;
  }
  yz(_set____db54di) {
    this.y4w_1.yz(_set____db54di);
  }
  zz() {
    return this.y4w_1.zz();
  }
  static i4z(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.j59(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  u4h(size, metrics) {
    return metrics.e4i(this.s4z(), size);
  }
  g4i(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.d51(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.p56_1;
    return metrics.n4i(tmp0_elvis_lhs == null ? this.f4z_1 : tmp0_elvis_lhs, size, codePoint);
  }
  t4j(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  n4z(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.nx_1;
    var codePointPeek = reader == null ? null : reader.vx(0);
    var tmp0_elvis_lhs = this.c51(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.q4i(size);
    path.b4t_1 = g.j26().s56_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.c57();
    tmp_0.c4t_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.u56();
    var bitmapEntry = g.e57();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.e54();
    path.d4t_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.i4y_1 / bitmapEntry.n53_1.t52_1;
      var scaleY = this.i4y_1 / bitmapEntry.n53_1.u52_1;
      path.e4t_1 = Vector2D.k2c(0.0, ((-bitmapEntry.o53_1 | 0) - bitmapEntry.y53() | 0) * scaleY);
      path.f4t_1 = Scale.v2h(scaleX, scaleY);
    }
    path.g4t_1 = Companion_getInstance_5().m2d_1.m2e(scale, scale);
    path.h4t_1 = scale;
    return path;
  }
  q4i(size) {
    return size / this.i4y_1;
  }
  p4z(key) {
    return this.t4y_1.f3(key);
  }
  q4z(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.t4y_1.h3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.u4y_1.h3(glyphID, codePoint);
  }
  r4z(codePoint, glyphID) {
  }
  s4z() {
    var tmp = this.e4z_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  t4z() {
    return this.d4x_1.t4z();
  }
  s3() {
    var tmp0_elvis_lhs = this.a4x_1;
    return tmp0_elvis_lhs == null ? this.t4z() : tmp0_elvis_lhs;
  }
  j4z() {
    this.k4z();
    this.z4z();
    this.a50();
    this.b50();
    this.x4z();
    if (!this.b4x_1) {
      if (!(this.m4z('CFF ') == null) && this.m4z('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.w4z('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.h4z_1 = CFF_instance.z4v(tmp111_safe_receiver);
        }
      }
      this.y4z();
      this.z50();
      this.c50();
      this.d50();
      this.y50();
      this.x50();
      this.f50();
      this.g50();
      this.h50();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.q4i(1.0);
    this_0.v4h_1 = 1.0;
    this_0.w4h_1 = this.m4y_1 * scale;
    this_0.x4h_1 = this.u4x_1 * scale;
    this_0.y4h_1 = 0.0 * scale;
    this_0.z4h_1 = this.v4x_1 * scale;
    this_0.a4i_1 = this.k4y_1 * scale;
    this_0.b4i_1 = this.w4x_1 * scale;
    this_0.c4i_1 = this.x4x_1 * scale;
    this_0.d4i_1 = this.i4y_1 * scale;
    tmp.e4z_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.s3() + ')';
  }
  u4z(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.s1s());
  }
  v4z(_this__u8e3s4) {
    return Companion_instance_24.k59(_this__u8e3s4.r1s(), _this__u8e3s4.r1s());
  }
  w4z(name) {
    var tmp109_safe_receiver = this.m4z(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.h52();
  }
  x4z() {
    var tmp111_safe_receiver = this.w4z('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_23.k52(tmp111_safe_receiver, this.d4x_1);
    }
    return Unit_instance;
  }
  y4z() {
    var tmp111_safe_receiver = this.w4z('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.q4y_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.o1s(imul(bytesPerEntry, this.f4x_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.q4y_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.y1s(this.f4x_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.a1t(this.f4x_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.g4y_1 = tmp_1;
    }
    return Unit_instance;
  }
  z4z() {
    var tmp111_safe_receiver = this.w4z('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.s1s() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.s1s() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.h4y_1 = this.v4z(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.u1s();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.u1s();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.s1s();
      this.i4y_1 = tmp111_safe_receiver.s1s();
      var created = tmp111_safe_receiver.v1s().z3(new Long(1000, 0));
      var modified = tmp111_safe_receiver.v1s().z3(new Long(1000, 0));
      this.j4y_1 = tmp111_safe_receiver.r1s();
      this.k4y_1 = tmp111_safe_receiver.r1s();
      this.l4y_1 = tmp111_safe_receiver.r1s();
      this.m4y_1 = tmp111_safe_receiver.r1s();
      this.n4y_1 = tmp111_safe_receiver.s1s();
      this.o4y_1 = tmp111_safe_receiver.s1s();
      this.p4y_1 = tmp111_safe_receiver.r1s();
      this.q4y_1 = tmp111_safe_receiver.r1s();
      this.r4y_1 = tmp111_safe_receiver.r1s();
    }
    return Unit_instance;
  }
  a50() {
    var tmp111_safe_receiver = this.w4z('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.v4z(tmp111_safe_receiver);
      this.f4x_1 = tmp111_safe_receiver.s1s();
      this.g4x_1 = tmp111_safe_receiver.s1s();
      this.h4x_1 = tmp111_safe_receiver.s1s();
      this.i4x_1 = tmp111_safe_receiver.s1s();
      this.j4x_1 = tmp111_safe_receiver.s1s();
      this.k4x_1 = tmp111_safe_receiver.s1s();
      this.l4x_1 = tmp111_safe_receiver.s1s();
      this.m4x_1 = tmp111_safe_receiver.s1s();
      this.n4x_1 = tmp111_safe_receiver.s1s();
      this.o4x_1 = tmp111_safe_receiver.s1s();
      this.p4x_1 = tmp111_safe_receiver.s1s();
      this.q4x_1 = tmp111_safe_receiver.s1s();
      this.r4x_1 = tmp111_safe_receiver.s1s();
      this.s4x_1 = tmp111_safe_receiver.s1s();
    }
    return Unit_instance;
  }
  b50() {
    var tmp111_safe_receiver = this.w4z('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.t4x_1 = this.v4z(tmp111_safe_receiver);
      this.u4x_1 = tmp111_safe_receiver.r1s();
      this.v4x_1 = tmp111_safe_receiver.r1s();
      this.w4x_1 = tmp111_safe_receiver.r1s();
      this.x4x_1 = tmp111_safe_receiver.s1s();
      this.y4x_1 = tmp111_safe_receiver.r1s();
      this.z4x_1 = tmp111_safe_receiver.r1s();
      this.a4y_1 = tmp111_safe_receiver.r1s();
      this.b4y_1 = tmp111_safe_receiver.r1s();
      this.c4y_1 = tmp111_safe_receiver.r1s();
      this.d4y_1 = tmp111_safe_receiver.r1s();
      tmp111_safe_receiver.r1s();
      tmp111_safe_receiver.r1s();
      tmp111_safe_receiver.r1s();
      tmp111_safe_receiver.r1s();
      this.e4y_1 = tmp111_safe_receiver.r1s();
      this.f4y_1 = tmp111_safe_receiver.s1s();
    }
    return Unit_instance;
  }
  c50() {
    var tmp111_safe_receiver = this.w4z('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.f4y_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.b2_1;
      var last_0 = this_0.c2_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.s1s(), tmp111_safe_receiver.r1s());
          destination.h(tmp$ret$0);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).i52_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.f4x_1 - this.f4y_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.b2_1;
      var last_1 = this_1.c2_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.r1s());
          destination_0.h(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.s4y_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  d50() {
    var tmp111_safe_receiver = this.w4z('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.s1s();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.s1s();
          var numPalettes = tmp111_safe_receiver.s1s();
          var numColorRecords = tmp111_safe_receiver.s1s();
          var colorRecordsArrayOffset = tmp111_safe_receiver.u1s();
          var colorRecordIndices = tmp111_safe_receiver.x1s(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.u1s() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.u1s() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.u1s() : -1;
          tmp111_safe_receiver.g1s(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.z1s(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_22().q4e(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.h(tmp$ret$0);
          }

          tmp.z4y_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  e50(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.q1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s(), _this__u8e3s4.p1s());
  }
  f50() {
    var tmp111_safe_receiver = this.w4z('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.s1s();
      var minorVersion = tmp111_safe_receiver.s1s();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.u1s();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.u1s(), tmp111_safe_receiver.u1s(), tmp111_safe_receiver.u1s(), tmp111_safe_receiver.u1s(), this.e50(tmp111_safe_receiver), this.e50(tmp111_safe_receiver), tmp111_safe_receiver.s1s(), tmp111_safe_receiver.s1s(), tmp111_safe_receiver.q1s(), tmp111_safe_receiver.q1s(), tmp111_safe_receiver.q1s(), tmp111_safe_receiver.p1s());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.b1();
        while (_iterator__ex2g4s.c1()) {
          var cbi = _iterator__ex2g4s.d1();
          var glyphCount = cbi.s52_1 - cbi.r52_1 | 0;
          tmp111_safe_receiver.g1s(cbi.l52_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.n52_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.s1s(), tmp111_safe_receiver.s1s(), tmp111_safe_receiver.u1s());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.g1s(cbi.l52_1 + subtable.w58_1 | 0);
            var indexFormat = tmp111_safe_receiver.s1s();
            var imageFormat = tmp111_safe_receiver.s1s();
            var imageDataOffset = tmp111_safe_receiver.u1s();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.x58() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.u1s() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.u58_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.w4y_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.h3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  g50() {
    var tmp111_safe_receiver = this.w4z('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.s1s();
      var minorVersion = tmp111_safe_receiver.s1s();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.w4y_1.l3().b1();
        while (_iterator__ex2g4s.c1()) {
          var i = _iterator__ex2g4s.d1();
          var format = i.k53_1;
          if (format === 17 || format === 18) {
            i.o53_1 = tmp111_safe_receiver.q1s();
            i.p53_1 = tmp111_safe_receiver.q1s();
            i.q53_1 = tmp111_safe_receiver.p1s();
            i.r53_1 = tmp111_safe_receiver.p1s();
            i.s53_1 = tmp111_safe_receiver.q1s();
            i.t53_1 = format === 18 ? tmp111_safe_receiver.p1s() : i.q53_1;
            i.u53_1 = format === 18 ? tmp111_safe_receiver.p1s() : i.r53_1;
            i.v53_1 = format === 18 ? tmp111_safe_receiver.p1s() : i.s53_1;
          }
          var dataLen = tmp111_safe_receiver.u1s();
          i.w53_1 = tmp111_safe_receiver.j1s(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  h50() {
    var tmp111_safe_receiver = this.w4z('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.s1s();
      var flags = tmp111_safe_receiver.s1s();
      var numStrikes = tmp111_safe_receiver.u1s();
      var strikeOffsets = tmp111_safe_receiver.a1t(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.g1s(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.s1s(), tmp111_safe_receiver.s1s(), item, toIntArrayList(tmp111_safe_receiver.a1t(this.f4x_1 + 1 | 0)));
        destination.h(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.b1();
        if (!iterator.c1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.d1();
        if (!iterator.c1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.y58_1;
        do {
          var e = iterator.d1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.y58_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.c1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.f4x_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.b59_1.e1(n);
          var len = strike.b59_1.e1(n + 1 | 0) - offset | 0;
          var start = strike.a59_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.g1s(start);
          var originOffsetX = tmp111_safe_receiver.r1s();
          var originOffsetY = tmp111_safe_receiver.r1s();
          var graphicType = tmp111_safe_receiver.d1t(4);
          var bytes = tmp111_safe_receiver.j1s(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.w4y_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.y58_1, strike.y58_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.w53_1 = bytes;
          this_0.h3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  i50(_this__u8e3s4) {
    return _this__u8e3s4.u1s();
  }
  j50(_this__u8e3s4) {
    return _this__u8e3s4.s1s();
  }
  k50(_this__u8e3s4) {
    return _this__u8e3s4.r1s();
  }
  l50(_this__u8e3s4) {
    return _this__u8e3s4.s1s();
  }
  m50(_this__u8e3s4) {
    return _this__u8e3s4.t1s();
  }
  n50(_this__u8e3s4) {
    return _this__u8e3s4.u1s();
  }
  o50(_this__u8e3s4, isVar) {
    var xx = this.j51(_this__u8e3s4);
    var yx = this.j51(_this__u8e3s4);
    var xy = this.j51(_this__u8e3s4);
    var yy = this.j51(_this__u8e3s4);
    var dx = this.j51(_this__u8e3s4);
    var dy = this.j51(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  p50(_this__u8e3s4, out) {
    out.i54_1 = this.i51(_this__u8e3s4);
    out.j54_1 = _this__u8e3s4.s1s();
    out.k54_1 = this.i51(_this__u8e3s4);
    return out;
  }
  q50(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.p50(_this__u8e3s4, out) : $super.p50.call(this, _this__u8e3s4, out);
  }
  r50(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.q1s();
    var xMin = this.k50(_this__u8e3s4);
    var yMin = this.k50(_this__u8e3s4);
    var xMax = this.k50(_this__u8e3s4);
    var yMax = this.k50(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.i50(_this__u8e3s4);
    }
    return Companion_getInstance_4().d2i(xMin, yMin, xMax, yMax);
  }
  s50(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.r50(_this__u8e3s4, doVar) : $super.r50.call(this, _this__u8e3s4, doVar);
  }
  t50(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.q1s()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.s1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.q50(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  u50(glyphID, s, c, pal, level) {
    var nodeFormat = s.q1s();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_32().t51_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.q1s();
        var firstLayerIndex = s.u1s();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.a4z_1.n55_1[firstLayerIndex + n | 0];
            this.u50(glyphID, this.a4z_1.q55_1.l1s(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.s1s();
        var alpha = this.i51(s);
        if (isVar) {
          var varIndexBase = this.i50(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.be();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.z4y_1.e1(pal).d4e_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.r4q(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.m50(s);
        var x0 = this.k50(s);
        var y0 = this.k50(s);
        var x1 = this.k50(s);
        var y1 = this.k50(s);
        var x2 = this.k50(s);
        var y2 = this.k50(s);
        var colorLine = this.t50(s.l1s(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.i50(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.f54_1;
        var transform = Companion_getInstance_5().m2d_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.h54(paint_0, this.z4y_1.e1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.r4q(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.m50(s);
        var x0_0 = this.k50(s);
        var y0_1 = this.k50(s);
        var radius0 = this.j50(s);
        var x1_0 = this.k50(s);
        var y1_1 = this.k50(s);
        var radius1 = this.j50(s);
        var colorLine_0 = this.t50(s.l1s(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.i50(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.f54_1;
        var transform_0 = Companion_getInstance_5().m2d_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.h54(paint_1, this.z4y_1.e1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.r4q(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.m50(s);
        var centerX = this.k50(s);
        var centerY = this.k50(s);
        var startAngle = this.i51(s);
        var endAngle = this.i51(s);
        if (isVar) {
          var varIndexBase_2 = this.i50(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
      case 10:
        var paint_2 = this.m50(s);
        var glyphID_0 = s.s1s();
        var colr = this.y4y_1.e1(glyphID_0);
        var glyph = this.h51(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4q();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.j26().s56_1), '\n'));
            }
            c.l59(glyph.j26().s56_1);
            this.u50(glyphID_0, s.l1s(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.g4r();
        }

        break;
      case 11:
        var glyphID_1 = s.s1s();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
      case 12:
      case 13:
        var paint_3 = this.m50(s);
        var transform_1 = this.m50(s);
        var affine = this.o50(s.l1s(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4q();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.s4s(affine);
          this.u50(glyphID, s.l1s(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.g4r();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.m50(s);
        var dx = FWord__toDouble_impl_53j5qp(this.u4z(s));
        var dy = FWord__toDouble_impl_53j5qp(this.u4z(s));
        if (isVar) {
          var varIndexBase_3 = this.i50(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4q();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.q4s(dx, -dy);
          this.u50(glyphID, s.l1s(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.g4r();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.m50(s);
        var scaleX = this.i51(s);
        var scaleY = this.i51(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.k50(s);
          var centerY_0 = this.k50(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.be();
        }

        if (isVar) {
          var varIndexBase_4 = this.i50(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.y4q();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.m59(numberToDouble(scaleX), numberToDouble(scaleY));
          this.u50(glyphID, s.l1s(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.g4r();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.m50(s);
        var scale = this.i51(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.k50(s);
          var centerY_1 = this.k50(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.i50(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.m50(s);
        var angle = this.i51(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.k50(s);
          var centerY_2 = this.k50(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.i50(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.m50(s);
        var xSkewAngle = this.i51(s);
        var ySkewAngle = this.i51(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.k50(s);
          var centerY_3 = this.k50(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.i50(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
      case 32:
        var sourcePaint = this.m50(s);
        var compositeMode = s.q1s();
        var backdropPaint = this.m50(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.be('An operation is not implemented: ' + reason);
    }
  }
  v50(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.s1s();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.s1s();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.y1s(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.s1s();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.b2_1;
        var last_0 = this_3.c2_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.s1s(), _this__u8e3s4.s1s(), _this__u8e3s4.s1s());
            destination.h(tmp$ret$4);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.b1();
        if (!iterator.c1())
          throw NoSuchElementException.v6();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.d1();
        var maxValue = it.e59_1 + it.f59_1 | 0;
        while (iterator.c1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.d1();
          var v = it_0.e59_1 + it_0.f59_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.b1();
        while (_iterator__ex2g4s.c1()) {
          var range = _iterator__ex2g4s.d1();
          var inductionVariable_1 = range.c59_1;
          var last_1 = range.d59_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.c59_1 | 0;
              glyphArray[range.e59_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.be('An operation is not implemented: ' + reason);
    }
  }
  w50(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.v50(_this__u8e3s4, hintedCount) : $super.v50.call(this, _this__u8e3s4, hintedCount);
  }
  x50() {
    var tmp111_safe_receiver = this.w4z('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.s1s();
      var minorVersion = tmp111_safe_receiver.s1s();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.h5(toString_0(message));
      }
      var scriptListOffset = this.l50(tmp111_safe_receiver);
      var featureListOffset = this.l50(tmp111_safe_receiver);
      var lookupListOffset = this.l50(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.n50(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.l1s(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.s1s();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.d1t(4);
          var scriptOffset = this.l50(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.l1s(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.s1s();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.d1t(4);
          var featureOffset = this.l50(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.l1s(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.s1s();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.m2o((coerceAtLeast(this_3.f2() - this_3.g2() | 0, 0) / this_3.d2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.g2();
      var nestedLast = this_3.f2();
      var stepArg = this_3.d2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.l50(this_2);
          this_4.s2o(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.b1();
      while (_iterator__ex2g4s.c1()) {
        var lookupOffset = _iterator__ex2g4s.d1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.l1s(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.s1s();
        var lookupFlag = this_5.s1s();
        var subTableCount = this_5.s1s();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.x1s(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.s1s();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.l1s(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.s1s();
              var coverageOffset = this.l50(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.r1s();
                  var coverageTable = this.w50(this_8.l1s(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.c4z_1.m2t(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.s1s();
                  var coverageTable_0 = this.w50(this_8.l1s(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.y1s(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.c4z_1.m2t(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.h5(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.s1s();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.h5(toString_0(message_1));
              }

              var coverageOffset_0 = this.l50(this_8);
              var ligatureSetCount = this_8.s1s();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.y1s(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.v50(this_8.l1s(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.oc();
                  var codePoint = this.b51(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.l1s(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.s1s();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.y1s(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.l1s(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.s1s();
                    var componentCount = this_19.s1s();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.y1s(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.b51(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_11();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.cy(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.h3(ligature, value);
                  }
                  this.d4z_1.p2s(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_30().x4w_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.x2x(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.y2x(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  y50() {
    var tmp111_safe_receiver = this.w4z('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.s1s();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.s1s();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.u1s();
          var layerRecordsOffset = tmp111_safe_receiver.u1s();
          var numLayerRecords = tmp111_safe_receiver.s1s();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.l1s(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.s1s(), this_0.s1s());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.x4y_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.l1s(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.s1s(), this_1.s1s(), this_1.s1s());
              this.y4y_1.p2s(info.y56_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.n50(tmp111_safe_receiver);
            var layerListOffset = this.n50(tmp111_safe_receiver);
            var clipListOffset = this.n50(tmp111_safe_receiver);
            var varIdxMapOffset = this.n50(tmp111_safe_receiver);
            var varStoreOffset = this.n50(tmp111_safe_receiver);
            this.a4z_1.s55_1.k3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.l1s(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.l1s(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.u1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.n50(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.l1s(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.l1s(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.l1s(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.a4z_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.l1s(clipListOffset);
              var format = s.q1s();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.u1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.s1s();
                var endGlyphID = s.s1s();
                var clipBoxOffset = this.m50(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.a4z_1.s55_1.m2t(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.l1s(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.u1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.s1s();
              var paint = this.n50(this_3);
              this.y4y_1.p2s(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  z50() {
    var tmp111_safe_receiver = this.w4z('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.s1s();
      var numTables = tmp111_safe_receiver.s1s();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.b2_1;
      var last = this_0.c2_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.s1s(), tmp111_safe_receiver.s1s(), tmp111_safe_receiver.u1s());
          destination.h(tmp$ret$0);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.b1();
      while (_iterator__ex2g4s.c1()) {
        var table = _iterator__ex2g4s.d1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.l1s(table.i59_1);
        var format = $this$run.s1s();
        try {
          switch (format) {
            case 0:
              var length = $this$run.s1s();
              var language = $this$run.s1s();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.o1s(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.r4z(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.s1s();
              var language_0 = $this$run.s1s();
              var segCount = $this$run.s1s() / 2 | 0;
              var searchRangeS = $this$run.s1s();
              var entrySelector = $this$run.s1s();
              var rangeShift = $this$run.s1s();
              var endCount = $this$run.y1s(segCount);
              $this$run.s1s();
              var startCount = $this$run.y1s(segCount);
              var idDelta = $this$run.x1s(segCount);
              var rangeOffsetPos = $this$run.h1s();
              var idRangeOffset = $this$run.y1s(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.l1s(glyphIndexOffset).s1s();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.q4z(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.s1s();
              var language_1 = $this$run.s1s();
              var firstCode = $this$run.s1s();
              var entryCount = $this$run.s1s();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.q4z(codePoint, $this$run.s1s());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.s1s();
              var length_2 = $this$run.u1s();
              var language_2 = $this$run.u1s();
              var numGroups = $this$run.u1s();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.u1s();
                  var endCharCode = $this$run.u1s();
                  var startGlyphId = $this$run.u1s();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.q4z(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  a51(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.u4y_1.f3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  b51(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.a51(charIndex, default_0) : $super.a51.call(this, charIndex, default_0);
  }
  c51(reader, codePoint, cache) {
    var g = this.f51(codePoint);
    var skipCount = 1;
    if (this.c4x_1 && !(g == null)) {
      var subs = this.d4z_1.e1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.ox();
        var b = subs.f52_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.ay(0, count);
            var replacement = subs.g52_1.f3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.h51(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.zx(skipCount);
    }
    return g;
  }
  d51(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.c51(reader, codePoint, cache) : $super.c51.call(this, reader, codePoint, cache);
  }
  e51(codePoint, cache) {
    var tmp134_safe_receiver = this.p4z(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.g51(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  f51(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.e51(codePoint, cache) : $super.e51.call(this, codePoint, cache);
  }
  g51(index, cache, codePoint) {
    var cff = this.h4z_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.v4y_1;
      var res = this_0.e1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.q4v(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.u4u_1), new GlyphGraphicsPath(index, gvector.t4u_1));
        this_0.p2s(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.e1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.g4y_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.g4y_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.v4y_1.e1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.m4z('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.h52();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.l51($this$runTable.l1s(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.s4y_1.e1(index).i52_1, true);
    }
    var glyph = tmp;
    if (cache && !this.b4z_1) {
      this.v4y_1.p2s(index, glyph);
    }
    return glyph;
  }
  h51(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.g51(index, cache, codePoint) : $super.g51.call(this, index, cache, codePoint);
  }
  i51(_this__u8e3s4) {
    var v = _this__u8e3s4.r1s();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  j51(_this__u8e3s4) {
    var v = _this__u8e3s4.u1s();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  k51(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.p1s();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.q1s();
    } else if (word && signed) {
      tmp = _this__u8e3s4.r1s();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.s1s();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  l51(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.r1s();
    var xMin = _this__u8e3s4.r1s();
    var yMin = _this__u8e3s4.r1s();
    var xMax = _this__u8e3s4.r1s();
    var yMax = _this__u8e3s4.r1s();
    var advanceWidth = this.s4y_1.e1(index).i52_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.j1();
      do {
        var flags = _this__u8e3s4.s1s();
        var glyphIndex = _this__u8e3s4.s1s();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.k51(_this__u8e3s4, signed, words);
        var y = this.k51(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.i51(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.i51(_this__u8e3s4);
          scaleY = this.i51(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.i51(_this__u8e3s4);
          scale01 = this.i51(_this__u8e3s4);
          scale10 = this.i51(_this__u8e3s4);
          scaleY = this.i51(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.h51(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.h(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.s1s();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.s1s();
      var instructions = _this__u8e3s4.o1s(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.m2o();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.q1s();
        flags_0.s2o(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.q1s();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.s2o(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.sz(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.q1s();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.r1s() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.d2p(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static w4m(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_30();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.i4z(d, extName, onlyReadMetadata, enableLigatures);
    $this.v4m_1 = LinkedHashMap.oc();
    $this.j4z();
    return $this;
  }
  k4z() {
    this.v4m_1.j3(Companion_instance_23.l4z(this.z4w_1.m1s()));
  }
  m4z(name) {
    return this.v4m_1.f3(name);
  }
}
class Companion_15 {
  constructor() {
    this.s51_1 = 26;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t51_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.u51_1 = fillArrayVal(Array(26), null);
    this.v51_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.w51_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.x51_1 = tmp_5;
    this.y51_1 = null;
  }
  t4z() {
    var tmp0_elvis_lhs = this.z51(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.z51(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  a52(nameId) {
    if (this.u51_1[nameId] == null) {
      var nameLength = this.w51_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.y51_1).b1t(this.v51_1[nameId], nameLength, this.x51_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.f();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.cc(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.u51_1[nameId] = tmp;
    }
    return this.u51_1[nameId];
  }
  z51(nameId) {
    return this.a52(nameId.d52_1);
  }
  e52() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.pc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.z51(element);
      result.h3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.e52()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.f52_1 = maxSequence;
    this.g52_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.m51_1 = id;
    this.n51_1 = checksum;
    this.o51_1 = offset;
    this.p51_1 = length;
    this.q51_1 = null;
    var tmp = this;
    tmp.r51_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  h52() {
    return _get_ss__ndcawb(this).uz();
  }
  toString() {
    return 'Table(id=' + this.m51_1 + ', checksum=' + this.n51_1 + ', offset=' + this.o51_1 + ', length=' + this.p51_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.m51_1);
    result = imul(result, 31) + this.n51_1 | 0;
    result = imul(result, 31) + this.o51_1 | 0;
    result = imul(result, 31) + this.p51_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.m51_1 === tmp0_other_with_cast.m51_1))
      return false;
    if (!(this.n51_1 === tmp0_other_with_cast.n51_1))
      return false;
    if (!(this.o51_1 === tmp0_other_with_cast.o51_1))
      return false;
    if (!(this.p51_1 === tmp0_other_with_cast.p51_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.i52_1 = advanceWidth;
    this.j52_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.i52_1 + ', lsb=' + this.j52_1 + ')';
  }
  hashCode() {
    var result = this.i52_1;
    result = imul(result, 31) + this.j52_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.i52_1 === tmp0_other_with_cast.i52_1))
      return false;
    if (!(this.j52_1 === tmp0_other_with_cast.j52_1))
      return false;
    return true;
  }
}
class Companion_17 {
  k52(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.s1s();
    var count = s.s1s();
    var stringOffset = s.s1s();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.s1s();
        var encodingId = s.s1s();
        var languageId = s.s1s();
        var nameId = s.s1s();
        var length = s.s1s();
        var offset = s.s1s();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.w51_1[nameId] === -1) {
          info.v51_1[nameId] = stringOffset + offset | 0;
          info.w51_1[nameId] = length;
          info.x51_1[nameId] = charset;
          info.y51_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  l4z(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.u1s() === 1953784678) {
      var majorVersion = s.s1s();
      var minorVersion = s.s1s();
      var numFonts = s.u1s();
      var tableDirectoryOffsets = s.a1t(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.u1s();
        var dsigLength = s.u1s();
        var dsigOffset = s.u1s();
      }
      s.g1s(tableDirectoryOffsets[0]);
    } else {
      s.n1s(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.s1s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.s1s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.s1s();
    var searchRange = s.s1s();
    var entrySelector = s.s1s();
    var rangeShift = s.s1s();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.b2_1;
    var last = this_2.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Table(s.d1t(4), s.u1s(), s.u1s(), s.u1s());
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.oc();
    var _iterator__ex2g4s = tables.b1();
    while (_iterator__ex2g4s.c1()) {
      var table = _iterator__ex2g4s.d1();
      var tmp = table;
      tmp.q51_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.m51_1;
      tablesByName.h3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.d52_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.l52_1 = indexSubTableArrayOffset;
    this.m52_1 = indexTablesSize;
    this.n52_1 = numberofIndexSubTables;
    this.o52_1 = colorRef;
    this.p52_1 = hori;
    this.q52_1 = vert;
    this.r52_1 = startGlyphIndex;
    this.s52_1 = endGlyphIndex;
    this.t52_1 = ppemX;
    this.u52_1 = ppemY;
    this.v52_1 = bitDepth;
    this.w52_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.l52_1 + ', indexTablesSize=' + this.m52_1 + ', numberofIndexSubTables=' + this.n52_1 + ', colorRef=' + this.o52_1 + ', hori=' + this.p52_1.toString() + ', vert=' + this.q52_1.toString() + ', startGlyphIndex=' + this.r52_1 + ', endGlyphIndex=' + this.s52_1 + ', ppemX=' + this.t52_1 + ', ppemY=' + this.u52_1 + ', bitDepth=' + this.v52_1 + ', flags=' + this.w52_1 + ')';
  }
  hashCode() {
    var result = this.l52_1;
    result = imul(result, 31) + this.m52_1 | 0;
    result = imul(result, 31) + this.n52_1 | 0;
    result = imul(result, 31) + this.o52_1 | 0;
    result = imul(result, 31) + this.p52_1.hashCode() | 0;
    result = imul(result, 31) + this.q52_1.hashCode() | 0;
    result = imul(result, 31) + this.r52_1 | 0;
    result = imul(result, 31) + this.s52_1 | 0;
    result = imul(result, 31) + this.t52_1 | 0;
    result = imul(result, 31) + this.u52_1 | 0;
    result = imul(result, 31) + this.v52_1 | 0;
    result = imul(result, 31) + this.w52_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.l52_1 === tmp0_other_with_cast.l52_1))
      return false;
    if (!(this.m52_1 === tmp0_other_with_cast.m52_1))
      return false;
    if (!(this.n52_1 === tmp0_other_with_cast.n52_1))
      return false;
    if (!(this.o52_1 === tmp0_other_with_cast.o52_1))
      return false;
    if (!this.p52_1.equals(tmp0_other_with_cast.p52_1))
      return false;
    if (!this.q52_1.equals(tmp0_other_with_cast.q52_1))
      return false;
    if (!(this.r52_1 === tmp0_other_with_cast.r52_1))
      return false;
    if (!(this.s52_1 === tmp0_other_with_cast.s52_1))
      return false;
    if (!(this.t52_1 === tmp0_other_with_cast.t52_1))
      return false;
    if (!(this.u52_1 === tmp0_other_with_cast.u52_1))
      return false;
    if (!(this.v52_1 === tmp0_other_with_cast.v52_1))
      return false;
    if (!(this.w52_1 === tmp0_other_with_cast.w52_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.x52_1 = ascender;
    this.y52_1 = descender;
    this.z52_1 = widthMax;
    this.a53_1 = caretSlopeNumerator;
    this.b53_1 = caretSlopeDenominator;
    this.c53_1 = caretOffset;
    this.d53_1 = minOriginSB;
    this.e53_1 = minAdvanceSB;
    this.f53_1 = maxBeforeBL;
    this.g53_1 = minAfterBL;
    this.h53_1 = pad1;
    this.i53_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.x52_1 + ', descender=' + this.y52_1 + ', widthMax=' + this.z52_1 + ', caretSlopeNumerator=' + this.a53_1 + ', caretSlopeDenominator=' + this.b53_1 + ', caretOffset=' + this.c53_1 + ', minOriginSB=' + this.d53_1 + ', minAdvanceSB=' + this.e53_1 + ', maxBeforeBL=' + this.f53_1 + ', minAfterBL=' + this.g53_1 + ', pad1=' + this.h53_1 + ', pad2=' + this.i53_1 + ')';
  }
  hashCode() {
    var result = this.x52_1;
    result = imul(result, 31) + this.y52_1 | 0;
    result = imul(result, 31) + this.z52_1 | 0;
    result = imul(result, 31) + this.a53_1 | 0;
    result = imul(result, 31) + this.b53_1 | 0;
    result = imul(result, 31) + this.c53_1 | 0;
    result = imul(result, 31) + this.d53_1 | 0;
    result = imul(result, 31) + this.e53_1 | 0;
    result = imul(result, 31) + this.f53_1 | 0;
    result = imul(result, 31) + this.g53_1 | 0;
    result = imul(result, 31) + this.h53_1 | 0;
    result = imul(result, 31) + this.i53_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.x52_1 === tmp0_other_with_cast.x52_1))
      return false;
    if (!(this.y52_1 === tmp0_other_with_cast.y52_1))
      return false;
    if (!(this.z52_1 === tmp0_other_with_cast.z52_1))
      return false;
    if (!(this.a53_1 === tmp0_other_with_cast.a53_1))
      return false;
    if (!(this.b53_1 === tmp0_other_with_cast.b53_1))
      return false;
    if (!(this.c53_1 === tmp0_other_with_cast.c53_1))
      return false;
    if (!(this.d53_1 === tmp0_other_with_cast.d53_1))
      return false;
    if (!(this.e53_1 === tmp0_other_with_cast.e53_1))
      return false;
    if (!(this.f53_1 === tmp0_other_with_cast.f53_1))
      return false;
    if (!(this.g53_1 === tmp0_other_with_cast.g53_1))
      return false;
    if (!(this.h53_1 === tmp0_other_with_cast.h53_1))
      return false;
    if (!(this.i53_1 === tmp0_other_with_cast.i53_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.j53_1 = glyphID;
    this.k53_1 = imageFormat;
    this.l53_1 = offset;
    this.m53_1 = size;
    this.n53_1 = info;
    this.o53_1 = height;
    this.p53_1 = width;
    this.q53_1 = horiBearingX;
    this.r53_1 = horiBearingY;
    this.s53_1 = horiAdvance;
    this.t53_1 = vertBearingX;
    this.u53_1 = vertBearingY;
    this.v53_1 = vertAdvance;
    this.w53_1 = null;
    this.x53_1 = null;
  }
  y53() {
    return this.n53_1.p52_1.y52_1;
  }
  z53(cache) {
    var tmp0_elvis_lhs = this.x53_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().d54(toSyncStream(ensureNotNull(this.w53_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.x53_1 = bmp;
    return bmp;
  }
  e54(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.z53(cache) : $super.z53.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.j53_1 + ', imageFormat=' + this.k53_1 + ', offset=' + this.l53_1 + ', size=' + this.m53_1 + ', info=' + this.n53_1.toString() + ', height=' + this.o53_1 + ', width=' + this.p53_1 + ', horiBearingX=' + this.q53_1 + ', horiBearingY=' + this.r53_1 + ', horiAdvance=' + this.s53_1 + ', vertBearingX=' + this.t53_1 + ', vertBearingY=' + this.u53_1 + ', vertAdvance=' + this.v53_1 + ')';
  }
  hashCode() {
    var result = this.j53_1;
    result = imul(result, 31) + this.k53_1 | 0;
    result = imul(result, 31) + this.l53_1 | 0;
    result = imul(result, 31) + this.m53_1 | 0;
    result = imul(result, 31) + this.n53_1.hashCode() | 0;
    result = imul(result, 31) + this.o53_1 | 0;
    result = imul(result, 31) + this.p53_1 | 0;
    result = imul(result, 31) + this.q53_1 | 0;
    result = imul(result, 31) + this.r53_1 | 0;
    result = imul(result, 31) + this.s53_1 | 0;
    result = imul(result, 31) + this.t53_1 | 0;
    result = imul(result, 31) + this.u53_1 | 0;
    result = imul(result, 31) + this.v53_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.j53_1 === tmp0_other_with_cast.j53_1))
      return false;
    if (!(this.k53_1 === tmp0_other_with_cast.k53_1))
      return false;
    if (!(this.l53_1 === tmp0_other_with_cast.l53_1))
      return false;
    if (!(this.m53_1 === tmp0_other_with_cast.m53_1))
      return false;
    if (!this.n53_1.equals(tmp0_other_with_cast.n53_1))
      return false;
    if (!(this.o53_1 === tmp0_other_with_cast.o53_1))
      return false;
    if (!(this.p53_1 === tmp0_other_with_cast.p53_1))
      return false;
    if (!(this.q53_1 === tmp0_other_with_cast.q53_1))
      return false;
    if (!(this.r53_1 === tmp0_other_with_cast.r53_1))
      return false;
    if (!(this.s53_1 === tmp0_other_with_cast.s53_1))
      return false;
    if (!(this.t53_1 === tmp0_other_with_cast.t53_1))
      return false;
    if (!(this.u53_1 === tmp0_other_with_cast.u53_1))
      return false;
    if (!(this.v53_1 === tmp0_other_with_cast.v53_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.f54_1 = cycle;
    this.g54_1 = stops;
  }
  h54(paint, palette) {
    var _iterator__ex2g4s = this.g54_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var stop = _iterator__ex2g4s.d1();
      paint.j55(stop.i54_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.d4e_1, stop.j54_1), stop.k54_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.f54_1.toString() + ', stops=' + toString_0(this.g54_1) + ')';
  }
  hashCode() {
    var result = this.f54_1.hashCode();
    result = imul(result, 31) + hashCode(this.g54_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.f54_1.equals(tmp0_other_with_cast.f54_1))
      return false;
    if (!equals(this.g54_1, tmp0_other_with_cast.g54_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.i54_1 = stopOffset;
    this.j54_1 = paletteIndex;
    this.k54_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.m55_1 = this.r3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.n55_1 = layerList;
    this.o55_1 = s;
    this.p55_1 = sBaseOffset;
    this.q55_1 = sLayerOffset;
    this.r55_1 = sClipOffset;
    this.s55_1 = IntIntMap.n2t();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.t55_1 = x;
    this.u55_1 = y;
    this.v55_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.t55_1 + ', y=' + this.u55_1 + ', onCurve=' + this.v55_1 + ')';
  }
  hashCode() {
    var result = this.t55_1;
    result = imul(result, 31) + this.u55_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v55_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.t55_1 === tmp0_other_with_cast.t55_1))
      return false;
    if (!(this.u55_1 === tmp0_other_with_cast.u55_1))
      return false;
    if (!(this.v55_1 === tmp0_other_with_cast.v55_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.w55_1 = glyph;
    this.x55_1 = x;
    this.y55_1 = y;
    this.z55_1 = scaleX;
    this.a56_1 = scale01;
    this.b56_1 = scale10;
    this.c56_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.w55_1) + ', x=' + this.x55_1 + ', y=' + this.y55_1 + ', scaleX=' + this.z55_1 + ', scale01=' + this.a56_1 + ', scale10=' + this.b56_1 + ', scaleY=' + this.c56_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.w55_1);
    result = imul(result, 31) + this.x55_1 | 0;
    result = imul(result, 31) + this.y55_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.z55_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a56_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b56_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.w55_1, tmp0_other_with_cast.w55_1))
      return false;
    if (!(this.x55_1 === tmp0_other_with_cast.x55_1))
      return false;
    if (!(this.y55_1 === tmp0_other_with_cast.y55_1))
      return false;
    if (!equals(this.z55_1, tmp0_other_with_cast.z55_1))
      return false;
    if (!equals(this.a56_1, tmp0_other_with_cast.a56_1))
      return false;
    if (!equals(this.b56_1, tmp0_other_with_cast.b56_1))
      return false;
    if (!equals(this.c56_1, tmp0_other_with_cast.c56_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.f56_1 = $outer;
    this.d56_1 = glyphID;
    this.e56_1 = paletteIndex;
  }
  g56(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.f56_1.z4y_1, pal).d4e_1);
    var index = this.e56_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.f1() : false) {
      tmp = this_0.e1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().i42_1);
    }
    return tmp.a4g_1;
  }
  h56() {
    return this.g56(0);
  }
  i56(pal) {
    var tmp135_safe_receiver = this.f56_1.h51(this.d56_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.j26();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.s56_1, null, new RGBA(this.g56(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.d56_1 + ', ' + this.e56_1 + ', ' + RGBA__toString_impl_4lw6dp(this.h56()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.t56(pal) : $super.t56.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.x56_1 = $outer;
    this.v56_1 = glyphID;
    this.w56_1 = paint;
  }
  t56(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.x56_1.a4z_1.p55_1.l1s(this.w56_1);
    try {
      this.x56_1.u50(this.v56_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.n4n();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.v56_1 + '][' + this.w56_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.b57_1 = $outer;
    this.y56_1 = glyphID;
    this.z56_1 = firstLayerIndex;
    this.a57_1 = numLayers;
  }
  e1(index) {
    return this.b57_1.x4y_1[this.z56_1 + index | 0];
  }
  u4v() {
    var tmp = 0;
    var tmp_0 = this.a57_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.e1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  t56(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.u4v();
    var destination = ArrayList.j1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.i56(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.y56_1 + '][' + this.a57_1 + '](' + toString_0(this.u4v()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.r56_1 = glpyhIndex;
    this.s56_1 = path;
  }
  t3h(p) {
    this.s56_1.t3h(p);
  }
  g3i(p) {
    this.s56_1.g3i(p);
  }
  h3i(c, a) {
    this.s56_1.h3i(c, a);
  }
  u3h(c1, c2, a) {
    this.s56_1.u3h(c1, c2, a);
  }
  n6() {
    this.s56_1.n6();
  }
  w3q(p0, p1) {
    this.s56_1.w3q(p0, p1);
  }
  x3q(rect) {
    this.s56_1.x3q(rect);
  }
  y3q(pos, size) {
    this.s56_1.y3q(pos, size);
  }
  z3q(x, y, width, height) {
    this.s56_1.z3q(x, y, width, height);
  }
  a3r(center, r, start, end, counterclockwise) {
    this.s56_1.a3r(center, r, start, end, counterclockwise);
  }
  c3r(center, radius) {
    this.s56_1.c3r(center, radius);
  }
  d3r(delta) {
    this.s56_1.d3r(delta);
  }
  e3r(delta) {
    this.s56_1.e3r(delta);
  }
  a2j(m) {
    return this.s56_1.a2j(m);
  }
  u3q() {
    return this.s56_1.u3q();
  }
  v3q() {
    return this.s56_1.c3i_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.r56_1 + ', "' + toSvgPathString(this.s56_1) + '")';
  }
  hashCode() {
    var result = this.r56_1;
    result = imul(result, 31) + this.s56_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.r56_1 === tmp0_other_with_cast.r56_1))
      return false;
    if (!this.s56_1.equals(tmp0_other_with_cast.s56_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.q56_1 = $outer;
    this.j56_1 = index;
    this.k56_1 = xMin;
    this.l56_1 = yMin;
    this.m56_1 = xMax;
    this.n56_1 = yMax;
    this.o56_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.k56_1;
    var yMin_0 = this.l56_1;
    var xMax_0 = this.m56_1;
    var yMax_0 = this.n56_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.q56_1.a4z_1.r55_1;
      var glyphIDToClipOffset = this.q56_1.a4z_1.s55_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.hp(this.j56_1)) {
        var clipOffset = glyphIDToClipOffset.e1(this.j56_1);
        tmp_0 = this.q56_1.s50(sClipOffset.l1s(clipOffset));
      } else {
        var tmp137_safe_receiver = this.c57();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.u56();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.d57();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.r2a());
        xMax_0 = numberToInt(bounds.s2a());
        yMin_0 = numberToInt(bounds.t2a());
        yMax_0 = numberToInt(bounds.u2a());
      }
    }
    var size = this.q56_1.i4y_1;
    var scale = this.q56_1.q4i(size);
    tmp.p56_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_4().c2i(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.o56_1 * scale);
  }
  c57() {
    return this.q56_1.y4y_1.e1(this.j56_1);
  }
  e57() {
    return this.q56_1.w4y_1.f3(this.j56_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.q57_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.n57_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.n57_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.w55_1.j26().s56_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.w55_1.j56_1, new VectorPath(IntArrayList.m2o(gpath.w3h_1.f1()), DoubleArrayList.g2p(gpath.x3h_1.f1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_5().p2d().l2e(item.z55_1, item.c56_1).r2e(item.x55_1, -item.y55_1 | 0);
      this_1.s56_1.k3r(item.w55_1.j26().s56_1, m);
      destination.h(this_1);
    }
    tmp.o57_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.o57_1;
    var n = 0;
    while (n < this_2.f1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.e1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.s56_1.w3h_1.f1() | 0;
      dataSize = dataSize + gpath_0.s56_1.x3h_1.f1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.m2o(commandsSize), DoubleArrayList.g2p(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.o57_1;
    var n_0 = 0;
    while (n_0 < this_4.f1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.e1(_unary__edvuaz_0);
      this_3.s56_1.l3r(it.s56_1);
    }
    tmp_0.p57_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.o56_1 + '](' + toString_0(this.n57_1) + ')';
  }
  j26() {
    return this.p57_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.b58_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.z57_1 = path;
    this.a58_1 = listOf_0(this.z57_1);
  }
  j26() {
    return this.z57_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.r58_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.k58_1 = contoursIndices;
    this.l58_1 = flags;
    this.m58_1 = xPos;
    this.n58_1 = yPos;
    this.o58_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.r58_1;
    var inductionVariable = 0;
    var last = this.k58_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.k58_1[n] + 1 | 0;
        var cend = this.k58_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.m2o(commandSize), DoubleArrayList.g2p(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.r58_1;
    var inductionVariable_0 = 0;
    var last_0 = this.k58_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.k58_1[n_0] + 1 | 0;
        var cend_0 = this.k58_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.s58(cend_0, this_1.e4x_1[0]);
        var next = this.s58(cstart_0, this_1.e4x_1[1]);
        if (curr.v55_1) {
          this_0.t3h(Vector2D.x2c(curr.t55_1, -curr.u55_1 | 0));
        } else if (next.v55_1) {
          this_0.t3h(Vector2D.x2c(next.t55_1, -next.u55_1 | 0));
        } else {
          this_0.t3h(Vector2D.x2c(imul(curr.t55_1 + next.t55_1 | 0, numberToInt(0.5)), -numberToInt((curr.u55_1 + next.u55_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.s58(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.e4x_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.v55_1) {
              this_0.g3i(Vector2D.x2c(curr.t55_1, -curr.u55_1 | 0));
            } else {
              var prev2X = prev.t55_1;
              var prev2Y = prev.u55_1;
              var next2X = next.t55_1;
              var next2Y = next.u55_1;
              if (!prev.v55_1) {
                prev2X = numberToInt((curr.t55_1 + prev.t55_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.u55_1 + prev.u55_1 | 0) * 0.5);
                this_0.g3i(Vector2D.x2c(prev2X, -prev2Y | 0));
              }
              if (!next.v55_1) {
                next2X = numberToInt((curr.t55_1 + next.t55_1 | 0) * 0.5);
                next2Y = numberToInt((curr.u55_1 + next.u55_1 | 0) * 0.5);
              }
              this_0.g3i(Vector2D.x2c(prev2X, -prev2Y | 0));
              this_0.h3i(Vector2D.x2c(curr.t55_1, -curr.u55_1 | 0), Vector2D.x2c(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.n6();
      }
       while (inductionVariable_0 < last_0);
    tmp.p58_1 = this_0;
    this.q58_1 = listOf_0(this.p58_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.o58_1 ? 'Dummy' : '') + '[' + this.j56_1 + '](advance=' + this.o56_1 + ') : ' + this.p58_1.toString();
  }
  t58(n) {
    return !((this.l58_1[n] & 1) === 0);
  }
  s58(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.t55_1 = this.m58_1[n];
    out.u55_1 = this.n58_1[n];
    out.v55_1 = this.t58(n);
    return out;
  }
  j26() {
    return this.p58_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.u58_1 = firstGlyphIndex;
    this.v58_1 = lastGlyphIndex;
    this.w58_1 = additionalOffsetToIndexSubtable;
  }
  x58() {
    return this.v58_1 - this.u58_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.u58_1 + ', lastGlyphIndex=' + this.v58_1 + ', additionalOffsetToIndexSubtable=' + this.w58_1 + ')';
  }
  hashCode() {
    var result = this.u58_1;
    result = imul(result, 31) + this.v58_1 | 0;
    result = imul(result, 31) + this.w58_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.u58_1 === tmp0_other_with_cast.u58_1))
      return false;
    if (!(this.v58_1 === tmp0_other_with_cast.v58_1))
      return false;
    if (!(this.w58_1 === tmp0_other_with_cast.w58_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.y58_1 = ppem;
    this.z58_1 = ppi;
    this.a59_1 = strikeOffset;
    this.b59_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.y58_1 + ', ppi=' + this.z58_1 + ', strikeOffset=' + this.a59_1 + ', offsets=' + this.b59_1.toString() + ')';
  }
  hashCode() {
    var result = this.y58_1;
    result = imul(result, 31) + this.z58_1 | 0;
    result = imul(result, 31) + this.a59_1 | 0;
    result = imul(result, 31) + this.b59_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.y58_1 === tmp0_other_with_cast.y58_1))
      return false;
    if (!(this.z58_1 === tmp0_other_with_cast.z58_1))
      return false;
    if (!(this.a59_1 === tmp0_other_with_cast.a59_1))
      return false;
    if (!this.b59_1.equals(tmp0_other_with_cast.b59_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.c59_1 = start;
    this.d59_1 = endInclusive;
    this.e59_1 = index;
    this.f59_1 = (this.d59_1 - this.c59_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.c59_1 + ', endInclusive=' + this.d59_1 + ', index=' + this.e59_1 + ')';
  }
  hashCode() {
    var result = this.c59_1;
    result = imul(result, 31) + this.d59_1 | 0;
    result = imul(result, 31) + this.e59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.c59_1 === tmp0_other_with_cast.c59_1))
      return false;
    if (!(this.d59_1 === tmp0_other_with_cast.d59_1))
      return false;
    if (!(this.e59_1 === tmp0_other_with_cast.e59_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.g59_1 = platformId;
    this.h59_1 = encodingId;
    this.i59_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.g59_1 + ', encodingId=' + this.h59_1 + ', offset=' + this.i59_1 + ')';
  }
  hashCode() {
    var result = this.g59_1;
    result = imul(result, 31) + this.h59_1 | 0;
    result = imul(result, 31) + this.i59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.g59_1 === tmp0_other_with_cast.g59_1))
      return false;
    if (!(this.h59_1 === tmp0_other_with_cast.h59_1))
      return false;
    if (!(this.i59_1 === tmp0_other_with_cast.i59_1))
      return false;
    return true;
  }
}
class Companion_18 {
  k59(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_25 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.p59_1;
      destination.h3(tmp$ret$0, element);
    }
    tmp.r59_1 = destination;
  }
  e1(index) {
    var tmp0_elvis_lhs = this.r59_1.f3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.p59_1 = id;
    this.q59_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.s59_1 = Companion_getInstance_14().ey('EXIF');
  }
  t59(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx.bind(VOID, this, ss, info, debug), $completion);
  }
  u59(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.t59(ss, info, debug, $completion) : $super.t59.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.v59_1 = function_0;
  }
  aj(a, b) {
    return this.v59_1(a, b);
  }
  compare(a, b) {
    return this.aj(a, b);
  }
  o4() {
    return this.v59_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.j1();
      var tmp0_iterator = frames.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.c5a_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.b1();
      while (tmp0_iterator_0.c1()) {
        var item = tmp0_iterator_0.d1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.e5a_1;
        destination_0.h(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.o5a_1 = frames;
    this.p5a_1 = direction;
    this.q5a_1 = name;
    this.r5a_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.o5a_1);
    tmp_1.s5a_1 = tmp0_elvis_lhs == null ? ImageFrame.t5a(0) : tmp0_elvis_lhs;
  }
}
class Companion_20 {
  u5a(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_29.v5a(item);
      destination.h(tmp$ret$0);
    }
    return new ImageData(destination);
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.w5a_1 = function_0;
  }
  aj(a, b) {
    return this.w5a_1(a, b);
  }
  compare(a, b) {
    return this.aj(a, b);
  }
  o4() {
    return this.w5a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.d2m();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.e2m();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.z5a_1 = new Mixin();
    this.a5b_1 = frames;
    this.b5b_1 = loopCount;
    this.c5b_1 = width;
    this.d5b_1 = height;
    this.e5b_1 = layers;
    this.f5b_1 = animations;
    this.g5b_1 = name;
    this.h5b_1 = new ImageAnimation(this.a5b_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.f5b_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.q5a_1;
      destination.h3(tmp$ret$0, element);
    }
    tmp_1.i5b_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.a5b_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.pc(capacity_0);
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.s3();
      destination_0.h3(tmp$ret$3, element_0);
    }
    tmp_2.j5b_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.a5b_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp_3.k5b_1 = sortedWith(this_2, tmp$ret$6);
  }
  yz(_set____db54di) {
    this.z5a_1.yz(_set____db54di);
  }
  zz() {
    return this.z5a_1.zz();
  }
  l5b() {
    var tmp173_safe_receiver = firstOrNull_0(this.k5b_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.x5a();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.a5b_1) + ')';
  }
}
class Companion_21 {
  m5b(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_26.u5a([item]);
      destination.h(tmp$ret$0);
    }
    return new ImageDataContainer(destination);
  }
  u5a(bitmaps) {
    return Companion_instance_27.m5b(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.n5b_1 = imageDatas;
    var tmp = this;
    tmp.o5b_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p5b_1 = lazy(ImageDataContainer$default$delegate$lambda(this));
  }
  q5b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o5b_1;
    imageDatasByName$factory();
    return this_0.s1();
  }
  r5b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p5b_1;
    default$factory();
    return this_0.s1();
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_28 = this;
    this.i4k_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.j4k_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.k4k_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_38();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.s5b_1 = filename;
    this.t5b_1 = width;
    this.u5b_1 = height;
    this.v5b_1 = premultiplied;
    this.w5b_1 = asumePremultiplied;
    this.x5b_1 = requestedMaxSize;
    this.y5b_1 = debug;
    this.z5b_1 = preferKotlinDecoder;
    this.a5c_1 = tryNativeDecode;
    this.b5c_1 = format;
    this.c5c_1 = out;
    this.d5c_1 = extra;
  }
  yz(_set____db54di) {
    this.d5c_1 = _set____db54di;
  }
  zz() {
    return this.d5c_1;
  }
  e5c() {
    return this;
  }
  f5c() {
    var tmp0_elvis_lhs = this.v5b_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  g5c(filename) {
    return this.h5c(filename);
  }
  i5c(file) {
    return this.g5c(get_baseName(file));
  }
  j5c(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  h5c(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.s5b_1 : filename;
    width = width === VOID ? this.t5b_1 : width;
    height = height === VOID ? this.u5b_1 : height;
    premultiplied = premultiplied === VOID ? this.v5b_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.w5b_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.x5b_1 : requestedMaxSize;
    debug = debug === VOID ? this.y5b_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.z5b_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.a5c_1 : tryNativeDecode;
    format = format === VOID ? this.b5c_1 : format;
    out = out === VOID ? this.c5c_1 : out;
    extra = extra === VOID ? this.d5c_1 : extra;
    return $super === VOID ? this.j5c(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.j5c.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.s5b_1 + ', width=' + this.t5b_1 + ', height=' + this.u5b_1 + ', premultiplied=' + this.v5b_1 + ', asumePremultiplied=' + this.w5b_1 + ', requestedMaxSize=' + this.x5b_1 + ', debug=' + this.y5b_1 + ', preferKotlinDecoder=' + this.z5b_1 + ', tryNativeDecode=' + this.a5c_1 + ', format=' + toString(this.b5c_1) + ', out=' + toString(this.c5c_1) + ', extra=' + toString(this.d5c_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s5b_1);
    result = imul(result, 31) + (this.t5b_1 == null ? 0 : this.t5b_1) | 0;
    result = imul(result, 31) + (this.u5b_1 == null ? 0 : this.u5b_1) | 0;
    result = imul(result, 31) + (this.v5b_1 == null ? 0 : getBooleanHashCode(this.v5b_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w5b_1) | 0;
    result = imul(result, 31) + (this.x5b_1 == null ? 0 : this.x5b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y5b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z5b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a5c_1) | 0;
    result = imul(result, 31) + (this.b5c_1 == null ? 0 : hashCode(this.b5c_1)) | 0;
    result = imul(result, 31) + (this.c5c_1 == null ? 0 : hashCode(this.c5c_1)) | 0;
    result = imul(result, 31) + (this.d5c_1 == null ? 0 : hashCode(this.d5c_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.s5b_1 === tmp0_other_with_cast.s5b_1))
      return false;
    if (!(this.t5b_1 == tmp0_other_with_cast.t5b_1))
      return false;
    if (!(this.u5b_1 == tmp0_other_with_cast.u5b_1))
      return false;
    if (!(this.v5b_1 == tmp0_other_with_cast.v5b_1))
      return false;
    if (!(this.w5b_1 === tmp0_other_with_cast.w5b_1))
      return false;
    if (!(this.x5b_1 == tmp0_other_with_cast.x5b_1))
      return false;
    if (!(this.y5b_1 === tmp0_other_with_cast.y5b_1))
      return false;
    if (!(this.z5b_1 === tmp0_other_with_cast.z5b_1))
      return false;
    if (!(this.a5c_1 === tmp0_other_with_cast.a5c_1))
      return false;
    if (!equals(this.b5c_1, tmp0_other_with_cast.b5c_1))
      return false;
    if (!equals(this.c5c_1, tmp0_other_with_cast.c5c_1))
      return false;
    if (!equals(this.d5c_1, tmp0_other_with_cast.d5c_1))
      return false;
    return true;
  }
}
class ImageFormat {
  static l5c(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.a54_1 = mimeType;
    var tmp = $this;
    tmp.b54_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp_0.c54_1 = toSet(destination);
    return $this;
  }
  e5c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b54_1;
    decodingProps$factory();
    return this_0.s1();
  }
  n5c(s, props) {
    return this.m5c(s, props).r5b();
  }
  o5c(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.k5c(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.q5c_1 = bmp.z3y_1;
      this_0.r5c_1 = bmp.a3z_1;
      this_0.s5c_1 = bmp.b3z_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  k5c(s, props) {
    return this.n5c(s, props).l5b();
  }
  t5c(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.o5c(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  u5c(s, props) {
    return this.k5c(s, props);
  }
  d54(s, props, $super) {
    props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
    return $super === VOID ? this.u5c(s, props) : $super.u5c.call(this, s, props);
  }
  v5c(data, props) {
    return this.k5c(openSync(data), props);
  }
  w5c(data, props, $completion) {
    return this.v5c(data, props);
  }
  x5c(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, this, file, props), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.c54_1) + ')';
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static c5d(formats) {
    var $this = this.l5c(['']);
    $this.b5d_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static d5d(formats) {
    return this.c5d(toList_1(formats));
  }
  e5d(_set____db54di) {
    var this_0 = this.b5d_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  f5d() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.b5d_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  g5d() {
    return this.f5d();
  }
  toString() {
    return 'ImageFormats(' + this.g5d().f1() + ')' + toString_0(this.g5d());
  }
  o5c(s, props) {
    if (this.g5d().h1())
      return null;
    var _iterator__ex2g4s = this.g5d().b1();
    $l$loop_0: while (_iterator__ex2g4s.c1()) {
      var format = _iterator__ex2g4s.d1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.o5c(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  m5c(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.g5d().b1();
      while (_iterator__ex2g4s.c1()) {
        var format = _iterator__ex2g4s.d1();
        if (format.t5c(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.m5c(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.la('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
}
class ImageFormatsMutable extends ImageFormats {
  static m5d() {
    var $this = this.d5d([]);
    $this.l5d_1 = new NonRecursiveLock();
    return $this;
  }
  static n5d(formats) {
    var $this = this.m5d();
    $this.o5d(formats.slice());
    return $this;
  }
  o5d(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.l5d_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.e5d(minus(plus_0(this.f5d(), formats), this));
    return this;
  }
}
class Companion_23 {
  p5d(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.q5d(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  v5a(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.p5d(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.p5d.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static t5a(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.z59_1 = new Mixin();
    $this.a5a_1 = index;
    $this.b5a_1 = fastTime;
    $this.c5a_1 = layerData;
    $this.d5a_1 = firstOrNull_0($this.c5a_1);
    return $this;
  }
  yz(_set____db54di) {
    this.z59_1.yz(_set____db54di);
  }
  zz() {
    return this.z59_1.zz();
  }
  r5d() {
    return toDuration_0(this.b5a_1);
  }
  static q5d(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.t5a(index, get_fast(time), layerData);
  }
  s5d() {
    var tmp177_safe_receiver = this.d5a_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.n5a_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  t5d() {
    var tmp178_safe_receiver = this.d5a_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.f5a_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  u5d() {
    var tmp179_safe_receiver = this.d5a_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.g5a_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  y5a() {
    var tmp180_safe_receiver = this.d5a_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.h5a_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  d2m() {
    return this.s5d().a3k_1;
  }
  e2m() {
    return this.s5d().b3k_1;
  }
  x5a() {
    var tmp182_safe_receiver = this.d5a_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.x5a();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  s3() {
    return this.s5d().v3j_1;
  }
  toString() {
    return 'ImageFrame(' + this.s5d().toString() + ', time=' + Duration__toString_impl_8d916b(this.r5d()) + ', targetX=' + this.t5d() + ', targetY=' + this.u5d() + ', main=' + this.y5a() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.e5a_1 = layer;
    this.f5a_1 = targetX;
    this.g5a_1 = targetY;
    this.h5a_1 = main;
    this.i5a_1 = includeInAtlas;
    this.j5a_1 = tilemap;
    this.k5a_1 = ninePatchSlice;
    this.l5a_1 = null;
    this.m5a_1 = null;
    this.n5a_1 = slice;
  }
  d2m() {
    return this.n5a_1.a3k_1;
  }
  e2m() {
    return this.n5a_1.b3k_1;
  }
  x5a() {
    if (get_bmp(this.n5a_1).z3y_1 === this.d2m() && get_bmp(this.n5a_1).a3z_1 === this.e2m())
      return get_bmp(this.n5a_1);
    if (this.l5a_1 == null)
      this.l5a_1 = extract_0(this.n5a_1);
    return ensureNotNull(this.l5a_1);
  }
}
class ImageInfo {
  constructor() {
    this.p5c_1 = new Mixin();
    this.q5c_1 = 0;
    this.r5c_1 = 0;
    this.s5c_1 = 8;
  }
  yz(_set____db54di) {
    this.p5c_1.yz(_set____db54di);
  }
  zz() {
    return this.p5c_1.zz();
  }
  toString() {
    var tmp = this.q5c_1;
    var tmp_0 = this.r5c_1;
    var tmp_1 = this.s5c_1;
    var tmp183_safe_receiver = this.zz();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_30 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v5d_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.w59_1 = index;
    this.x59_1 = name;
    this.y59_1 = type;
  }
}
class NativeImageFormatProvider {
  y5d(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0.bind(VOID, this, data, props), $completion);
  }
  s5e(_this__u8e3s4, props) {
    return this.u5e(_this__u8e3s4, props);
  }
  u5e(image, props) {
    return this.t5e(toBitmap_0(image.a3x()), props);
  }
  r5e(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1.bind(VOID, this, vfs, path, props), $completion);
  }
  w5c(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme.bind(VOID, this, data, props), $completion);
  }
  v5e(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0.bind(VOID, this, file, props), $completion);
  }
  x5c(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1.bind(VOID, this, file, props), $completion);
  }
  z4c(width, height, premultiplied) {
    return BitmapNativeImage.a5f(Bitmap32.s3y(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  y4c(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.z4c(bmp.z3y_1, bmp.a3z_1, bmp.f3z_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.d3z_1;
    if (true) {
      this_0.m3z();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.v46(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.b5f(bmp, Companion_getInstance_6().c2a_1);
      }finally {
        ctx.m1a();
      }
    }finally {
      result = true ? this_0.o3z(rect) : 0;
    }
    return this_0;
  }
  w5e(bmp) {
    return BitmapNativeImage.q5e(bmp);
  }
  t5e(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.w5b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.v5b_1 == null || props.v5b_1 === _this__u8e3s4.f3z_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.w46();
    if (props.w5b_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.f3z_1 && props.v5b_1 === false) {
      out.e4a();
    } else if (_this__u8e3s4.f3z_1 && props.v5b_1 === true) {
      out.d4a();
    }
    return this.w5e(out);
  }
  w5d(_this__u8e3s4, props) {
    return new NativeImageResult(this.t5e(_this__u8e3s4, props));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  y5d(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt.bind(VOID, this, data, props), $completion);
  }
  z5d(bmp) {
    return BitmapNativeImage.q5e(bmp);
  }
  x5d(bmp, props) {
    var bmp32 = bmp.w46();
    return new NativeImageResult(this.z5d(props.w5b_1 ? asumePremultiplied(bmp32) : props.f5c() ? bmp32.a4a() : bmp32.b4a()));
  }
  z4c(width, height, premultiplied) {
    return this.z5d(Bitmap32.s3y(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  y4c(bmp) {
    return this.z5d(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.z3y_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.a3z_1 : originalHeight;
    this.x5e_1 = image;
    this.y5e_1 = originalWidth;
    this.z5e_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.x5e_1.toString() + ', originalWidth=' + this.y5e_1 + ', originalHeight=' + this.z5e_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x5e_1);
    result = imul(result, 31) + this.y5e_1 | 0;
    result = imul(result, 31) + this.z5e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.x5e_1, tmp0_other_with_cast.x5e_1))
      return false;
    if (!(this.y5e_1 === tmp0_other_with_cast.y5e_1))
      return false;
    if (!(this.z5e_1 === tmp0_other_with_cast.z5e_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static a5f(bitmap) {
    var $this = this.x4c(bitmap.z3y_1, bitmap.a3z_1, bitmap, bitmap.f3z_1);
    $this.o5e_1 = bitmap;
    $this.p5e_1 = $this.o5e_1.p3y_1;
    return $this;
  }
  s3() {
    return 'BitmapNativeImage';
  }
  static q5e(bitmap) {
    return this.a5f(bitmap.w46());
  }
  v46(antialiasing) {
    return this.o5e_1.v46(antialiasing);
  }
  l3z() {
    return this.o5e_1;
  }
  w3z(x, y, width, height, out, offset) {
    return this.o5e_1.w3z(x, y, width, height, out, offset);
  }
  y3z(x, y, width, height, out, offset) {
    return this.o5e_1.y3z(x, y, width, height, out, offset);
  }
  z3z(x, y, v) {
    return this.o5e_1.z3z(x, y, v);
  }
  x3z(x, y) {
    return this.o5e_1.x3z(x, y);
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.e5f_1;
      destination.h3(tmp$ret$0, element);
    }
    tmp.g5f_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.h5f_1 = startingRow;
    this.i5f_1 = startingCol;
    this.j5f_1 = rowIncrement;
    this.k5f_1 = colIncrement;
    this.l5f_1 = blockHeight;
    this.m5f_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.k5f_1;
    var tmp$ret$0 = log2(x);
    tmp.n5f_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.h5f_1 + ', startingCol=' + this.i5f_1 + ', rowIncrement=' + this.j5f_1 + ', colIncrement=' + this.k5f_1 + ', blockHeight=' + this.l5f_1 + ', blockWidth=' + this.m5f_1 + ')';
  }
  hashCode() {
    var result = this.h5f_1;
    result = imul(result, 31) + this.i5f_1 | 0;
    result = imul(result, 31) + this.j5f_1 | 0;
    result = imul(result, 31) + this.k5f_1 | 0;
    result = imul(result, 31) + this.l5f_1 | 0;
    result = imul(result, 31) + this.m5f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.h5f_1 === tmp0_other_with_cast.h5f_1))
      return false;
    if (!(this.i5f_1 === tmp0_other_with_cast.i5f_1))
      return false;
    if (!(this.j5f_1 === tmp0_other_with_cast.j5f_1))
      return false;
    if (!(this.k5f_1 === tmp0_other_with_cast.k5f_1))
      return false;
    if (!(this.l5f_1 === tmp0_other_with_cast.l5f_1))
      return false;
    if (!(this.m5f_1 === tmp0_other_with_cast.m5f_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.e5f_1 = id;
    this.f5f_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.o5f_1 = width;
    this.p5f_1 = height;
    this.q5f_1 = bitsPerChannel;
    this.r5f_1 = colorspace;
    this.s5f_1 = compressionmethod;
    this.t5f_1 = filtermethod;
    this.u5f_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.r5f_1.r3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.v5f_1 = tmp_0;
    this.w5f_1 = imul(imul(this.o5f_1, this.v5f_1), this.q5f_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.x5f_1 = header;
    this.y5f_1 = _UByteArrayInt___init__impl__xif7bu_0(this.x5f_1.w5f_1);
    this.z5f_1 = _UByteArrayInt___init__impl__xif7bu_0(this.x5f_1.w5f_1);
    this.a5g_1 = Companion_instance_11.h4a(this.x5f_1.o5f_1);
  }
  k5g() {
    var temp = this.z5f_1;
    this.z5f_1 = this.y5f_1;
    this.y5f_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.l5g_1 = $data;
    this.m5g_1 = $info;
  }
  ce($completion) {
    return EXIF_getInstance().u59(openAsync(readAll_0(this.l5g_1)), this.m5g_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static n5g() {
    PNG_instance = null;
    var $this = this.l5c(['png']);
    PNG_instance = $this;
    $this.e5g_1 = -1991225785;
    $this.f5g_1 = 218765834;
    $this.g5g_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.h5g_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  o5c(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  m5c(s, props) {
    var tmp = Companion_instance_27;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.u5a([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  o5g(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  i5g(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.o5g(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.be('An operation is not implemented: ' + reason);
    }
  }
  j5g(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.i5g(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.i5g.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  s5g(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.r5g(n, yFloat));
      }
       while (!(n === x1));
  }
  t5g(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.p3y_1);
    var inductionVariable = rect.t2a();
    var last = rect.u2a();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.z3y_1);
        this.s5g(cols, offset, rect.r2a(), rect.s2a() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  u5g(bmp, rect, $super) {
    rect = rect === VOID ? bmp.r3y_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.t5g(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.t5g.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.p5g_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().i40_1);
  }
  q5g(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.p5g_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  r5g(x, y) {
    return this.p5g_1;
  }
  s5g(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.p5g_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_26 {
  constructor() {
    this.v5g_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.w5g_1 = Companion_instance_14.w4g(256);
  }
  y5g(fill, state) {
    fill.z5g(this.w5g_1);
    this.x5g_1 = fill.a5h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().m2d_1.e2f(fill.v54_1).e2f(state.s4i_1));
    return this;
  }
  b5h(x, y) {
    return _get_fill__d6ivc8(this).c5h(Vector2D.v2e(x, y));
  }
  r5g(x, y) {
    return color(this, this.b5h(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.d5h_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.e5h_1 = 0.0;
    this.f5h_1 = 0.0;
    this.g5h_1 = 0.0;
    this.h5h_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.i5h_1 = get_bmp(tmp$ret$0);
    this.j5h_1 = Companion_getInstance_5().m2d_1;
    this.k5h_1 = true;
    this.l5h_1 = Companion_getInstance_5().m2d_1;
  }
  m5h(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.d5h_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.p5h_1, fill.q5h_1);
    _set_texture__qu271y(this, fill.t5h_1);
    this.j5h_1 = fill.o5h_1;
    this.k5h_1 = fill.r5h_1;
    this.l5h_1 = Companion_getInstance_5().m2d_1.x2e(state.s4i_1).x2e(fill.o5h_1).y2e();
    return this;
  }
  u5h(x, y) {
    return this.i5h_1.f40(x, y);
  }
  v5h(x, y) {
    return this.i5h_1.p48(numberToInt(x), numberToInt(y));
  }
  r5g(x, y) {
    var mat = this.l5h_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.v2e(x, y);
      if (mat.p2a()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2c(mat.e2e(p.a2a_1, p.b2a_1), mat.h2e(p.a2a_1, p.b2a_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.v2e(this.g5h_1, this.h5h_1);
    var p_0 = Vector2D.k2c(this_0.a2a_1 * that.a2a_1, this_0.b2a_1 * that.b2a_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.d5h_1, p_0);
    var that_0 = Vector2D.v2e(this.e5h_1, this.f5h_1);
    var t = Vector2D.k2c(this_1.a2a_1 * that_0.a2a_1, this_1.b2a_1 * that_0.b2a_1);
    return this.k5h_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.u5h(t.a2a_1, t.b2a_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.v5h(t.a2a_1, t.b2a_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  r5g(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  s5g(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_27 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.g2p() : stops;
    colors = colors === VOID ? IntArrayList.m2o() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_5().m2d_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().r29_1 : startAngle;
    this.l54_1 = kind;
    this.m54_1 = x0;
    this.n54_1 = y0;
    this.o54_1 = r0;
    this.p54_1 = x1;
    this.q54_1 = y1;
    this.r54_1 = r1;
    this.s54_1 = stops;
    this.t54_1 = colors;
    this.u54_1 = cycle;
    this.v54_1 = transform;
    this.w54_1 = interpolationMethod;
    this.x54_1 = units;
    this.y54_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_5().m2d_1.s2e(-this.m54_1, -this.n54_1).n2e(1.0 / clamp_1(Companion_getInstance_6().d2j(this.m54_1, this.n54_1, this.p54_1, this.q54_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_8();
    var x0_0 = this.m54_1;
    var y0_0 = this.n54_1;
    var x1_0 = this.p54_1;
    var y1_0 = this.q54_1;
    var up = Companion_getInstance_6().g2a_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.z54_1 = tmp_0.k2e(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.a55_1 = this.v54_1.y2e();
    this.b55_1 = Companion_getInstance_5().m2d_1.x2e(this.z54_1).x2e(this.a55_1);
    this.c55_1 = 2 * this.o54_1 * this.r54_1;
    this.d55_1 = this.w5h(this.o54_1);
    this.e55_1 = this.w5h(this.r54_1);
    this.f55_1 = this.n54_1 - this.q54_1;
    this.g55_1 = this.o54_1 - this.r54_1;
    this.h55_1 = this.m54_1 - this.p54_1;
    this.i55_1 = 1.0 / (this.w5h(this.o54_1 - this.r54_1) - this.w5h(this.m54_1 - this.p54_1) - this.w5h(this.n54_1 - this.q54_1));
  }
  r4s() {
    return this.v54_1;
  }
  z5g(out) {
    return _fillColors(Companion_instance_33, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.s54_1, this.t54_1, true);
  }
  j55(stop, color) {
    return this.x5h(stop, color);
  }
  x5h(stop, color) {
    this.s54_1.o2p(stop);
    this.t54_1.t2o(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  c5h(p) {
    var tmp;
    switch (this.l54_1.r3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.a55_1;
          if (this_0.p2a()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_6().q2k(Vector2D.k2c(this.m54_1, this.n54_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.a55_1;
          if (this_1.p2a()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.k2c(this_1.e2e(p.a2a_1, p.b2a_1), this_1.h2e(p.a2a_1, p.b2a_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.nl();
        var y = _destruct__k2r9zo.ol();
        var tmp_0 = -this.r54_1 * this.g55_1 + this.h55_1 * (this.p54_1 - x) + this.f55_1 * (this.q54_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.e55_1 * (this.w5h(this.m54_1 - x) + this.w5h(this.n54_1 - y)) - this.c55_1 * ((this.m54_1 - x) * (this.p54_1 - x) + (this.n54_1 - y) * (this.q54_1 - y)) + this.d55_1 * (this.w5h(this.p54_1 - x) + this.w5h(this.q54_1 - y)) - this.w5h(this.p54_1 * this.n54_1 - x * this.n54_1 - this.m54_1 * this.q54_1 + x * this.q54_1 + this.m54_1 * y - this.p54_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.i55_1;
        break;
      default:
        tmp = this.b55_1.d2e(p);
        break;
    }
    return this.u54_1.a5i(tmp);
  }
  w5h(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  uz() {
    return this.a5h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.v54_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.l54_1.r3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.m54_1 + ', ' + this.n54_1 + '], [' + this.p54_1 + ', ' + this.q54_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.m54_1 + ', ' + this.n54_1 + ', ' + this.o54_1 + '], [' + this.p54_1 + ', ' + this.q54_1 + ', ' + this.r54_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.m54_1 + ', ' + this.n54_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.bc(tmp);
    this_0.bc(', stops=' + this.s54_1.toString() + ', colors=' + colorsToString_0(this, this.t54_1) + ', cycle=' + this.u54_1.toString() + ', transform=' + this.v54_1.toString() + ', interpolationMethod=' + this.w54_1.toString() + ', units=' + this.x54_1.toString() + ')');
    return this_0.toString();
  }
  b5i(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  a5h(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.l54_1 : kind;
    x0 = x0 === VOID ? this.m54_1 : x0;
    y0 = y0 === VOID ? this.n54_1 : y0;
    r0 = r0 === VOID ? this.o54_1 : r0;
    x1 = x1 === VOID ? this.p54_1 : x1;
    y1 = y1 === VOID ? this.q54_1 : y1;
    r1 = r1 === VOID ? this.r54_1 : r1;
    stops = stops === VOID ? this.s54_1 : stops;
    colors = colors === VOID ? this.t54_1 : colors;
    cycle = cycle === VOID ? this.u54_1 : cycle;
    transform = transform === VOID ? this.v54_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.w54_1 : interpolationMethod;
    units = units === VOID ? this.x54_1 : units;
    startAngle = startAngle === VOID ? this.y54_1 : startAngle;
    return $super === VOID ? this.b5i(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.b5i.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.l54_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.m54_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n54_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o54_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p54_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q54_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r54_1) | 0;
    result = imul(result, 31) + this.s54_1.hashCode() | 0;
    result = imul(result, 31) + this.t54_1.hashCode() | 0;
    result = imul(result, 31) + this.u54_1.hashCode() | 0;
    result = imul(result, 31) + this.v54_1.hashCode() | 0;
    result = imul(result, 31) + this.w54_1.hashCode() | 0;
    result = imul(result, 31) + this.x54_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.y54_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.l54_1.equals(tmp0_other_with_cast.l54_1))
      return false;
    if (!equals(this.m54_1, tmp0_other_with_cast.m54_1))
      return false;
    if (!equals(this.n54_1, tmp0_other_with_cast.n54_1))
      return false;
    if (!equals(this.o54_1, tmp0_other_with_cast.o54_1))
      return false;
    if (!equals(this.p54_1, tmp0_other_with_cast.p54_1))
      return false;
    if (!equals(this.q54_1, tmp0_other_with_cast.q54_1))
      return false;
    if (!equals(this.r54_1, tmp0_other_with_cast.r54_1))
      return false;
    if (!this.s54_1.equals(tmp0_other_with_cast.s54_1))
      return false;
    if (!this.t54_1.equals(tmp0_other_with_cast.t54_1))
      return false;
    if (!this.u54_1.equals(tmp0_other_with_cast.u54_1))
      return false;
    if (!this.v54_1.equals(tmp0_other_with_cast.v54_1))
      return false;
    if (!this.w54_1.equals(tmp0_other_with_cast.w54_1))
      return false;
    if (!this.x54_1.equals(tmp0_other_with_cast.x54_1))
      return false;
    if (!equals(this.y54_1, tmp0_other_with_cast.y54_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  uz() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_5().m2d_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.n5h_1 = bitmap;
    this.o5h_1 = transform;
    this.p5h_1 = cycleX;
    this.q5h_1 = cycleY;
    this.r5h_1 = smooth;
    this.s5h_1 = units;
    this.t5h_1 = this.n5h_1.l3z();
  }
  r4s() {
    return this.o5h_1;
  }
  c5i() {
    return this.p5h_1.d5i();
  }
  e5i() {
    return this.q5h_1.d5i();
  }
  uz() {
    return this.f5i(VOID, this.o5h_1);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.n5h_1) + ', cycle=(' + this.p5h_1.toString() + ', ' + this.q5h_1.toString() + '), smooth=' + this.r5h_1 + ', transform=' + this.o5h_1.toString() + ')';
  }
  g5i(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  f5i(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.n5h_1 : bitmap;
    transform = transform === VOID ? this.o5h_1 : transform;
    cycleX = cycleX === VOID ? this.p5h_1 : cycleX;
    cycleY = cycleY === VOID ? this.q5h_1 : cycleY;
    smooth = smooth === VOID ? this.r5h_1 : smooth;
    units = units === VOID ? this.s5h_1 : units;
    return $super === VOID ? this.g5i(bitmap, transform, cycleX, cycleY, smooth, units) : $super.g5i.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.n5h_1);
    result = imul(result, 31) + this.o5h_1.hashCode() | 0;
    result = imul(result, 31) + this.p5h_1.hashCode() | 0;
    result = imul(result, 31) + this.q5h_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r5h_1) | 0;
    result = imul(result, 31) + this.s5h_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.n5h_1, tmp0_other_with_cast.n5h_1))
      return false;
    if (!this.o5h_1.equals(tmp0_other_with_cast.o5h_1))
      return false;
    if (!this.p5h_1.equals(tmp0_other_with_cast.p5h_1))
      return false;
    if (!this.q5h_1.equals(tmp0_other_with_cast.q5h_1))
      return false;
    if (!(this.r5h_1 === tmp0_other_with_cast.r5h_1))
      return false;
    if (!this.s5h_1.equals(tmp0_other_with_cast.s5h_1))
      return false;
    return true;
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_34 = this;
    this.h5i_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.i5i_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.j5i_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.k5i_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l5i_1 = [new VerticalAlign(this.h5i_1), new VerticalAlign(this.i5i_1), new VerticalAlign(this.k5i_1), new VerticalAlign(this.j5i_1)];
    this.m5i_1 = toList_1(this.l5i_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_44();
    this.n5i_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.n5i_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.n5i_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.n5i_1, other);
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_35 = this;
    this.o5i_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.p5i_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.q5i_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.r5i_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s5i_1 = [new HorizontalAlign(this.p5i_1), new HorizontalAlign(this.q5i_1), new HorizontalAlign(this.r5i_1), new HorizontalAlign(this.o5i_1)];
    this.t5i_1 = toList_1(this.s5i_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_45();
    this.u5i_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.u5i_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.u5i_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.u5i_1, other);
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_36 = this;
    this.f4o_1 = listOf([new HorizontalAlign(Companion_getInstance_45().p5i_1), new HorizontalAlign(Companion_getInstance_45().q5i_1), new HorizontalAlign(Companion_getInstance_45().r5i_1), new HorizontalAlign(Companion_getInstance_45().o5i_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.f4o_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.u5i_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_44().h5i_1);
      destination.h(tmp$ret$0);
    }
    tmp.g4o_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.f4o_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var item_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.u5i_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_44().k5i_1);
      destination_0.h(tmp$ret$3);
    }
    tmp_0.h4o_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.f4o_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.b1();
    while (tmp0_iterator_1.c1()) {
      var item_1 = tmp0_iterator_1.d1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.u5i_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_44().i5i_1);
      destination_1.h(tmp$ret$6);
    }
    tmp_1.i4o_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.f4o_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.b1();
    while (tmp0_iterator_2.c1()) {
      var item_2 = tmp0_iterator_2.d1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.u5i_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_44().j5i_1);
      destination_2.h(tmp$ret$9);
    }
    tmp_2.j4o_1 = destination_2;
    this.k4o_1 = plus(plus(plus(this.g4o_1, this.h4o_1), this.i4o_1), this.j4o_1);
    this.l4o_1 = this.g4o_1.e1(0);
    this.m4o_1 = this.g4o_1.e1(1);
    this.n4o_1 = this.g4o_1.e1(2);
    this.o4o_1 = this.g4o_1.e1(3);
    this.p4o_1 = this.h4o_1.e1(0);
    this.q4o_1 = this.h4o_1.e1(1);
    this.r4o_1 = this.h4o_1.e1(2);
    this.s4o_1 = this.h4o_1.e1(3);
    this.t4o_1 = this.g4o_1.e1(0);
    this.u4o_1 = this.g4o_1.e1(1);
    this.v4o_1 = this.g4o_1.e1(2);
    this.w4o_1 = this.g4o_1.e1(3);
    this.x4o_1 = this.i4o_1.e1(0);
    this.y4o_1 = this.i4o_1.e1(1);
    this.z4o_1 = this.i4o_1.e1(2);
    this.a4p_1 = this.i4o_1.e1(3);
    this.b4p_1 = this.j4o_1.e1(0);
    this.c4p_1 = this.j4o_1.e1(1);
    this.d4p_1 = this.j4o_1.e1(2);
    this.e4p_1 = this.j4o_1.e1(3);
  }
  v5i(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_45().p5i_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_45().q5i_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_45().r5i_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_45().o5i_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_44().h5i_1) ? this.g4o_1.e1(horizontalIndex) : equals(vertical, Companion_getInstance_44().k5i_1) ? this.h4o_1.e1(horizontalIndex) : equals(vertical, Companion_getInstance_44().i5i_1) ? this.i4o_1.e1(horizontalIndex) : equals(vertical, Companion_getInstance_44().j5i_1) ? this.j4o_1.e1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_46();
    this.d4q_1 = horizontal;
    this.e4q_1 = vertical;
    this.f4q_1 = Anchor2D.o29(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.d4q_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.e4q_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.e4q_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.d4q_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.d4q_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.e4q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.d4q_1, tmp0_other_with_cast.d4q_1))
      return false;
    if (!equals(this.e4q_1, tmp0_other_with_cast.e4q_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_7().a2b() : bounds;
    this.h4q_1 = maxLineHeight;
    this.i4q_1 = maxX;
    this.j4q_1 = bounds;
  }
  k4q(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.i4q_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.j4q_1, 0.0);
  }
  z4s(dx) {
    this.i4q_1 = this.i4q_1 + dx;
  }
  y5i(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.h4q_1;
    var b = fontMetrics.m4h();
    tmp.h4q_1 = Math.max(a, b);
  }
  z5i() {
  }
  p2u() {
    this.i4q_1 = 0.0;
    this.j4q_1 = Companion_getInstance_7().v2a_1;
    this.h4q_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.h4q_1 + ', maxX=' + this.i4q_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.j4q_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h4q_1);
    result = imul(result, 31) + getNumberHashCode(this.i4q_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.j4q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.h4q_1, tmp0_other_with_cast.h4q_1))
      return false;
    if (!equals(this.i4q_1, tmp0_other_with_cast.i4q_1))
      return false;
    if (!equals(this.j4q_1, tmp0_other_with_cast.j4q_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.x4p_1 = Companion_getInstance_7().a2b();
    this.y4p_1 = Companion_getInstance_7().a2b();
    this.z4p_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a4q_1 = ArrayList.j1();
    this.b4q_1 = new LineStats();
  }
  c4q() {
    return this.z4p_1;
  }
  a5j() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.a4q_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.h4q_1;
    }
    return sum;
  }
  p4s(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.a4q_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.i4q_1);
  }
  g4q(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.a5j());
  }
  p2u() {
    super.p2u();
    this.z4p_1 = 0;
    this.y4p_1 = Companion_getInstance_7().v2a_1;
    this.x4p_1 = Companion_getInstance_7().v2a_1;
    this.b4q_1.p2u();
    this.a4q_1.k3();
  }
  d4s(reader, codePoint) {
    var g = this.x4s(reader, codePoint);
    add_0(this, g.l4i_1);
    this.b4q_1.y5i(this.g4s_1);
    return g;
  }
  z4s(x) {
    super.z4s(x);
    this.b4q_1.z4s(x);
  }
  a4t(y, end) {
    super.a4t(y, end);
    this.z4p_1 = this.z4p_1 + 1 | 0;
    this.b4q_1.y5i(this.g4s_1);
    this.b4q_1.z5i();
    this.a4q_1.h(this.b4q_1);
    this.b4q_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.b5j_1 = maxTop;
    this.c5j_1 = minBottom;
    this.d5j_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.b5j_1 + ', minBottom=' + this.c5j_1 + ', maxLineHeight=' + this.d5j_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b5j_1);
    result = imul(result, 31) + getNumberHashCode(this.c5j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d5j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.b5j_1, tmp0_other_with_cast.b5j_1))
      return false;
    if (!equals(this.c5j_1, tmp0_other_with_cast.c5j_1))
      return false;
    if (!equals(this.d5j_1, tmp0_other_with_cast.d5j_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.e5j_1 = tex;
    this.f5j_1 = x;
    this.g5j_1 = y;
    this.h5j_1 = sx;
    this.i5j_1 = sy;
    this.j5j_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.bc('Entry(');
    this_0.bc("'" + this.e5j_1.v3j_1 + "', " + numberToInt(this.f5j_1) + ', ' + numberToInt(this.g5j_1) + ', ' + this.e5j_1.a3k_1 + ', ' + this.e5j_1.b3k_1);
    if (!(this.h5j_1 === 1.0)) {
      this_0.bc(', sx=' + get_niceStr_0(this.h5j_1));
    }
    if (!(this.i5j_1 === 1.0)) {
      this_0.bc(', sy=' + get_niceStr_0(this.i5j_1));
    }
    if (!equals(this.j5j_1, get_radians(0))) {
      this_0.bc(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.j5j_1)));
    }
    this_0.bc(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.e5j_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.f5j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g5j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h5j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i5j_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.j5j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.e5j_1.equals(tmp0_other_with_cast.e5j_1))
      return false;
    if (!equals(this.f5j_1, tmp0_other_with_cast.f5j_1))
      return false;
    if (!equals(this.g5j_1, tmp0_other_with_cast.g5j_1))
      return false;
    if (!equals(this.h5j_1, tmp0_other_with_cast.h5j_1))
      return false;
    if (!equals(this.i5j_1, tmp0_other_with_cast.i5j_1))
      return false;
    if (!equals(this.j5j_1, tmp0_other_with_cast.j5j_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.u5j_1 = Companion_getInstance_46().l4o_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.v5j_1 = ArrayList.j1();
    this.w5j_1 = doubleArrayListOf(new Float64Array([]));
    this.x5j_1 = doubleArrayListOf(new Float64Array([]));
    this.y5j_1 = doubleArrayListOf(new Float64Array([]));
    this.z5j_1 = doubleArrayListOf(new Float64Array([]));
    this.a5k_1 = doubleArrayListOf(new Float64Array([]));
    this.b5k_1 = new DoubleVectorArrayList(4);
    this.c5k_1 = MatrixTransform.v2f();
  }
  d5k() {
    return this.u5j_1.e4q_1;
  }
  f1() {
    return this.w5j_1.f1();
  }
  e5k() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.b5k_1;
    var inductionVariable = 0;
    var last = this_0.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.m2c(n, 0));
        while (out.f1() <= line) {
          out.h(new LineInfo());
        }
        var lineInfo = out.e1(line);
        var top = this_0.m2c(n, 1);
        var bottom = this_0.m2c(n, 2);
        var lineHeight = this_0.m2c(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.b5j_1;
        tmp.b5j_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.c5j_1;
        tmp_0.c5j_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.d5j_1;
        tmp_1.d5j_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  f5k(n) {
    return n >= this.f1() ? Companion_getInstance_4().w2a_1 : Companion_getInstance_4().c2i(this.w5j_1.e1(n), this.x5j_1.e1(n), this.w5j_1.e1(n) + this.v5j_1.e1(n).a3k_1 * this.y5j_1.e1(n), this.x5j_1.e1(n) + this.v5j_1.e1(n).b3k_1 * this.z5j_1.e1(n));
  }
  k3e() {
    if (this.f1() === 0) {
      return Companion_getInstance_4().w2a_1;
    }
    var bb = Companion_getInstance_7().a2b();
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.f5k(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  g5k(n, out) {
    out.e5j_1 = this.v5j_1.e1(n);
    out.f5j_1 = this.w5j_1.e1(n);
    out.g5j_1 = this.x5j_1.e1(n);
    out.h5j_1 = this.y5j_1.e1(n);
    out.i5j_1 = this.z5j_1.e1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_8();
    var ratio = this.a5k_1.e1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.j5j_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  h5k() {
    this.w4s(Companion_getInstance_6().c2a_1);
    this.v5j_1.k3();
    this.w5j_1.k3();
    this.x5j_1.k3();
    this.y5j_1.k3();
    this.z5j_1.k3();
    this.a5k_1.k3();
    this.b5k_1.k3();
    this.u4s(0);
  }
  d4s(reader, codePoint) {
    var tmp = this.t4s();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.nx_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.x4s(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.nx_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.e1(codePoint);
    var x = g.c4h_1;
    var tmp_0 = g.d4h_1;
    var tmp295_subject = this.d5k();
    var y = tmp_0 - (equals(tmp295_subject, Companion_getInstance_44().k5i_1) ? bf.a3l() : bf.m4h() * _VerticalAlign___get_ratio__impl__b3ilr8(this.d5k()));
    var fontScale = this.j4s_1 / bf.l4h();
    this.c5k_1 = get_immutable(this.r4s()).z2e();
    this.v5j_1.h(g.b4h_1);
    this.w5j_1.t11(this.vy().a2a_1 + this.r4s().e2e(x, y) * fontScale);
    this.x5j_1.t11(this.vy().b2a_1 + this.r4s().h2e(x, y) * fontScale);
    this.y5j_1.t11(this.c5k_1.n2f_1 * fontScale);
    this.z5j_1.t11(this.c5k_1.o2f_1 * fontScale);
    this.a5k_1.t11(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.c5k_1.r2f_1)));
    this.b5k_1.m2p(this.o4s(), this.g4s_1.w4h_1, this.g4s_1.a4i_1, this.g4s_1.m4h());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.i5k_1 = $getVersion;
    this.j5k_1 = $handler;
  }
  w5i() {
    return this.i5k_1();
  }
  k5k(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.p2u();
    _this__u8e3s4.v4s(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.ux()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.xx());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.vx(1));
      var startPos = reader.nx_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.a4t(_this__u8e3s4.m4h(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.nx_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.x4s(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.nx_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.y4s(Companion_getInstance_5().m2d_1);
        this.j5k_1(_this__u8e3s4, reader, c, g, g.m4i_1 + _this__u8e3s4.p4i(c, c1));
      }
      if (reader.nx_1 <= startPos) {
        reader.zx(1);
      }
    }
    _this__u8e3s4.a4t(_this__u8e3s4.m4h(), true);
  }
  x5i(_this__u8e3s4, text, size, defaultFont) {
    return this.k5k(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.l5k_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  w5i() {
    return this.l5k_1.w5i();
  }
  m5k(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.l5k_1.x5i(_this__u8e3s4, Companion_getInstance_11().ey(text), size, defaultFont);
  }
  x5i(_this__u8e3s4, text, size, defaultFont) {
    return this.m5k(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class SegmentHandler {
  constructor() {
    this.n5k_1 = intArrayListOf(new Int32Array([]));
    this.o5k_1 = intArrayListOf(new Int32Array([]));
    this.p2u();
  }
  f1() {
    return this.n5k_1.f1();
  }
  p2u() {
    this.n5k_1.k3();
    this.o5k_1.k3();
  }
  g3o(x0, x1) {
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.n5k_1.sz(n);
        var xmax = this.o5k_1.sz(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.n5k_1.x2o(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.o5k_1.x2o(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.n5k_1.s2o(x0);
    this.o5k_1.s2o(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.a5l_1 = $outer;
    this.p5k_1 = get_DEFAULT(Companion_getInstance_47());
    this.q5k_1 = NoneFiller_getInstance();
    this.r5k_1 = -1;
    this.s5k_1 = -1;
    this.t5k_1 = new Float32Array(this.f1());
    this.u5k_1 = new Int32Array(this.f1());
    this.v5k_1 = Companion_instance_14.w4g(this.f1());
    this.w5k_1 = Companion_instance_14.w4g(this.f1());
    this.x5k_1 = new SegmentHandler();
    this.y5k_1 = 0;
    this.z5k_1 = 1.0;
  }
  f1() {
    return this.a5l_1.d5l_1.z3y_1;
  }
  n5l() {
    return this.a5l_1.d5l_1.z3y_1 - 1 | 0;
  }
  p2u() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.x5k_1;
    var inductionVariable = 0;
    var last = this_0.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.n5k_1.sz(n);
        var xmax = this_0.o5k_1.sz(n);
        fill_0(this.t5k_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.u5k_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.y5k_1 = 0;
    this.x5k_1.p2u();
  }
  o5l(x0, x1, y0) {
    if (this.n5l() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.n5l(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.n5l(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.n5l());
    var i1 = coerceIn(b, 0, this.n5l());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.s5k_1 === y)) {
      if (y >= 0) {
        this.yc();
      }
      this.s5k_1 = y;
      this.p2u();
    }
    if (!(this.r5k_1 === y0)) {
      this.r5k_1 = y0;
      this.y5k_1 = this.y5k_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.x5k_1.g3o(i0, i1);
      this.p5l(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.p5l(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.p5l(i1, i1m / 20);
      }
    }
  }
  p5l(x, ratio) {
    var mask = 1 << this.y5k_1;
    if ((this.u5k_1[x] & mask) === 0) {
      this.u5k_1[x] = this.u5k_1[x] | mask;
      var _array__4zh2yp = this.t5k_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  yc() {
    var containsUpper = this.a5l_1.d5l_1.a3z_1;
    var containsArg = this.s5k_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.z5k_1);
    var scale_0 = 1.0 / this.y5k_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.x5k_1;
    var inductionVariable = 0;
    var last = this_0.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.n5k_1.sz(n);
        var xmax = this_0.o5k_1.sz(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.q5k_1.s5g(this.w5k_1, 0, xmin, xmax, this.s5k_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.t5k_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.w5k_1, xmin, this.t5k_1, xmin, count);
        var index = this.a5l_1.d5l_1.u3z(0, this.s5k_1) + x | 0;
        if (this.a5l_1.d5l_1.f3z_1) {
          arraycopy(this.a5l_1.d5l_1.p3y_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.v5k_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.a5l_1.d5l_1.p3y_1), index, this.v5k_1, x, count);
        }
        this.p5k_1.q5l(this.v5k_1, x, this.w5k_1, x, count);
        if (this.a5l_1.d5l_1.f3z_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.v5k_1), x, this.a5l_1.d5l_1.p3y_1, index, count);
        } else {
          depremultiply(this.v5k_1, x, _RgbaArray___init__impl__oib4y4(this.a5l_1.d5l_1.p3y_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.c5m_1 = false;
    this.d5m_1 = 0;
  }
  yc() {
    return Unit_instance;
  }
  f5m() {
    var _unary__edvuaz = this.d5m_1;
    this.d5m_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  g5m() {
    this.d5m_1 = this.d5m_1 - 1 | 0;
    if (this.d5m_1 === 0) {
      this.yc();
    }
  }
  h5m(state, fill, winding) {
    var rstate = state;
    if (fill && !this.j5m(state.c4j_1)) {
      rstate = state.uz();
      rstate.c4j_1 = toBitmapPaint(rstate.c4j_1, state);
    }
    this.b5m(rstate, fill, winding);
  }
  i5m(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.h5m(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.h5m.call(this, state, fill, winding);
    }
    return tmp;
  }
  b5m(state, fill, winding) {
    return Unit_instance;
  }
  j5m(_this__u8e3s4) {
    return true;
  }
  k5m(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.c2e().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.y3q(pos, size);
    } else {
      this_0.f3r(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.i5m(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().m2d_1, size.u2j(toFloat(image.f1()))).q2e(pos))), true);
  }
  m1a() {
    this.yc();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.d5l_1 = bmp;
    this.e5l_1 = antialiasing;
    this.f5l_1 = this.d5l_1.r3y_1.n2j();
    this.g5l_1 = new Rasterizer();
    this.h5l_1 = new ColorFiller();
    this.i5l_1 = new GradientFiller();
    this.j5l_1 = new BitmapFiller();
    this.k5l_1 = new ScanlineWriter(this);
    this.l5l_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.m5l_1 = new StrokeToFill();
  }
  d2m() {
    return this.d5l_1.z3y_1;
  }
  e2m() {
    return this.d5l_1.a3z_1;
  }
  b5m(state, fill, winding) {
    var style = fill ? state.c4j_1 : state.b4j_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.h5l_1.q5g(style.a4g_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.i5l_1.y5g(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.j5l_1.m5h(style, state);
          } else {
            throw NotImplementedError.be();
          }
        }
      }
    }
    var filler = tmp;
    this.k5l_1.p5k_1 = state.j4j_1;
    this.g5l_1.p2u();
    this.g5l_1.r5l_1 = this.c5m_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.u4i_1;
    } else {
      this.l5l_1.k3();
      var tmp306_$receiver = state.u4i_1;
      var tmp307_lineWidth = state.e5m();
      var tmp308_joins = state.z4i_1;
      var tmp309_startCap = state.x4i_1;
      var tmp310_endCap = state.y4i_1;
      var tmp311_miterLimit = state.a4j_1;
      var tmp312_temp = this.m5l_1;
      var tmp313_outFill = this.l5l_1;
      var tmp314_lineDash = state.k4j_1;
      var tmp315_lineDashOffset = state.l4j_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.t4i_1 == null)) {
      this.g5l_1.v5l_1.l3n_1 = ensureNotNull(state.t4i_1).y3h_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.t4i_1);
      var i = Vector2D.v2c();
      var l = Vector2D.v2c();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.g5l_1.v5l_1.n6();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.w3h_1;
      var n_0 = 0;
      while (n_0 < this_1.f1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.sz(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.x3h_1.e1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.k2c(tmp_1, this_0.x3h_1.e1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.nl();
            var y = it.ol();
            this.g5l_1.v5l_1.o3o(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.x3h_1.e1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.k2c(tmp_2, this_0.x3h_1.e1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.nl();
            var y_0 = it_0.ol();
            this.g5l_1.v5l_1.o3o(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.x3h_1.e1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.k2c(tmp_3, this_0.x3h_1.e1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.x3h_1.e1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.k2c(tmp_4, this_0.x3h_1.e1(_unary__edvuaz_7));
            var sum = Companion_getInstance_6().t2k(l, c) + Companion_getInstance_6().t2k(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.v2c()};
            var prevPos = {_v: Vector2D.v2c()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_9().mz_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_1().t3f(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_1().t3f(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.nl();
                var y_1 = it_1.ol();
                this.g5l_1.v5l_1.o3o(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.x3h_1.e1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.k2c(tmp_5, this_0.x3h_1.e1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.x3h_1.e1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.k2c(tmp_6, this_0.x3h_1.e1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.x3h_1.e1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.k2c(tmp_7, this_0.x3h_1.e1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_6().t2k(l, c0) + Companion_getInstance_6().t2k(c0, c1) + Companion_getInstance_6().t2k(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.v2c()};
            var prevPos_0 = {_v: Vector2D.v2c()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_9().mz_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_1().s3f(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_1().s3f(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.nl();
                var y_2 = it_2.ol();
                this.g5l_1.v5l_1.o3o(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.nl();
            var y_3 = destruct.ol();
            this.g5l_1.v5l_1.o3o(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.g5l_1.v5l_1.n6();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.g5l_1.v5l_1.n6();
      }
    }
    var tmp_8 = this.g5l_1.u5l_1;
    tmp_8.l3n_1 = winding == null ? ensureNotNull(state.u4i_1).y3h_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.v2c();
    var l_0 = Vector2D.v2c();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.g5l_1.u5l_1.n6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.w3h_1;
    var n_4 = 0;
    while (n_4 < this_2.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.sz(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.x3h_1.e1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.k2c(tmp_9, fillPath.x3h_1.e1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.nl();
          var y_4 = it_3.ol();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.g5l_1.u5l_1.o3o(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.x3h_1.e1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.k2c(tmp_10, fillPath.x3h_1.e1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.nl();
          var y_5 = it_4.ol();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.g5l_1.u5l_1.o3o(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.x3h_1.e1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.k2c(tmp_11, fillPath.x3h_1.e1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.x3h_1.e1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.k2c(tmp_12, fillPath.x3h_1.e1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_6().t2k(l_0, c_0) + Companion_getInstance_6().t2k(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.v2c()};
          var prevPos_1 = {_v: Vector2D.v2c()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_9().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_1().t3f(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_1().t3f(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.nl();
              var y_6 = it_5.ol();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.g5l_1.u5l_1.o3o(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.x3h_1.e1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.k2c(tmp_13, fillPath.x3h_1.e1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.x3h_1.e1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.k2c(tmp_14, fillPath.x3h_1.e1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.x3h_1.e1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.k2c(tmp_15, fillPath.x3h_1.e1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_6().t2k(l_0, c0_0) + Companion_getInstance_6().t2k(c0_0, c1_0) + Companion_getInstance_6().t2k(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.v2c()};
          var prevPos_2 = {_v: Vector2D.v2c()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_9().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_1().s3f(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_1().s3f(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.nl();
              var y_7 = it_6.ol();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.g5l_1.u5l_1.o3o(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.nl();
          var y_8 = destruct_0.ol();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.g5l_1.u5l_1.o3o(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.g5l_1.u5l_1.n6();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.g5l_1.u5l_1.n6();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.l5m_1 = $func;
  }
  q5l(dst, dstN, src, srcN, count) {
    return this.l5m_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_37 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_47();
    tmp.m5m_1 = tmp_0.n5m(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  n5m(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_32 {
  g3r() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.q5m_1 = op;
  }
  q5l(dst, dstN, src, srcN, count) {
    this.q5m_1.q5l(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_5().m2d_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_44().k5i_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_45().p5i_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.s4i_1 = transform;
    this.t4i_1 = clip;
    this.u4i_1 = path;
    this.v4i_1 = lineScaleMode;
    this.w4i_1 = lineWidth;
    this.x4i_1 = startLineCap;
    this.y4i_1 = endLineCap;
    this.z4i_1 = lineJoin;
    this.a4j_1 = miterLimit;
    this.b4j_1 = strokeStyle;
    this.c4j_1 = fillStyle;
    this.d4j_1 = fontRegistry;
    this.e4j_1 = font;
    this.f4j_1 = fontSize;
    this.g4j_1 = verticalAlign;
    this.h4j_1 = horizontalAlign;
    this.i4j_1 = globalAlpha;
    this.j4j_1 = globalCompositeOperation;
    this.k4j_1 = lineDash;
    this.l4j_1 = lineDashOffset;
    var tmp = this;
    tmp.m4j_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  r5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m4j_1;
    transformTransform$factory();
    return this_0.s1();
  }
  e5m() {
    var tmp = this.w4i_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.r5m().x2f();
    return tmp * Math.abs(this_0);
  }
  a4r(value) {
    this.x4i_1 = value;
    this.y4i_1 = value;
  }
  t4q() {
    return this.x4i_1;
  }
  uz() {
    var tmp = this.s4i_1;
    var tmp319_safe_receiver = this.t4i_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.uz();
    var tmp_1 = this.u4i_1.uz();
    var tmp320_safe_receiver = this.k4j_1;
    return this.s5m(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.uz());
  }
  t5m(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  s5m(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.s4i_1 : transform;
    clip = clip === VOID ? this.t4i_1 : clip;
    path = path === VOID ? this.u4i_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.v4i_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.w4i_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.x4i_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.y4i_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.z4i_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.a4j_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.b4j_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.c4j_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.d4j_1 : fontRegistry;
    font = font === VOID ? this.e4j_1 : font;
    fontSize = fontSize === VOID ? this.f4j_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.g4j_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.h4j_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.i4j_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.j4j_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.k4j_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.l4j_1 : lineDashOffset;
    return $super === VOID ? this.t5m(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.t5m.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.s4i_1.toString() + ', clip=' + toString(this.t4i_1) + ', path=' + this.u4i_1.toString() + ', lineScaleMode=' + this.v4i_1.toString() + ', lineWidth=' + this.w4i_1 + ', startLineCap=' + this.x4i_1.toString() + ', endLineCap=' + this.y4i_1.toString() + ', lineJoin=' + this.z4i_1.toString() + ', miterLimit=' + this.a4j_1 + ', strokeStyle=' + toString_0(this.b4j_1) + ', fillStyle=' + toString_0(this.c4j_1) + ', fontRegistry=' + toString(this.d4j_1) + ', font=' + toString(this.e4j_1) + ', fontSize=' + this.f4j_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.g4j_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.h4j_1) + ', globalAlpha=' + this.i4j_1 + ', globalCompositeOperation=' + toString_0(this.j4j_1) + ', lineDash=' + toString(this.k4j_1) + ', lineDashOffset=' + this.l4j_1 + ')';
  }
  hashCode() {
    var result = this.s4i_1.hashCode();
    result = imul(result, 31) + (this.t4i_1 == null ? 0 : this.t4i_1.hashCode()) | 0;
    result = imul(result, 31) + this.u4i_1.hashCode() | 0;
    result = imul(result, 31) + this.v4i_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.w4i_1) | 0;
    result = imul(result, 31) + this.x4i_1.hashCode() | 0;
    result = imul(result, 31) + this.y4i_1.hashCode() | 0;
    result = imul(result, 31) + this.z4i_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.a4j_1) | 0;
    result = imul(result, 31) + hashCode(this.b4j_1) | 0;
    result = imul(result, 31) + hashCode(this.c4j_1) | 0;
    result = imul(result, 31) + (this.d4j_1 == null ? 0 : hashCode(this.d4j_1)) | 0;
    result = imul(result, 31) + (this.e4j_1 == null ? 0 : hashCode(this.e4j_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4j_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.g4j_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.h4j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i4j_1) | 0;
    result = imul(result, 31) + hashCode(this.j4j_1) | 0;
    result = imul(result, 31) + (this.k4j_1 == null ? 0 : hashCode(this.k4j_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l4j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.s4i_1.equals(tmp0_other_with_cast.s4i_1))
      return false;
    if (!equals(this.t4i_1, tmp0_other_with_cast.t4i_1))
      return false;
    if (!this.u4i_1.equals(tmp0_other_with_cast.u4i_1))
      return false;
    if (!this.v4i_1.equals(tmp0_other_with_cast.v4i_1))
      return false;
    if (!equals(this.w4i_1, tmp0_other_with_cast.w4i_1))
      return false;
    if (!this.x4i_1.equals(tmp0_other_with_cast.x4i_1))
      return false;
    if (!this.y4i_1.equals(tmp0_other_with_cast.y4i_1))
      return false;
    if (!this.z4i_1.equals(tmp0_other_with_cast.z4i_1))
      return false;
    if (!equals(this.a4j_1, tmp0_other_with_cast.a4j_1))
      return false;
    if (!equals(this.b4j_1, tmp0_other_with_cast.b4j_1))
      return false;
    if (!equals(this.c4j_1, tmp0_other_with_cast.c4j_1))
      return false;
    if (!equals(this.d4j_1, tmp0_other_with_cast.d4j_1))
      return false;
    if (!equals(this.e4j_1, tmp0_other_with_cast.e4j_1))
      return false;
    if (!equals(this.f4j_1, tmp0_other_with_cast.f4j_1))
      return false;
    if (!equals(this.g4j_1, tmp0_other_with_cast.g4j_1))
      return false;
    if (!equals(this.h4j_1, tmp0_other_with_cast.h4j_1))
      return false;
    if (!equals(this.i4j_1, tmp0_other_with_cast.i4j_1))
      return false;
    if (!equals(this.j4j_1, tmp0_other_with_cast.j4j_1))
      return false;
    if (!equals(this.k4j_1, tmp0_other_with_cast.k4j_1))
      return false;
    if (!equals(this.l4j_1, tmp0_other_with_cast.l4j_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.x46_1 = renderer;
    this.y46_1 = defaultFontRegistry;
    this.z46_1 = defaultFont;
    this.a47_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.y46_1, this.z46_1);
    this.b47_1 = _TGenStack___init__impl__yynjgt();
    this.c47_1 = Vector2D.v2c();
    this.d47_1 = Vector2D.v2c();
  }
  u5m() {
    return this.x46_1.d2m();
  }
  v5m() {
    return this.x46_1.e2m();
  }
  w5m(state, fill, winding) {
    return this.x46_1.h5m(state, fill, winding);
  }
  x5m(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.w5m(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.w5m.call(this, state, fill, winding);
    }
    return tmp;
  }
  y5m(image, pos, size, transform) {
    return this.x46_1.k5m(image, pos, size, transform);
  }
  z5m() {
    return this.x46_1.m1a();
  }
  a5n() {
    return this.x46_1.f5m();
  }
  b5n() {
    return this.x46_1.g5m();
  }
  d2m() {
    return this.u5m();
  }
  e2m() {
    return this.v5m();
  }
  m1a() {
    this.z5m();
  }
  c5n() {
    return this.a5n();
  }
  d5n() {
    return this.b5n();
  }
  e5n(value) {
    this.a47_1.v4i_1 = value;
  }
  z4q(value) {
    this.a47_1.w4i_1 = value;
  }
  s4q() {
    return this.a47_1.w4i_1;
  }
  a4r(value) {
    this.a47_1.a4r(value);
  }
  t4q() {
    return this.a47_1.t4q();
  }
  c4r(value) {
    this.a47_1.a4j_1 = value;
  }
  v4q() {
    return this.a47_1.a4j_1;
  }
  f5n(value) {
    this.a47_1.x4i_1 = value;
  }
  g5n(value) {
    this.a47_1.y4i_1 = value;
  }
  b4r(value) {
    this.a47_1.z4i_1 = value;
  }
  u4q() {
    return this.a47_1.z4i_1;
  }
  h5n(value) {
    this.a47_1.b4j_1 = value;
  }
  i5n() {
    return this.a47_1.b4j_1;
  }
  p4j(value) {
    this.a47_1.c4j_1 = value;
  }
  o4j() {
    return this.a47_1.c4j_1;
  }
  t4s() {
    return this.a47_1.e4j_1;
  }
  l4h() {
    return this.a47_1.f4j_1;
  }
  d5k() {
    return this.a47_1.g4j_1;
  }
  j5n() {
    return this.a47_1.h4j_1;
  }
  k5n() {
    return Companion_getInstance_46().v5i(this.j5n(), this.d5k());
  }
  d4r(value) {
    this.a47_1.k4j_1 = value;
  }
  w4q() {
    return this.a47_1.k4j_1;
  }
  e4r(value) {
    this.a47_1.l4j_1 = value;
  }
  x4q() {
    return this.a47_1.l4j_1;
  }
  y4q() {
    TGenStack__push_impl_9yh33t(this.b47_1, this.a47_1.uz());
  }
  g4r() {
    this.a47_1 = TGenStack__pop_impl_qisxa0(this.b47_1);
  }
  m59(sx, sy) {
    this.a47_1.s4i_1 = this.a47_1.s4i_1.o2e(sx, sy);
  }
  n4j(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.m59(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.m59.call(this, sx, sy);
    }
    return tmp;
  }
  q4s(tx, ty) {
    this.a47_1.s4i_1 = this.a47_1.s4i_1.w2e(tx, ty);
  }
  s4s(m) {
    this.a47_1.s4i_1 = this.a47_1.s4i_1.x2e(m);
  }
  l5n(_set____db54di) {
    this.c47_1 = _set____db54di;
  }
  m5n() {
    return this.c47_1;
  }
  n5n(_set____db54di) {
    this.d47_1 = _set____db54di;
  }
  v3q() {
    return this.d47_1;
  }
  u3q() {
    return this.a47_1.u4i_1.u3q();
  }
  n6() {
    this.a47_1.u4i_1.n6();
    this.n5n(this.m5n());
  }
  t3h(p) {
    this.a47_1.u4i_1.t3h(trans(this, p));
    this.n5n(p);
    this.l5n(p);
  }
  g3i(p) {
    this.a47_1.u4i_1.g3i(trans(this, p));
    this.n5n(p);
  }
  h3i(c, a) {
    this.a47_1.u4i_1.h3i(trans(this, c), trans(this, a));
    this.n5n(a);
  }
  u3h(c1, c2, a) {
    this.a47_1.u4i_1.u3h(trans(this, c1), trans(this, c2), trans(this, a));
    this.n5n(a);
  }
  l59(path) {
    if (this.h1())
      this.a47_1.u4i_1.y3h_1 = path.y3h_1;
    write_0(this, path);
  }
  k4t(d) {
    d.j4t(this);
  }
  q4j(x, y, width, height) {
    this.f4p();
    this.z3q(x, y, width, height);
    this.o4q();
  }
  f4p() {
    this.a47_1.u4i_1 = new VectorPath();
  }
  n4q() {
    if (!equals(this.a47_1.b4j_1, NonePaint_instance)) {
      this.x5m(this.a47_1, false);
    }
  }
  o5n(winding) {
    if (!equals(this.a47_1.c4j_1, NonePaint_instance)) {
      this.w5m(this.a47_1, true, winding);
    }
  }
  o4q(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.o5n(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.o5n.call(this, winding);
    }
    return tmp;
  }
  p5n(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.o4j();
    this.p4j(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.o5n(winding);
    }finally {
      this.p4j(oldStyle);
    }
  }
  r4q(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.p5n(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.p5n.call(this, paint, winding);
    }
    return tmp;
  }
  f4r(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.i5n();
    this.h5n(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.n4q();
    }finally {
      this.h5n(oldStyle);
    }
  }
  q5n(path, winding) {
    if (!(path == null)) {
      if (this.a47_1.t4i_1 == null) {
        this.a47_1.t4i_1 = new VectorPath();
      }
      ensureNotNull(this.a47_1.t4i_1).k3();
      ensureNotNull(this.a47_1.t4i_1).y3h_1 = winding;
      ensureNotNull(this.a47_1.t4i_1).l3r(path);
      if (path === this.a47_1.u4i_1) {
        path.k3();
      }
    } else {
      this.a47_1.t4i_1 = null;
    }
  }
  r5n(path, winding, $super) {
    path = path === VOID ? this.a47_1.u4i_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.q5n(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.q5n.call(this, path, winding);
    }
    return tmp;
  }
  s5n(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.o4j() : this.i5n() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  t5n(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_6().c2a_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.t4s() : font;
    size = size === VOID ? this.l4h() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.k5n() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.s5n(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.s5n.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  r4j(image, pos, size) {
    return this.y5m(image, pos, size, this.a47_1.s4i_1);
  }
  b5f(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.f1()) : size;
    var tmp;
    if ($super === VOID) {
      this.r4j(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.r4j.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_39 = this;
    this.u5n_1 = values_6();
  }
}
class CycleMethod extends Enum {
  d5i() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  a5i(ratio) {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  v5n(ratio) {
    return this.a5i(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.w5n_1 = beziers;
    var tmp = this;
    tmp.x5n_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.y5n_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.z5n_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.a5o_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.b5o_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.c5o_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.d5o_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  o5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5n_1;
    red$factory();
    return this_0.s1();
  }
  p5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5n_1;
    green$factory();
    return this_0.s1();
  }
  q5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5n_1;
    blue$factory();
    return this_0.s1();
  }
  e5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a5o_1;
    allProjected$factory();
    return this_0.s1();
  }
  j5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b5o_1;
    redProjected$factory();
    return this_0.s1();
  }
  k5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c5o_1;
    greenProjected$factory();
    return this_0.s1();
  }
  l5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d5o_1;
    blueProjected$factory();
    return this_0.s1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.m5o_1 = bezier;
    this.n5o_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.m5o_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.n5o_1) + ')';
  }
  hashCode() {
    var result = this.m5o_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.n5o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.m5o_1.equals(tmp0_other_with_cast.m5o_1))
      return false;
    if (!(this.n5o_1 === tmp0_other_with_cast.n5o_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.f5o_1 = beziers;
    this.g5o_1 = new ProjectedPoint();
    this.h5o_1 = Companion_getInstance_2().p2d();
  }
  i5o(point) {
    return Companion_getInstance_6().t2k(point, this.z3g(point));
  }
  z3g(point) {
    if (this.f5o_1.h1())
      return Vector2D.x2c(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f5o_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.e1(_unary__edvuaz).k3g().u2b(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.v2c();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.f5o_1;
    var n_0 = 0;
    while (n_0 < this_1.f1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.e1(_unary__edvuaz_0);
        if (it.k3g().t2b(point) > minDistSq) {
          break $l$block;
        }
        it.x3g(point, this.g5o_1);
        if (this.g5o_1.n3f_1 < bminDistSq) {
          bminDistSq = this.g5o_1.n3f_1;
          out = this.g5o_1.l3f_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.r5o(path) : getPath(path);
}
function get_bounds() {
  return this.s5o(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.j26();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_1(Companion_getInstance_7().a2b(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_4().z2a() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp347_safe_receiver = this.j26();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.l3r(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.a47_1.s4i_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.f4p();
    var tmp348_safe_receiver = this.j26();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.a5p() == null)) {
      draw_0(ensureNotNull(this.a5p()), c);
      c.r5n();
    }
    c.s4s(get_immutable(this.r4s()));
    this.e5p(c);
  }finally {
    c.a47_1.s4i_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_5().m2d_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.t5o_1 = path;
    this.u5o_1 = clip;
    this.v5o_1 = paint;
    this.w5o_1 = transform;
    this.x5o_1 = globalAlpha;
    var tmp = this;
    tmp.y5o_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.z5o_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  j26() {
    return this.t5o_1;
  }
  a5p() {
    return this.u5o_1;
  }
  r4s() {
    return this.w5o_1;
  }
  b5p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5o_1;
    pathCurvesList$factory();
    return this_0.s1();
  }
  c5p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5o_1;
    clipCurvesList$factory();
    return this_0.s1();
  }
  d5p() {
    return this.b5p().f1() === 1 && get_isConvex(first_0(this.b5p())) && this.c5p() == null;
  }
  e5p(c) {
    c.p5n(this.v5o_1, this.t5o_1.y3h_1);
  }
  toString() {
    return 'FillShape(path=' + this.t5o_1.toString() + ', clip=' + toString(this.u5o_1) + ', paint=' + toString_0(this.v5o_1) + ', transform=' + this.w5o_1.toString() + ', globalAlpha=' + this.x5o_1 + ')';
  }
  hashCode() {
    var result = this.t5o_1.hashCode();
    result = imul(result, 31) + (this.u5o_1 == null ? 0 : this.u5o_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.v5o_1) | 0;
    result = imul(result, 31) + this.w5o_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.x5o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.t5o_1.equals(tmp0_other_with_cast.t5o_1))
      return false;
    if (!equals(this.u5o_1, tmp0_other_with_cast.u5o_1))
      return false;
    if (!equals(this.v5o_1, tmp0_other_with_cast.v5o_1))
      return false;
    if (!this.w5o_1.equals(tmp0_other_with_cast.w5o_1))
      return false;
    if (!equals(this.x5o_1, tmp0_other_with_cast.x5o_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.f5p_1 = components;
  }
  s5o(includeStrokes) {
    var bb = Companion_getInstance_7().a2b();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f5p_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.e1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.s5o(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  j4t(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.c5n();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.f5p_1;
        var n = 0;
        while (n < this_0.f1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.e1(_unary__edvuaz).j4t(c);
        }
        break $l$block;
      }finally {
        c.d5n();
      }
    }
    return Unit_instance;
  }
  r5o(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f5p_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.e1(_unary__edvuaz).r5o(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.f5p_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.h5p_1 = path;
    this.i5p_1 = clip;
    this.j5p_1 = paint;
    this.k5p_1 = transform;
    this.l5p_1 = strokeInfo;
    this.m5p_1 = globalAlpha;
    this.n5p_1 = thickness$factory(this.l5p_1);
    this.o5p_1 = scaleMode$factory(this.l5p_1);
    this.p5p_1 = startCap$factory(this.l5p_1);
    this.q5p_1 = endCap$factory(this.l5p_1);
    this.r5p_1 = join$factory(this.l5p_1);
    this.s5p_1 = miterLimit$factory(this.l5p_1);
    this.t5p_1 = dash$factory(this.l5p_1);
    this.u5p_1 = dashOffset$factory(this.l5p_1);
    var tmp = this;
    tmp.v5p_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  j26() {
    return this.h5p_1;
  }
  a5p() {
    return this.i5p_1;
  }
  r4s() {
    return this.k5p_1;
  }
  s5o(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_1(Companion_getInstance_7().a2b(), this.h5p_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.l5p_1.c3c_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.f3t(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.n3s();
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().w2a_1 : tmp0_elvis_lhs;
  }
  w5p(c) {
    c.e5n(this.l5p_1.e3c_1);
    c.z4q(this.l5p_1.c3c_1);
    c.f5n(this.l5p_1.f3c_1);
    c.g5n(this.l5p_1.g3c_1);
    c.b4r(this.l5p_1.h3c_1);
    c.c4r(this.l5p_1.i3c_1);
    c.d4r(this.l5p_1.j3c_1);
    c.e4r(this.l5p_1.k3c_1);
  }
  e5p(c) {
    this.w5p(c);
    c.f4r(this.j5p_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.h5p_1.toString() + ', clip=' + toString(this.i5p_1) + ', paint=' + toString_0(this.j5p_1) + ', transform=' + this.k5p_1.toString() + ', strokeInfo=' + this.l5p_1.toString() + ', globalAlpha=' + this.m5p_1 + ')';
  }
  hashCode() {
    var result = this.h5p_1.hashCode();
    result = imul(result, 31) + (this.i5p_1 == null ? 0 : this.i5p_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.j5p_1) | 0;
    result = imul(result, 31) + this.k5p_1.hashCode() | 0;
    result = imul(result, 31) + this.l5p_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.m5p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.h5p_1.equals(tmp0_other_with_cast.h5p_1))
      return false;
    if (!equals(this.i5p_1, tmp0_other_with_cast.i5p_1))
      return false;
    if (!equals(this.j5p_1, tmp0_other_with_cast.j5p_1))
      return false;
    if (!this.k5p_1.equals(tmp0_other_with_cast.k5p_1))
      return false;
    if (!this.l5p_1.equals(tmp0_other_with_cast.l5p_1))
      return false;
    if (!equals(this.m5p_1, tmp0_other_with_cast.m5p_1))
      return false;
    return true;
  }
}
class TextShape {
  y5p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5p_1;
    primitiveShapes$factory();
    return this_0.s1();
  }
}
class EmptyShape {
  s5o(includeStrokes) {
    return Companion_getInstance_4().z2a();
  }
  j4t(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_50());
    var tmp = this;
    tmp.k4n_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.l4n_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.m4n_1 = ArrayList.j1();
  }
  u5m() {
    return this.k4n_1;
  }
  v5m() {
    return this.l4n_1;
  }
  w5m(state, fill, winding) {
    if (state.u4i_1.h1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.u4i_1.uz();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.y3h_1 = winding == null ? this_0.y3h_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.t4i_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.uz();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.y3h_1 = winding == null ? tmp368_safe_receiver.y3h_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.s4i_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.m4n_1;
      var element = new FillShape(path, clip, state.c4j_1.uz(), transform, state.i4j_1);
      this_1.h(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.m4n_1;
      var tmp_2 = state.b4j_1.uz();
      var tmp369_thickness = state.w4i_1;
      var tmp370_scaleMode = state.v4i_1;
      var tmp371_startCap = state.x4i_1;
      var tmp372_endCap = state.y4i_1;
      var tmp373_join = state.z4i_1;
      var tmp374_dash = state.k4j_1;
      var tmp375_dashOffset = state.l4j_1;
      var tmp376_miterLimit = state.a4j_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.i4j_1);
      this_2.h(element_0);
    }
  }
  y5m(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.y3q(pos, size);
    this.x5m(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().m2d_1, size.u2j(toFloat(image.f1()))).q2e(pos))), true);
  }
  z5m() {
  }
  a5n() {
    return 0;
  }
  b5n() {
  }
  k3() {
    this.a47_1.uz();
    this.m4n_1.k3();
  }
  n4n() {
    return this.m4n_1.f1() === 1 ? first_0(this.m4n_1) : new CompoundShape(toList(this.m4n_1));
  }
  j4t(c) {
    c.k4t(this.n4n());
  }
}
class SvgPath {
  g5p(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.j1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.w3h_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.k2c(tmp, path.x3h_1.e1(_unary__edvuaz_1));
          var x = destruct.nl();
          var y = destruct.ol();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.h(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.k2c(tmp_0, path.x3h_1.e1(_unary__edvuaz_3));
          var x_0 = destruct_0.nl();
          var y_0 = destruct_0.ol();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.h(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.k2c(tmp_1, path.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.k2c(tmp_2, path.x3h_1.e1(_unary__edvuaz_7));
          var x1 = destruct_1.nl();
          var y1 = destruct_1.ol();
          var x2 = destruct_2.nl();
          var y2 = destruct_2.ol();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.h(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.k2c(tmp_3, path.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.k2c(tmp_4, path.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.k2c(tmp_5, path.x3h_1.e1(_unary__edvuaz_13));
          var x1_0 = destruct_3.nl();
          var y1_0 = destruct_3.ol();
          var x2_0 = destruct_4.nl();
          var y2_0 = destruct_4.ol();
          var x3 = destruct_5.nl();
          var y3 = destruct_5.ol();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.h(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.h('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.r5l_1 = false;
    this.s5l_1 = 2;
    this.t5l_1 = 1;
    this.u5l_1 = new PolygonScanline();
    this.v5l_1 = new PolygonScanline();
    this.w5l_1 = new IntSegmentSet();
    this.x5l_1 = new IntSegmentSet();
    this.y5l_1 = new IntSegmentSet();
    this.z5l_1 = IntArrayList.m2o(1024);
  }
  p2u() {
    this.u5l_1.p2u();
    this.v5l_1.p2u();
  }
  z5p(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.p2u();
    }
    var xmin = this.c3o(bounds.r2a());
    var xmax = this.c3o(bounds.s2a());
    var tempRect = this.u5l_1.k3e();
    // Inline function 'kotlin.math.max' call
    var a = bounds.t2a();
    var b = tempRect.t2a();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.c3o(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.u2a();
    var b_0 = tempRect.u2a();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.c3o(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.z5l_1.k3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.u3o() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.u3o()) / this.t5l_1 | 0) / q | 0) | 0;
        this.z5l_1.s2o(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z5l_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.sz(_unary__edvuaz);
      this.u5l_1.p3o(y_0, winding, this.w5l_1);
      edgesChecked = edgesChecked + this.u5l_1.a3o_1 | 0;
      if (this.v5l_1.l2c()) {
        this.v5l_1.p3o(y_0, this.v5l_1.l3n_1, this.x5l_1);
        edgesChecked = edgesChecked + this.v5l_1.a3o_1 | 0;
        this.y5l_1.b3c(this.w5l_1, this.x5l_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.v5l_1.l2c() ? this.y5l_1 : this.w5l_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.f1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.t3b_1.sz(n_1), this_1.u3b_1.sz(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.d5q(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  a5m(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.s5l_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.z5p(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.z5p.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_50();
    super();
    this.g5q_1 = width;
    this.h5q_1 = height;
  }
  d2m() {
    return this.g5q_1;
  }
  e2m() {
    return this.h5q_1;
  }
}
class Companion_34 extends DummyRenderer {
  constructor() {
    Companion_instance_40 = null;
    super(128, 128);
    Companion_instance_40 = this;
  }
}
class HtmlCanvas {
  h3x(width, height) {
    if (Companion_getInstance_10().aw()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  d5r(width, height) {
    return HtmlCanvas_instance.h3x(width, height);
  }
  e5r(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  f5r(bmp, canvas) {
    return this.e5r(_RgbaArray___init__impl__oib4y4(bmp.b4a().p3y_1), bmp.z3y_1, bmp.a3z_1, canvas);
  }
  i5q(bmp) {
    return this.f5r(bmp, this.d5r(bmp.z3y_1, bmp.a3z_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  y5d(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_2.bind(VOID, this, data, props), $completion);
  }
  r5e(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_3.bind(VOID, this, vfs, path, props), $completion);
  }
  z4c(width, height, premultiplied) {
    return HtmlNativeImage.c5r(HtmlCanvas_instance.h3x(width, height));
  }
  y4c(bmp) {
    return HtmlNativeImage.c5r(HtmlImage_instance.i5q(bmp.l3z()));
  }
}
class HtmlNativeImage extends NativeImage {
  static l5r(texSourceBase, width, height) {
    var $this = this.x4c(width, height, texSourceBase, true);
    $this.x5q_1 = texSourceBase;
    $this.y5q_1 = $this.x5q_1;
    var tmp = $this;
    tmp.z5q_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.a5r_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.b5r_1 = Monotonic_instance.kj();
    return $this;
  }
  s3() {
    return 'HtmlNativeImage';
  }
  static i5r(img) {
    return this.l5r(img, img.width, img.height);
  }
  static c5r(canvas) {
    return this.l5r(canvas, canvas.width, canvas.height);
  }
  k5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5q_1;
    lazyCanvasElement$factory();
    return this_0.s1();
  }
  m5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a5r_1;
    ctx$factory();
    return this_0.s1();
  }
  w3z(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.x5q_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.kj();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.b5r_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.b5r_1 = now;
        this.m5r().clearRect(0.0, 0.0, width, height);
        this.m5r().drawImage(this.x5q_1, 0.0, 0.0);
      }
    }
    var idata = this.m5r().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.g3z_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  y3z(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.m5r().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.g3z_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.m5r().putImageData(idata, x, y);
  }
  v46(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.k5r()));
  }
  n5r(type, quality) {
    return this.k5r().toDataURL(type, quality);
  }
  o5r(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.n5r(type, quality) : $super.n5r.call(this, type, quality);
  }
}
class BrowserImage {
  g5r(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd.bind(VOID, this, bytes, props), $completion);
  }
  q5r(img) {
    return this.j5r(img, img.width, img.height);
  }
  j5r(img, width, height) {
    var canvas = HtmlCanvas_instance.h3x(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  h5r(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.s1b();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_10().aw()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.e19();
  }
  p5r(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
    return $super === VOID ? this.h5r(jsUrl, props, $completion) : $super.h5r.call(this, jsUrl, props, $completion);
  }
  d3x(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi.bind(VOID, this, jsUrl), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.t5r_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u5r_1 = this.t5r_1.getContext('2d');
    this.v5r_1 = NaN;
    this.w5r_1 = null;
  }
  d2m() {
    return this.t5r_1.width;
  }
  e2m() {
    return this.t5r_1.height;
  }
  a5s(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.s54_1.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.s54_1.sz(n);
        var color = paint.t54_1.sz(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  y5r(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.a4g_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.l54_1.r3_1) {
            case 0:
              tmp_0 = this.a5s(this.u5r_1.createLinearGradient(_this__u8e3s4.m54_1, _this__u8e3s4.n54_1, _this__u8e3s4.p54_1, _this__u8e3s4.q54_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.a5s(this.u5r_1.createRadialGradient(_this__u8e3s4.m54_1, _this__u8e3s4.n54_1, _this__u8e3s4.o54_1, _this__u8e3s4.p54_1, _this__u8e3s4.q54_1, _this__u8e3s4.r54_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.u5r_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.u5r_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.y54_1), _this__u8e3s4.m54_1, _this__u8e3s4.n54_1);
                tmp_1 = this.a5s(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.n5h_1).y5q_1;
            tmp = this.u5r_1.createPattern(tmp$ret$3, _this__u8e3s4.c5i() && _this__u8e3s4.e5i() ? 'repeat' : _this__u8e3s4.c5i() ? 'repeat-x' : _this__u8e3s4.e5i() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  b5s(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.r3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  c5s(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.r3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.q3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  x5r(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.b5s(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.c5s(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  z5r(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.r2d_1, m.s2d_1, m.t2d_1, m.u2d_1, m.v2d_1, m.w2d_1);
  }
  k5m(image, pos, size, transform) {
    this.u5r_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.u5r_1.setTransform(transform.r2d_1, transform.s2d_1, transform.t2d_1, transform.u2d_1, transform.v2d_1, transform.w2d_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).y5q_1;
      this.u5r_1.drawImage(tmp$ret$2, pos.a2a_1, pos.b2a_1, size.f2b_1, size.g2b_1);
    }finally {
      this.u5r_1.restore();
    }
  }
  d5s(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.w3h_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.k2c(tmp, path.x3h_1.e1(_unary__edvuaz_1));
          var x = destruct.nl();
          var y = destruct.ol();
          this.u5r_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.k2c(tmp_0, path.x3h_1.e1(_unary__edvuaz_3));
          var x_0 = destruct_0.nl();
          var y_0 = destruct_0.ol();
          this.u5r_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.k2c(tmp_1, path.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.k2c(tmp_2, path.x3h_1.e1(_unary__edvuaz_7));
          var cx = destruct_1.nl();
          var cy = destruct_1.ol();
          var ax = destruct_2.nl();
          var ay = destruct_2.ol();
          this.u5r_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.k2c(tmp_3, path.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.k2c(tmp_4, path.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.k2c(tmp_5, path.x3h_1.e1(_unary__edvuaz_13));
          var cx1 = destruct_3.nl();
          var cy1 = destruct_3.ol();
          var cx2 = destruct_4.nl();
          var cy2 = destruct_4.ol();
          var ax_0 = destruct_5.nl();
          var ay_0 = destruct_5.ol();
          this.u5r_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.u5r_1.closePath();
          break;
      }
    }
  }
  b5m(state, fill, winding) {
    if (state.u4i_1.h1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.u5r_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.t4i_1;
        if (!(clip == null)) {
          this.u5r_1.beginPath();
          this.d5s(clip);
          this.u5r_1.clip(this.e5s(winding == null ? clip.y3h_1 : winding));
        }
        this.u5r_1.beginPath();
        this.d5s(state.u4i_1);
        this.z5r(this.u5r_1, state.s4i_1);
        if (fill) {
          transformPaint(this, state.c4j_1);
          this.u5r_1.fill(this.e5s(winding == null ? state.u4i_1.y3h_1 : winding));
        } else {
          transformPaint(this, state.b4j_1);
          var lineDash = state.k4j_1;
          if (!(lineDash == null)) {
            this.u5r_1.lineDashOffset = state.l4j_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.g2p();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.b1();
            while (_iterator__ex2g4s.c1()) {
              var v = _iterator__ex2g4s.d1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.t11(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.u5r_1.setLineDash(tmp$ret$3);
          }
          this.u5r_1.stroke();
        }
        break $l$block;
      }finally {
        this.u5r_1.restore();
      }
    }
  }
  e5s(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.r3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.v2x() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.z3x_1);
  $this.r3x_1 = Companion_instance_0.l3i(width, height);
  $this.x3x_1 = Bitmap32.s3y(width, height, VOID, $this.t3x_1);
  $this.y3x_1.k3();
  $this.y3x_1.h($this.x3x_1);
  $this.a3y_1.k3();
  $this.z3x_1.k3();
  var _iterator__ex2g4s = slices.b1();
  while (_iterator__ex2g4s.c1()) {
    var entry = _iterator__ex2g4s.d1();
    $this.t3y(entry.p3x_1, entry.q3x_1, entry.p3x_1.v3j_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.v3x_1.r3_1) {
    case 0:
      reconstructWithSize($this, imul($this.d2m(), 2), imul($this.e2m(), 2));
      break;
    case 1:
      if (bmp.a3k_1 > $this.d2m() || bmp.b3k_1 > $this.e2m()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.d2m() + 'x' + $this.e2m() + ') to hold a slice of (' + bmp.a3k_1 + 'x' + bmp.b3k_1 + ')';
        throw IllegalStateException.h5(toString_0(message));
      }

      $this.r3x_1 = Companion_instance_0.l3i($this.d2m(), $this.e2m());
      $this.x3x_1 = Bitmap32.s3y($this.d2m(), $this.e2m(), VOID, $this.t3x_1);
      $this.y3x_1.h($this.x3x_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.z3y_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.w3z(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.k3z_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.d3z_1;
  if (false) {
    this_0.m3z();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.v46(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.m1a();
    }
  }finally {
    result = false ? this_0.o3z(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.f3z_1 = true;
  _this__u8e3s4.g3z_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.r3z();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.e47_1.l2j();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.tl(new RGBA($this.e47_1.f47(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_5;
function Companion_getInstance_15() {
  if (Companion_instance_5 === VOID)
    new Companion();
  return Companion_instance_5;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.n48($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).p3y_1);
  var width = _this__u8e3s4.s2a() - _this__u8e3s4.r2a() | 0;
  var inductionVariable = _this__u8e3s4.t2a();
  var last = _this__u8e3s4.u2a();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.u3z(_this__u8e3s4.r2a(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.r2a() + ', top=' + _this__u8e3s4.t2a() + ', right=' + _this__u8e3s4.s2a() + ', bottom=' + _this__u8e3s4.u2a();
        throw IllegalStateException.h5(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.t2a(), area.r2a(), area.u2a(), area.s2a(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.p3y_1;
  var x0Index = _this__u8e3s4.u3z(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.u3z(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.z3y_1 | 0;
      x1Index = x1Index + _this__u8e3s4.z3y_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.u3z(x, areaTop), data, _this__u8e3s4.u3z(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.u3z(x, areaBottom - 1 | 0), data, _this__u8e3s4.u3z(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_6;
function Companion_getInstance_16() {
  return Companion_instance_6;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_7;
function Companion_getInstance_17() {
  BitmapChannel_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_1();
  return Companion_instance_7;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_17();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.s3j_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.a3l();
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.x2i(0, 0, _this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().h3j_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().c2d_1 : padding;
  var left = clamp(bounds.r2a(), 0, _this__u8e3s4.z3y_1);
  var top = clamp(bounds.t2a(), 0, _this__u8e3s4.a3z_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_1.d2i(left, top, clamp(bounds.s2a(), left, _this__u8e3s4.z3y_1), clamp(bounds.u2a(), top, _this__u8e3s4.a3z_1)), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.t3j_1) ? _this__u8e3s4.s3j_1.v2i_1 : _this__u8e3s4.s3j_1.w2i_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.t3j_1) ? _this__u8e3s4.s3j_1.w2i_1 : _this__u8e3s4.s3j_1.v2i_1;
  var tmp = get_container(_this__u8e3s4).u46(w + _this__u8e3s4.u3j_1.k2d() | 0, h + _this__u8e3s4.u3j_1.l2d() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).t46(_this__u8e3s4.t3j_1);
  raw.h46(0, 0, out, _this__u8e3s4.u3j_1.g2d_1, _this__u8e3s4.u3j_1.d2d_1, raw.z3y_1, raw.a3z_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().h3j_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().c2d_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.x2i(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).u46(_this__u8e3s4.s3j_1.v2i_1, _this__u8e3s4.s3j_1.w2i_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).e46(_this__u8e3s4.s3j_1.t2i_1, _this__u8e3s4.s3j_1.u2i_1, out, 0, 0, _this__u8e3s4.s3j_1.v2i_1, _this__u8e3s4.s3j_1.w2i_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_15().h47(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().l40_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_15().h47(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().g40_1)), VOID, 'white');
  }
}
var Companion_instance_8;
function Companion_getInstance_18() {
  return Companion_instance_8;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.k46(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.x3z(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.c4b(x + dx | 0, y + dy | 0) + d < this$0.c4b(x, y)) {
    this$0.y4a(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.z4a(x, y) | 0;
    var y_0 = y - this$0.a4b(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.b4b(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.e4b(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.u3z(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.s3y(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().y4c(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().z4c(width, height, premultiplied);
}
var Companion_instance_9;
function Companion_getInstance_19() {
  if (Companion_instance_9 === VOID)
    Companion_3.o4d();
  return Companion_instance_9;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_15().i47(_this__u8e3s4.z3y_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.a3z_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.f3z_1);
  out.z48(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.o4e();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.h4e_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.h4e_1);
  }
  if (!(effect.k4e_1 === 0) || !(effect.i4e_1 === 0) || !(effect.j4e_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.i4e_1, effect.j4e_1, effect.k4e_1, effect.l4e_1);
  }
  if (!(effect.m4e_1 === 0)) {
    borderInline(_this__u8e3s4, effect.m4e_1, effect.n4e_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.z3y_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.a3z_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.z49(_this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1);
  var t2 = Bitmap8.z49(_this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_17().e1(n);
      _this__u8e3s4.d49(channel, t1);
      arraycopy_0(t1.l48(), 0, t2.l48(), 0, t2.l2j());
      gaussBlur(t1.l48(), t2.l48(), _this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1, r_0);
      _this__u8e3s4.c49(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.z49(_this__u8e3s4.z3y_1 + imul(r, 2) | 0, _this__u8e3s4.a3z_1 + imul(r, 2) | 0);
  Companion_instance_6.g4a(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.z3y_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.a3z_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.z49(_this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1);
  arraycopy_0(_this__u8e3s4.l48(), 0, t2.l48(), 0, _this__u8e3s4.l2j());
  gaussBlur(t2.l48(), _this__u8e3s4.l48(), _this__u8e3s4.z3y_1, _this__u8e3s4.a3z_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().h40_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.a3z_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.z3y_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.c4b(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.o48(x, y, Companion_getInstance_22().p4e(rcolor, out.p48(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().h40_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.uz();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.e49(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.f3z_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.f48_1, n, Companion_getInstance_22().q4e(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.l3z();
  _this__u8e3s4.x48(Colors_getInstance().l40_1);
  _this__u8e3s4.a49(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.a49(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.a4f()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.a4f());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_22().q4e(_this__u8e3s4.b4f(c), _this__u8e3s4.c4f(c), _this__u8e3s4.d4f(c), _this__u8e3s4.e4f(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.a4f() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_10;
function Companion_getInstance_20() {
  if (Companion_instance_10 === VOID)
    new Companion_4();
  return Companion_instance_10;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_21() {
  return Companion_instance_11;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__contains_impl_ofn00n_0($this, element) {
  if (!(element instanceof RGBA))
    return false;
  return RgbaArray__contains_impl_ofn00n($this.g4g_1, element instanceof RGBA ? element.a4g_1 : THROW_CCE());
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.h1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.a4g_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.g4g_1, elements);
}
function RgbaArray__indexOf_impl_d6b5pl($this, element) {
  return indexOf(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__indexOf_impl_d6b5pl_0($this, element) {
  if (!(element instanceof RGBA))
    return -1;
  return RgbaArray__indexOf_impl_d6b5pl($this.g4g_1, element instanceof RGBA ? element.a4g_1 : THROW_CCE());
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.g4g_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.g4g_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.gc(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.cc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.gc(7);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.cc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.a4g_1, other instanceof RGBA ? other.a4g_1 : THROW_CCE());
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
var Companion_instance_12;
function Companion_getInstance_22() {
  if (Companion_instance_12 === VOID)
    new Companion_6();
  return Companion_instance_12;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.a4g_1 : THROW_CCE())))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().l40_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_22();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.q4e(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_14;
function Companion_getInstance_24() {
  return Companion_instance_14;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.x4g_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_13.v4g(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.b4h_1).l3z();
  };
}
var Companion_instance_16;
function Companion_getInstance_26() {
  return Companion_instance_16;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.x4j_1;
    var baseline = 0.0;
    var tmp = -this$0.c4k_1;
    var tmp_0 = -this$0.c4k_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.y4j_1.l3().b1();
    while (_iterator__ex2g4s.c1()) {
      var glyph = _iterator__ex2g4s.d1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.b4h_1.a3k_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.v4j_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.y4j_1.e1(this$0.y4j_1.g3().b1().d1());
    return tmp0_elvis_lhs == null ? this$0.h4k() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.v4j_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.q28(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.t8();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo.bind(VOID, _this__u8e3s4, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.hi('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.w13('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.hi('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.w13('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.hi('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.w13('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.hi('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.x13('fieldType');
  var _iterator__ex2g4s = get(xml.hi('pages'), 'page').b1();
  while (_iterator__ex2g4s.c1()) {
    var page = _iterator__ex2g4s.d1();
    var id = page.t13('id');
    var file = page.v13('file');
    var texFile = fntFile.k28().hi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.h3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.hi('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.t13('page');
    var tmp0_elvis_lhs_0 = textures.f3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first(textures.l3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.t13('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.i3l(item.t13('x'), item.t13('y'), item.t13('width'), item.t13('height'));
      tmp_1 = atlas.p3z(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.p3x_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.i3l(item.t13('x'), item.t13('y'), item.t13('width'), item.t13('height')) : tmp1_elvis_lhs_0, item.t13('xoffset'), item.t13('yoffset'), item.t13('xadvance'));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.hi('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.b1();
  while (tmp0_iterator_0.c1()) {
    var item_0 = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.t13('first'), item_0.t13('second'), item_0.t13('amount'));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.b1();
  while (tmp0_iterator_1.c1()) {
    var item_1 = tmp0_iterator_1.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.a4h_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.b1();
  while (tmp0_iterator_2.c1()) {
    var item_2 = tmp0_iterator_2.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.y4g(item_2.h4h_1, item_2.i4h_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_12().e11(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.f1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.e1(n).n31_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.k28().hi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.h3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.n31_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.f3(page_0);
    var texture = tmp0_elvis_lhs == null ? first(textures.l3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.i3l(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.p3z(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.p3x_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.i3l(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.b1();
  while (tmp0_iterator_0.c1()) {
    var item_0 = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.n31_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.b1();
  while (tmp0_iterator_1.c1()) {
    var item_1 = tmp0_iterator_1.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.a4h_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.b1();
  while (tmp0_iterator_2.c1()) {
    var item_2 = tmp0_iterator_2.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.y4g(item_2.h4h_1, item_2.i4h_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.j1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.j1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).b1();
  while (_iterator__ex2g4s.c1()) {
    var rline = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.oc();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).b1();
    while (_iterator__ex2g4s_0.c1()) {
      var part = _iterator__ex2g4s_0.d1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.e1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.e1(1);
      // Inline function 'kotlin.collections.set' call
      map.h3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.f3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.f3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.f3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.h5(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.k28().hi(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice(mipmaps(tmp_0, mipmaps_0));
      textures.h3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.f3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.f3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.f3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.f3(page);
      var texture = tmp5_elvis_lhs == null ? first(textures.l3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.i3l(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.p3z(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.p3x_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.i3l(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.h(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.f3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.f3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.f3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.h(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.pc(capacity);
  var tmp0_iterator = glyphs.b1();
  while (tmp0_iterator.c1()) {
    var element_1 = tmp0_iterator.d1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.a4h_1;
    destination.h3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_15.y4g(it.h4h_1, it.i4h_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.k4h();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.s4h();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.r4h();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.h4k();
  }, null);
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.kj();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.w4m(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.lr_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_13());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.f4i(size);
  var gmetrics = _this__u8e3s4.o4i(size, codePoint, VOID, reader);
  var gx = -gmetrics.r2a();
  var gy = gmetrics.e2m() + gmetrics.t2a();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.d2m()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.e2m()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.s3y(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.d3z_1;
  if (true) {
    image.m3z();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.v46(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.m1a();
    }
  }finally {
    result = true ? image.o3z(rect) : 0;
  }
  var imageOut = applyEffect(image.w46(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.k2c(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_5().m2d_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.n4n();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.z3h_1 = false;
    this_0.z3q(this$0.q4n_1.r2a(), -this$0.r4n_1.x4h_1, this$0.q4n_1.m4i_1, this$0.r4n_1.m4h());
    return applyTransform(this_0, Companion_getInstance_5().p2d().q2e(this$0.p4n_1).x2e(this$0.s4n_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.z4n());
    var tmp;
    if (!(curves.n3d_1.f1() === 4)) {
      println('curves=' + curves.n3d_1.f1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.a4o().n3d_1.e1(3).j3h();
    var tmp$ret$0 = Line2D.t2c(this_0.s2c_1, this_0.r2c_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.a4o().n3d_1.e1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_6().c2a_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_46().p4o_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.f4p();
  }
  invoke(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.d4o_1 = glyphs.g4p_1;
    outMetrics.e4o_1 = glyphs.h4p_1;
    var fmetrics = _this__u8e3s4.f4i(size);
    outMetrics.b4o_1 = fmetrics;
    var metrics = outMetrics.c4o_1;
    metrics.k4p_1.m4p(fmetrics);
    metrics.l4p_1 = glyphs.h4p_1.f1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.h4p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_7().a2b();
      var _iterator__ex2g4s = item.b1();
      while (_iterator__ex2g4s.c1()) {
        var g = _iterator__ex2g4s.d1();
        bb = plus_1(bb, g.z4n());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.h(tmp$ret$0);
    }
    tmp_1.j4p_1 = destination;
    metrics.i4p_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_7().a2b(), metrics.j4p_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_46().l4o_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.u4h(size, out.k4p_1);
  out.l4p_1 = actions.c4q();
  var bb = Companion_getInstance_7().a2b();
  var dy = 0.0;
  var lineBounds = FastArrayList.q10();
  var offsetY = actions.g4q(align.e4q_1, out.k4p_1);
  var _iterator__ex2g4s = actions.a4q_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var line = _iterator__ex2g4s.d1();
    var offsetX = line.k4q(align.d4q_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.l4q(), line.i4q_1, line.h4q_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.h(rect);
    dy = dy + line.h4q_1;
  }
  out.j4p_1 = lineBounds;
  out.i4p_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.p4j($paint);
  font.s4j(_this__u8e3s4, $size, $codePoint, Vector2D.k2c(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.o4q();
  } else {
    _this__u8e3s4.n4q();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.p4q_1;
        var strokeInfo = stroke == null ? null : stroke.q4q_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.r4q(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.c3c_1;
              var lineCap = strokeInfo.f3c_1;
              var lineJoin = strokeInfo.h3c_1;
              var miterLimit = strokeInfo.i3c_1;
              var lineDash = strokeInfo.j3c_1;
              var lineDashOffset = strokeInfo.k3c_1;
              if (false) {
                tmp67_safe_receiver.f4p();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.y4q();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.z4q(numberToDouble(lineWidth));
                tmp67_safe_receiver.a4r(lineCap);
                tmp67_safe_receiver.b4r(lineJoin);
                tmp67_safe_receiver.c4r(numberToDouble(miterLimit));
                tmp67_safe_receiver.d4r(lineDash);
                tmp67_safe_receiver.e4r(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.f4r(stroke_0);
              }finally {
                tmp67_safe_receiver.g4r();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.s4q();
            var lineCap_0 = tmp67_safe_receiver.t4q();
            var lineJoin_0 = tmp67_safe_receiver.u4q();
            var miterLimit_0 = tmp67_safe_receiver.v4q();
            var lineDash_0 = tmp67_safe_receiver.w4q();
            var lineDashOffset_0 = tmp67_safe_receiver.x4q();
            if (false) {
              tmp67_safe_receiver.f4p();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.y4q();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.z4q(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.a4r(lineCap_0);
              tmp67_safe_receiver.b4r(lineJoin_0);
              tmp67_safe_receiver.c4r(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.d4r(lineDash_0);
              tmp67_safe_receiver.e4r(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.f4r(stroke_0);
            }finally {
              tmp67_safe_receiver.g4r();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.o4q();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.n4q();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.f4p();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.z4n();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.a4o();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.m28(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77.bind(VOID, _this__u8e3s4, preload, props, mipmaps), $completion);
}
var SystemFontRegistryOrNull;
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_17;
function Companion_getInstance_27() {
  if (Companion_instance_17 === VOID)
    new Companion_11();
  return Companion_instance_17;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.u4t_1.e1(this$0.u4t_1.g3().b1().d1());
    return tmp0_elvis_lhs == null ? this$0.h4k() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.o4t_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.r4t_1.z4h_1 - this$0.r4t_1.b4i_1;
    var tmp78_size = this$0.r4t_1.v4h_1;
    var tmp79_top = this$0.r4t_1.w4h_1;
    var tmp80_ascent = this$0.r4t_1.x4h_1;
    var tmp81_baseline = this$0.r4t_1.y4h_1;
    var tmp82_maxWidth = this$0.r4t_1.c4i_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.r4h();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.h4k();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.s4h();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_18;
function Companion_getInstance_28() {
  Op_initEntries();
  if (Companion_instance_18 === VOID)
    new Companion_12();
  return Companion_instance_18;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_28();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_19;
function Companion_getInstance_29() {
  Op_initEntries_0();
  if (Companion_instance_19 === VOID)
    new Companion_13();
  return Companion_instance_19;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_29();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_20;
function Companion_getInstance_30() {
  if (Companion_instance_20 === VOID)
    new Companion_14();
  return Companion_instance_20;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.r51_1;
  ss$factory();
  return this_0.s1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.q51_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.k1s($table.o51_1, $table.p51_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_21;
function Companion_getInstance_31() {
  return Companion_instance_21;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_22;
function Companion_getInstance_32() {
  Colrv1Paint_initEntries();
  if (Companion_instance_22 === VOID)
    new Companion_16();
  return Companion_instance_22;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_32();
}
var Companion_instance_23;
function Companion_getInstance_33() {
  return Companion_instance_23;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_24;
function Companion_getInstance_34() {
  return Companion_instance_24;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.n28($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.w4m(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd.bind(VOID, _this__u8e3s4, onlyReadMetadata, enableLigatures), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_25;
function Companion_getInstance_35() {
  DataFormat_initEntries();
  if (Companion_instance_25 === VOID)
    new Companion_19();
  return Companion_instance_25;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_35();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString(s, 2, Charsets_instance.lx(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.h5(toString_0(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.s59_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.y2x(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.g1v_1.j2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_35();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.e1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.s59_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.x2x(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.q59_1(nComponent);
          this_1.y2x(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact(s, dataFormat.q59_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.s59_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.x2x(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.y2x(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().h3j_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_0().l3j_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_0().j3j_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_0().n3j_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_0().o3j_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_0().i3j_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_0().m3j_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_0().k3j_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().h3j_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.jv());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.jv());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.w59_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.w59_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_26;
function Companion_getInstance_36() {
  return Companion_instance_26;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.y5a()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.x5a().z3y_1, b.x5a().a3z_1), imul(b.x5a().b3z_1, b.x5a().b3z_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.y5a()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.x5a().z3y_1, a.x5a().a3z_1), imul(a.x5a().b3z_1, a.x5a().b3z_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var Companion_instance_27;
function Companion_getInstance_37() {
  return Companion_instance_27;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.n5b_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.g5b_1;
      destination.h3(tmp$ret$0, element);
    }
    return destination;
  };
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.q5b().f3(null);
    return tmp0_elvis_lhs == null ? first_0(this$0.n5b_1) : tmp0_elvis_lhs;
  };
}
function imageDatasByName$factory() {
  return getPropertyCallableRef('imageDatasByName', 1, KProperty1, function (receiver) {
    return receiver.q5b();
  }, null);
}
function default$factory() {
  return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
    return receiver.r5b();
  }, null);
}
var tilesetBorder$delegate;
var Companion_instance_28;
function Companion_getInstance_38() {
  if (Companion_instance_28 === VOID)
    new Companion_22();
  return Companion_instance_28;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.k5c(tmp, props.i5c(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.h5c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.e5c();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.j1();
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.g5d();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.f5d();
  }, function (receiver, value) {
    return receiver.e5d(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.f5d();
  }, function (receiver, value) {
    return receiver.e5d(value);
  });
}
var Companion_instance_29;
function Companion_getInstance_39() {
  return Companion_instance_29;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_30;
function Companion_getInstance_40() {
  Type_initEntries();
  if (Companion_instance_30 === VOID)
    new Companion_24();
  return Companion_instance_30;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_40();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.q3j_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.q3j_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.q3j_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.q3j_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.e5c(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.w3y(result.w46(), Unit_instance, name).p3x_1 : slice(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr.bind(VOID, _this__u8e3s4, bprops, name, atlas), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  var prop = !(file == null) ? props.i5c(file) : props;
  var rformats = !prop.a5c_1 ? listOf_0(prop.b5c_1) : prop.b5c_1 == null ? listOf_0(null) : prop.z5b_1 ? listOf([prop.b5c_1, null]) : listOf([null, prop.b5c_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.b1();
  while (_iterator__ex2g4s.c1()) {
    var format = _iterator__ex2g4s.d1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.w5c(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.x5c(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.be();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.w5b_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.x2x(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.y2x(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_38().i4k_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g.bind(VOID, file, bytes, props), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.e5c(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr.bind(VOID, _this__u8e3s4, props), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_14().ey('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, data, props, $completion) {
  if (props.w5b_1 || props.v5b_1 === false) {
    return $this.w5d(get_RegisteredImageFormats().v5c(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.x5d(toBitmap(tmp), props);
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  if (props.w5b_1 || props.v5b_1 === false) {
    return $this.w5d(get_RegisteredImageFormats().v5c(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  return $this.w5d($this.s5e(image, props), props);
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp = vfs.z27(path).o28($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.y5d(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp = $this.y5d(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.x5e_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.r5e(file.d26(), file.j26(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.x5e_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.v5e(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function toBitmap(_this__u8e3s4) {
  return toBitmap_0(_this__u8e3s4.a3x());
}
function toBitmap_0(_this__u8e3s4) {
  return Bitmap32.s3y(_this__u8e3s4.v3w_1, _this__u8e3s4.w3w_1, _this__u8e3s4.x3w_1, _this__u8e3s4.y3w_1);
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_31;
function Companion_getInstance_41() {
  Colorspace_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_25();
  return Companion_instance_31;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_41();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.pu();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.o5f_1;
  var height = header.p5f_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.v5f_1);
  var databb = uncompress(pngdata.uu(), Companion_getInstance_13());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.x5f_1.v5f_1;
  var row32 = context.a5g_1;
  var tmp_2;
  if (header.v5f_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var it = item;
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_22().q4e(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.h(tmp$ret$1);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.z49(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
  } else {
    tmp_2 = Bitmap32.s3y(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.u5f_1 === 1 ? $this.g5g_1 : $this.h5g_1;
  var _iterator__ex2g4s = passes.b1();
  while (_iterator__ex2g4s.c1()) {
    var pass = _iterator__ex2g4s.d1();
    var progression = step(until(pass.h5f_1, height), pass.j5f_1);
    var inductionVariable_0 = progression.b2_1;
    var last_0 = progression.c2_1;
    var step_0 = progression.d2_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.i5f_1;
        var colIncrement = pass.k5f_1;
        var pixelsInThisRow = width >>> pass.n5f_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.v5f_1), header.q5f_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.z5f_1;
        var lastRow = context.y5f_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.j5g(filter, lastRow, currentRow, header.v5f_1);
          switch (header.q5f_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.d40(x, y, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.d40(x_0, y_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.d40(x_1, y_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.o4a(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.q5f_1;
              throw IllegalStateException.h5(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.q5f_1 === 8) {
            $this.i5g(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_20(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_22(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.be('An operation is not implemented: ' + reason);
            }
            bmp32.f4a(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.q5f_1;
            throw IllegalStateException.h5(toString_0(message_0));
          }
        }
        context.k5g();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_41().g5f_1.f3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.q5c_1 = this_0.o5f_1;
      $info.r5c_1 = this_0.p5f_1;
      $info.s5c_1 = imul(this_0.q5f_1, this_0.r5f_1.f5f_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().j2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.y15(asByteArray(rgbPalette), 0, data.a().j2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().j2();
      paletteCount._v = Math.max(a_0, b_0);
      data.y15(asByteArray(aPalette), 0, data.a().j2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.su(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.n5g();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.n5d([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_32;
function Companion_getInstance_42() {
  return Companion_instance_32;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.x5g_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.w5g_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.i5h_1 = value;
  $this.e5h_1 = $this.i5h_1.z3y_1;
  $this.f5h_1 = $this.i5h_1.a3z_1;
  $this.g5h_1 = 1.0 / $this.e5h_1;
  $this.h5h_1 = 1.0 / $this.f5h_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.q5g(_this__u8e3s4.a4g_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.y5g(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.m5h(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.be();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.f1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().i42_1 : _RGBA___init__impl__lqpay5(colors.qk());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.qk()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.sz(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.sz(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_22().r4g(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.z2o()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.e1(n) * NCOLORS);
}
var Companion_instance_33;
function Companion_getInstance_43() {
  return Companion_instance_33;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.d2p()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.a4g_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().h40_1;
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_44().k5i_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_34;
function Companion_getInstance_44() {
  if (Companion_instance_34 === VOID)
    new Companion_28();
  return Companion_instance_34;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_44().k5i_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_44().k5i_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.w4h_1, font.w4h_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_44().h5i_1) ? 'TOP' : equals($this, Companion_getInstance_44().i5i_1) ? 'MIDDLE' : equals($this, Companion_getInstance_44().j5i_1) ? 'BOTTOM' : equals($this, Companion_getInstance_44().k5i_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.n5i_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_45().o5i_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_35;
function Companion_getInstance_45() {
  if (Companion_instance_35 === VOID)
    new Companion_29();
  return Companion_instance_35;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_45().o5i_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_45().p5i_1) ? 'LEFT' : equals($this, Companion_getInstance_45().q5i_1) ? 'CENTER' : equals($this, Companion_getInstance_45().r5i_1) ? 'RIGHT' : equals($this, Companion_getInstance_45().o5i_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.u5i_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_36;
function Companion_getInstance_46() {
  if (Companion_instance_36 === VOID)
    new Companion_30();
  return Companion_instance_36;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.vy().a2a_1 + $this.r4s().e2e(x, y);
  var ry = $this.vy().b2a_1 + $this.r4s().h2e(x, y);
  $this.y4p_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.y4p_1, Vector2D.k2c(rx, ry));
  if ($this.z4p_1 === 0) {
    $this.x4p_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.x4p_1, Vector2D.k2c(rx, ry));
  }
  var _receiver__tnumb7 = $this.b4q_1;
  _receiver__tnumb7.j4q_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.j4q_1, Vector2D.k2c(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.r2a();
  var fy = rect.t2a();
  var w = rect.m2a_1;
  var h = rect.n2a_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.x5i(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.d4s(text, c);
  $this$CreateWStringTextRenderer.z4s(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.d4s(text, c);
  $this$CreateStringTextRenderer.z4s(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.g5l_1.u5l_1.l2c()) {
    this$0.g5l_1.s5l_1 = this$0.e5l_1 ? 4 : 1;
    this$0.k5l_1.q5k_1 = filler;
    this$0.k5l_1.z5k_1 = $state.i4j_1;
    this$0.k5l_1.p2u();
    var tmp = $winding == null ? fillPath.y3h_1 : $winding;
    this$0.g5l_1.a5m(this$0.f5l_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.k5l_1.yc();
    this$0.g5l_1.u5l_1.p2u();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.k5l_1.o5l(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.x4g_1, dstN, src.x4g_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_37;
function Companion_getInstance_47() {
  if (Companion_instance_37 === VOID)
    new Companion_31();
  return Companion_instance_37;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_38;
function Companion_getInstance_48() {
  return Companion_instance_38;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.x4g_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.x4g_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.x4g_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.x4g_1, dstN, dst.x4g_1, dstN, src.x4g_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.x4g_1, dstN, src.x4g_1, srcN, dst.x4g_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_47();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.n5m(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_47().m5m_1);
  var tmp_0 = Companion_getInstance_47();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.n5m(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_47();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.n5m(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_47().m5m_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_47().m5m_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_47().m5m_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_47().m5m_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_47().m5m_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_47().m5m_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_47().m5m_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_47().m5m_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_38.g3r();
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.s4i_1.z2e();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.a47_1.s4i_1;
    if (this_0.p2a()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.w3h_1;
  var n_0 = 0;
  while (n_0 < this_0.f1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.sz(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.x3h_1.e1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2c(tmp, path.x3h_1.e1(_unary__edvuaz_1));
        _this__u8e3s4.t3h(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.x3h_1.e1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2c(tmp_0, path.x3h_1.e1(_unary__edvuaz_3));
        _this__u8e3s4.g3i(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.x3h_1.e1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.k2c(tmp_1, path.x3h_1.e1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.x3h_1.e1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.k2c(tmp_2, path.x3h_1.e1(_unary__edvuaz_7));
        _this__u8e3s4.h3i(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.x3h_1.e1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.k2c(tmp_3, path.x3h_1.e1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.x3h_1.e1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.k2c(tmp_4, path.x3h_1.e1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.x3h_1.e1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.k2c(tmp_5, path.x3h_1.e1(_unary__edvuaz_13));
        _this__u8e3s4.u3h(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.n6();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_7().a2b();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.u4i_1.k3e());
  var tmp = bb;
  var tmp333_safe_receiver = state.t4i_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.k3e());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).a2j(state.s4i_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.s3y(toIntCeil_0(bounds.m2a_1), toIntCeil_0(bounds.n2a_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.u5g(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_5().p2d().s2e(-bounds.r2a(), -bounds.t2a()));
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.r5m();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_39;
function Companion_getInstance_49() {
  CycleMethod_initEntries();
  if (Companion_instance_39 === VOID)
    new Companion_33();
  return Companion_instance_39;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_49();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.r3_1, 0), y.r3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_49().u5n_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_49().u5n_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.k2c(_CycleMethodPair___get_x__impl__dgz5uj($this).v5n(ratio.a2a_1), _CycleMethodPair___get_y__impl__fcnb7o($this).v5n(ratio.b2a_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.l59(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.l59(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.z3y_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.a3z_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.u3z(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.v4b(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.w4b(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.x4b(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.y4b(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.z4b(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.g4c(-1.0);
  msdf_0.i4c(-1.0, +1.0);
  msdf_0.f4c();
  var msdfBitmap = msdf_0.l3z();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.y4e(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).l3z(), VOID, 0);
  return newImage.r4e_1.w46();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.t4b(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.v2c();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.n3d_1, item.o3d_1);
    destination.h(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.j1();
  var tmp0_iterator_0 = colorizedCurves.b1();
  while (tmp0_iterator_0.c1()) {
    var element = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.w5n_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.a3z_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.z3y_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.k2c(x + 0.5, y + 0.5);
          var inside = path.j3r(p);
          var allDist = allColorizedCurves.e5o().i5o(p);
          var redDist = allColorizedCurves.j5o().i5o(p);
          var greenDist = allColorizedCurves.k5o().i5o(p);
          var blueDist = allColorizedCurves.l5o().i5o(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.z4b(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.w5n_1;
    var destination = ArrayList.j1();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.n5o_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.w5n_1;
    var destination = ArrayList.j1();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.n5o_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.w5n_1;
    var destination = ArrayList.j1();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.n5o_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.w5n_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.m5o_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.o5o();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.m5o_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.p5o();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.m5o_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.q5o();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.m5o_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.f1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.h(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().g40_1;
  if (index === 0)
    return Colors_getInstance().i42_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().w45_1 : Colors_getInstance().g41_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().g40_1);
    if (true) {
      $this$NativeImageContext2d.f4p();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.p5n(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.o5o();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.p5o();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.q5o();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.e5o();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.j5o();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.k5o();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.l5o();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.j1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.w3h_1;
  var n_0 = 0;
  while (n_0 < this_1.f1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.sz(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.k2c(tmp, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_1));
        var x = destruct.nl();
        var y = destruct.ol();
        this_0.h('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.k2c(tmp_0, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_3));
        var x_0 = destruct_0.nl();
        var y_0 = destruct_0.ol();
        this_0.h('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.k2c(tmp_1, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.k2c(tmp_2, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_7));
        var cx = destruct_1.nl();
        var cy = destruct_1.ol();
        var ax = destruct_2.nl();
        var ay = destruct_2.ol();
        this_0.h('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.k2c(tmp_3, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.k2c(tmp_4, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.k2c(tmp_5, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_13));
        var cx1 = destruct_3.nl();
        var cy1 = destruct_3.ol();
        var cx2 = destruct_4.nl();
        var cy2 = destruct_4.ol();
        var ax_0 = destruct_5.nl();
        var ay_0 = destruct_5.ol();
        this_0.h('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.h('close()');
        break;
    }
  }
  var this_2 = this_0.g8();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.h(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.t5o_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp351_safe_receiver = this$0.u5o_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.g5p(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.h5p_1, this$0.l5p_1), this$0.i5p_1, this$0.j5p_1, this$0.k5p_1, this$0.m5p_1);
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.b5p();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.c5p();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.c3c_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.e3c_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.f3c_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.g3c_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.h3c_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.i3c_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.j3c_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.k3c_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.y5p();
  }, null);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.r5l_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.y3q($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_40;
function Companion_getInstance_50() {
  if (Companion_instance_40 === VOID)
    new Companion_34();
  return Companion_instance_40;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.c5r(HtmlImage_instance.i5q(_this__u8e3s4.l3z()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_2($this, data, props, $completion) {
  var tmp = BrowserImage_instance.g5r(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.c5r(tmp));
}
function *_generator_decodeInternal__jnwsgt_3($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.h5r(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.i5r(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.a29(path);
      var tmp_1 = BrowserImage_instance.h5r(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.i5r(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.hi(path).n28($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.g5r(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.c5r(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.y5q_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.y5q_1;
      tmp = tmp_0.j5r(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.y5q_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.y5q_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.k5r().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_10().aw()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.h5(toString_0(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.d3x(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.p5r(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.q5r(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.bd(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.wa('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.bd(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.s3()) == $this.w5r_1) {
    tmp = fontSize === $this.v5r_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.w5r_1 = font == null ? null : font.s3();
  $this.v5r_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.s3();
  $this.u5r_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.u5r_1.globalAlpha = state.i4j_1;
  $this.u5r_1.globalCompositeOperation = $this.x5r(state.j4j_1);
  if (doSetFont) {
    setFont($this, state.e4j_1, state.f4j_1);
  }
  if (fill) {
    $this.u5r_1.fillStyle = $this.y5r(state.c4j_1);
  } else {
    $this.u5r_1.lineWidth = state.w4i_1;
    var tmp;
    switch (state.z4i_1.r3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.u5r_1.lineJoin = tmp;
    var tmp_0;
    switch (state.t4q().r3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.u5r_1.lineCap = tmp_0;
    $this.u5r_1.strokeStyle = $this.y5r(state.b4j_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.z5r($this.u5r_1, paint.r4s());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.k5r();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.m5r();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_10().bw() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_10().aw() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [1];
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$2)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.v3y);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).q4h = get_baseBmp;
protoOf(BitmapFontImpl).u4h = getFontMetrics;
protoOf(BitmapFontImpl).f4i = getFontMetrics$default;
protoOf(BitmapFontImpl).g4i = getGlyphMetrics;
protoOf(BitmapFontImpl).o4i = getGlyphMetrics$default;
protoOf(BitmapFontImpl).t4j = getKerning;
protoOf(BitmapFontImpl).q4i = getTextScale;
protoOf(BitmapFontImpl).e1 = get_0;
protoOf(BitmapFontImpl).r4i = renderGlyph;
protoOf(BitmapFontImpl).s4j = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).p2u = reset;
protoOf(TextRendererActions).z4s = advance;
protoOf(TextRendererActions).a4t = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_11);
protoOf(LazyBitmapFont).q4h = get_baseBmp;
protoOf(LazyBitmapFont).u4h = getFontMetrics;
protoOf(LazyBitmapFont).f4i = getFontMetrics$default;
protoOf(LazyBitmapFont).g4i = getGlyphMetrics;
protoOf(LazyBitmapFont).o4i = getGlyphMetrics$default;
protoOf(LazyBitmapFont).t4j = getKerning;
protoOf(LazyBitmapFont).q4i = getTextScale;
protoOf(LazyBitmapFont).b11 = getOrNull_2;
protoOf(LazyBitmapFont).e1 = get_0;
protoOf(LazyBitmapFont).r4i = renderGlyph;
protoOf(LazyBitmapFont).s4j = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_12);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.s4v, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_13);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_14, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).f4i = getFontMetrics$default;
protoOf(BaseTtfFont).o4i = getGlyphMetrics$default;
protoOf(BaseTtfFont).o4z = getGlyphPath$default;
protoOf(BaseTtfFont).r4i = renderGlyph_0;
protoOf(BaseTtfFont).s4j = renderGlyph$default;
protoOf(BaseTtfFont).b11 = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_15);
initMetadataForCompanion(Companion_16);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_17);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).u56 = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).u56 = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).b3r = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_18);
initMetadataForCompanion(Companion_19);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_20);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_21);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_22);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.m5d, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_24);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_25);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_26);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_27);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_28);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_29);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_30);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_0, 'Entry', Entry_0);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_31);
initMetadataForCompanion(Companion_32);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).k3o = moveTo;
protoOf(Context2d).l3o = lineTo;
protoOf(Context2d).w3q = line;
protoOf(Context2d).h1 = isEmpty;
protoOf(Context2d).x3q = rect;
protoOf(Context2d).y3q = rect_0;
protoOf(Context2d).z3q = rect_1;
protoOf(Context2d).a3r = arc;
protoOf(Context2d).b3r = arc$default;
protoOf(Context2d).c3r = circle;
protoOf(Context2d).d3r = rMoveTo;
protoOf(Context2d).e3r = rLineTo;
protoOf(Context2d).a2j = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_33);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).s5o = getBounds;
protoOf(FillShape).r5o = getPath_0;
protoOf(FillShape).c4u = getPath$default;
protoOf(FillShape).j4t = draw;
protoOf(FillShape).d57 = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).c4u = getPath$default;
protoOf(CompoundShape).d57 = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).r5o = getPath_0;
protoOf(PolylineShape).c4u = getPath$default;
protoOf(PolylineShape).j4t = draw;
protoOf(PolylineShape).d57 = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).r5o = getPath;
protoOf(EmptyShape).c4u = getPath$default;
protoOf(EmptyShape).d57 = get_bounds;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_34);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_6 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_8 = new Companion_2();
NewSDF_instance = new NewSDF();
Companion_instance_11 = new Companion_5();
Companion_instance_13 = new Companion_7();
Companion_instance_14 = new Companion_8();
Companion_instance_15 = new Companion_9();
Companion_instance_16 = new Companion_10();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_21 = new Companion_15();
Companion_instance_23 = new Companion_17();
Companion_instance_24 = new Companion_18();
Companion_instance_26 = new Companion_20();
Companion_instance_27 = new Companion_21();
Companion_instance_29 = new Companion_23();
WEBP_WASM_BASE64_ZLIB = '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';
Companion_instance_32 = new Companion_26();
Companion_instance_33 = new Companion_27();
NonePaint_instance = new NonePaint();
Companion_instance_38 = new Companion_32();
EmptyShape_instance = new EmptyShape();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  readFont as readFont34z4s2654u5hd,
  readTtfFont as readTtfFont159as20nksus9,
  readBitmapSlice as readBitmapSlice2r7knpwifec2u,
  readBitmap_0 as readBitmap1yhww5yoq3a9l,
  readBitmap as readBitmapdk80pcjw6p8f,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3fdqajvftucv7,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf629uhw1oxrapg6,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmis57bfwjkwav,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqtysv8goadjy9q,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2tumn1mea41fm,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8vehpblbe3f2y8,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao1ojb8pkalp2nb,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq,
  Bitmaps_instance as Bitmaps_instance27726euemn90u,
  Colors_getInstance as Colors_getInstance2cnv7p5d6jz4u,
  Companion_getInstance_22 as Companion_getInstance2ou2xyvohty1g,
  Companion_instance_16 as Companion_instance1zw3l6m7tnvps,
  Companion_instance_15 as Companion_instance1sgltfeqg9bxt,
  Companion_getInstance_46 as Companion_getInstancezw1wxvwtmh0g,
  Companion_getInstance_44 as Companion_getInstance2w9pdpq8h2ue0,
  EmptyShape_instance as EmptyShape_instance1905h5dvjxi3r,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFont as get_DefaultTtfFontddovg6zy24ck,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  Entry_0 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  invoke as invoke2ot88cm6qcfmr,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
